import { Accordion as e } from "@base-ui/react/accordion";
import { ArrowDown as t, ArrowDownIcon as n, ArrowLeft as r, ArrowRight as i, ArrowUp as a, ArrowUpRightIcon as o, CheckIcon as s, ChevronDownIcon as c, ChevronLeft as l, ChevronRight as u, ChevronRightIcon as d, ChevronUpIcon as f, CircleArrowRightIcon as p, CircleCheckIcon as m, CircleDashedIcon as h, CircleXIcon as g, InfoIcon as _, ListIcon as v, Loader2Icon as y, MoreHorizontal as b, SearchIcon as x, TriangleAlertIcon as S, XIcon as C } from "lucide-react";
import * as w from "react";
import { createElement as T, forwardRef as E, useCallback as D, useMemo as O, useState as k } from "react";
import { clsx as A } from "clsx";
import { extendTailwindMerge as j } from "tailwind-merge";
import { Fragment as M, jsx as N, jsxs as P } from "react/jsx-runtime";
import { AlertDialog as F } from "@base-ui/react/alert-dialog";
import { Autocomplete as I } from "@base-ui/react/autocomplete";
import { Button as ee } from "@base-ui/react/button";
import { cva as L } from "class-variance-authority";
import { NumberField as R } from "@base-ui/react/number-field";
import { Input as te } from "@base-ui/react/input";
import { mergeProps as z } from "@base-ui/react/merge-props";
import { useRender as B } from "@base-ui/react/use-render";
import { Separator as ne } from "@base-ui/react/separator";
import { Avatar as re } from "@base-ui/react/avatar";
import { Collapsible as V } from "@base-ui/react/collapsible";
import { Toggle as H } from "@base-ui/react/toggle";
import { Toolbar as ie } from "@base-ui/react/toolbar";
import { Tooltip as U } from "@base-ui/react/tooltip";
import { Checkbox as ae } from "@base-ui/react/checkbox";
import { Combobox as W } from "@base-ui/react";
import { ContextMenu as G } from "@base-ui/react/context-menu";
import { Radio as oe } from "@base-ui/react/radio";
import { RadioGroup as se } from "@base-ui/react/radio-group";
import { Dialog as ce } from "@base-ui/react/dialog";
import { ScrollArea as le } from "@base-ui/react/scroll-area";
import { DirectionProvider as ue, useDirection as de } from "@base-ui/react/direction-provider";
import { Drawer as fe } from "@base-ui/react/drawer";
import { Menu as K } from "@base-ui/react/menu";
import { Menubar as pe } from "@base-ui/react/menubar";
import { Popover as me } from "@base-ui/react/popover";
import { Progress as he } from "@base-ui/react/progress";
import * as ge from "react-resizable-panels";
import { Select as _e } from "@base-ui/react/select";
import { Slider as ve } from "@base-ui/react/slider";
import { Toast as ye } from "@base-ui/react/toast";
import { Switch as be } from "@base-ui/react/switch";
import { Tabs as xe } from "@base-ui/react/tabs";
import { ToggleGroup as Se } from "@base-ui/react/toggle-group";
//#region ../primitives/dist/index.js
var Ce = j({ extend: { classGroups: { "font-size": [{ text: ["xxs"] }] } } });
function q(...e) {
	return Ce(A(e));
}
function we({ className: t, ...n }) {
	return /* @__PURE__ */ N(e.Root, {
		"data-slot": "accordion",
		className: q("quill-accordion flex w-full flex-col", t),
		...n
	});
}
function Te({ className: t, ...n }) {
	return /* @__PURE__ */ N(e.Item, {
		"data-quill": !0,
		"data-slot": "accordion-item",
		className: q("quill-accordion__item", t),
		...n
	});
}
function Ee({ className: t, children: n, ...r }) {
	return /* @__PURE__ */ N(e.Header, {
		className: "flex",
		children: /* @__PURE__ */ P(e.Trigger, {
			"data-slot": "accordion-trigger",
			className: q("quill-accordion__trigger group/accordion-trigger relative flex flex-1 items-start justify-between gap-6", t),
			...r,
			children: [
				/* @__PURE__ */ N("span", { children: n }),
				/* @__PURE__ */ N(c, {
					"data-slot": "accordion-trigger-icon",
					"data-chevron": "down",
					className: "pointer-events-none shrink-0"
				}),
				/* @__PURE__ */ N(f, {
					"data-slot": "accordion-trigger-icon",
					"data-chevron": "up",
					className: "pointer-events-none shrink-0"
				})
			]
		})
	});
}
function De({ className: t, children: n, ...r }) {
	return /* @__PURE__ */ N(e.Panel, {
		"data-slot": "accordion-content",
		className: "quill-accordion__panel",
		...r,
		children: /* @__PURE__ */ N("div", {
			className: q("quill-accordion__panel-content", t),
			children: n
		})
	});
}
function Oe({ ...e }) {
	return /* @__PURE__ */ N(F.Root, {
		"data-slot": "alert-dialog",
		...e
	});
}
function ke({ ...e }) {
	return /* @__PURE__ */ N(F.Trigger, {
		"data-slot": "alert-dialog-trigger",
		...e
	});
}
function Ae({ ...e }) {
	return /* @__PURE__ */ N(F.Portal, {
		"data-slot": "alert-dialog-portal",
		...e
	});
}
function je({ ...e }) {
	return /* @__PURE__ */ N(F.Close, {
		"data-slot": "alert-dialog-close",
		...e
	});
}
function Me({ className: e, ...t }) {
	return /* @__PURE__ */ N(F.Backdrop, {
		"data-quill": !0,
		"data-quill-portal": "modal-overlay",
		"data-slot": "alert-dialog-overlay",
		className: q("quill-dialog__overlay", e),
		...t
	});
}
function Ne({ className: e, children: t, ...n }) {
	return /* @__PURE__ */ P(Ae, { children: [/* @__PURE__ */ N(Me, {}), /* @__PURE__ */ N(F.Popup, {
		"data-quill": !0,
		"data-quill-portal": "modal-content",
		"data-slot": "alert-dialog-content",
		className: q("quill-dialog__content", e),
		...n,
		children: t
	})] });
}
function Pe({ className: e, ...t }) {
	return /* @__PURE__ */ N(F.Title, {
		"data-slot": "alert-dialog-title",
		className: q("quill-dialog__title", e),
		...t
	});
}
function Fe({ className: e, ...t }) {
	return /* @__PURE__ */ N(F.Description, {
		"data-slot": "alert-dialog-description",
		className: q("quill-dialog__description", e),
		...t
	});
}
function Ie({ className: e, ...t }) {
	return /* @__PURE__ */ N("div", {
		"data-slot": "alert-dialog-header",
		className: q("quill-dialog__header flex flex-col gap-1", e),
		...t
	});
}
function Le({ className: e, ...t }) {
	return /* @__PURE__ */ N("div", {
		"data-slot": "alert-dialog-footer",
		className: q("quill-dialog__footer flex flex-col-reverse gap-2 sm:flex-row sm:justify-end", e),
		...t
	});
}
function Re({ className: e, ...t }) {
	return /* @__PURE__ */ N(y, {
		"data-quill": !0,
		role: "status",
		"aria-label": "Loading",
		className: q("quill-spinner", e),
		...t
	});
}
var ze = L("quill-button group/button inline-flex shrink-0 items-center justify-center whitespace-nowrap", {
	variants: {
		variant: {
			default: "quill-button--variant-default",
			primary: "quill-button--variant-primary",
			outline: "quill-button--variant-outline",
			destructive: "quill-button--variant-destructive",
			link: "quill-button--variant-link",
			"link-muted": "quill-button--variant-link-muted"
		},
		size: {
			default: "quill-button--size-default",
			xs: "quill-button--size-xs",
			sm: "quill-button--size-sm",
			lg: "quill-button--size-lg",
			icon: "quill-button--size-icon",
			"icon-xs": "quill-button--size-icon-xs",
			"icon-sm": "quill-button--size-icon-sm",
			"icon-lg": "quill-button--size-icon-lg"
		},
		focusableWhenDisabled: {
			true: "",
			false: "quill-button--not-focusable-when-disabled"
		},
		left: {
			true: "justify-start",
			false: ""
		},
		inert: {
			true: "quill-button--inert",
			false: ""
		}
	},
	defaultVariants: {
		variant: "default",
		size: "default"
	}
}), J = w.forwardRef(({ className: e, variant: t = "default", size: n = "default", focusableWhenDisabled: r = !0, left: i = !1, loading: a = !1, disabled: o, children: s, ...c }, l) => /* @__PURE__ */ P(ee, {
	ref: l,
	"data-quill": !0,
	"data-slot": "button",
	"data-size": n,
	"data-loading": a || void 0,
	"aria-busy": a || void 0,
	disabled: o || a,
	focusableWhenDisabled: a ? !0 : r,
	className: q(ze({
		variant: t,
		size: n,
		className: e,
		focusableWhenDisabled: r,
		left: i
	})),
	...c,
	children: [s, a && /* @__PURE__ */ N(Re, { className: "quill-button__spinner" })]
}));
J.displayName = "Button";
var Be = w.forwardRef(({ className: e, type: t, ...n }, r) => /* @__PURE__ */ N(te, {
	ref: r,
	type: t,
	"data-quill": !0,
	"data-slot": "input",
	className: q("quill-input", e),
	...n
}));
Be.displayName = "Input";
function Ve({ className: e, ...t }) {
	return /* @__PURE__ */ N("textarea", {
		"data-quill": !0,
		"data-slot": "textarea",
		className: q("quill-textarea flex", e),
		...t
	});
}
var He = w.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ N("div", {
	ref: n,
	"data-quill": !0,
	"data-slot": "input-group",
	role: "group",
	className: q("quill-input-group group/input-group flex items-center", e),
	...t
}));
He.displayName = "InputGroup";
var Ue = L("quill-input-group__addon group/input-group-addon empty:hidden flex h-auto items-center justify-center gap-1 select-none whitespace-nowrap", {
	variants: { align: {
		"inline-start": "quill-input-group__addon--align-inline-start",
		"inline-end": "quill-input-group__addon--align-inline-end",
		"block-start": "quill-input-group__addon--align-block-start justify-start",
		"block-end": "quill-input-group__addon--align-block-end justify-start"
	} },
	defaultVariants: { align: "inline-start" }
});
function We({ className: e, align: t = "inline-start", ...n }) {
	return /* @__PURE__ */ N("div", {
		role: "group",
		"data-slot": "input-group-addon",
		"data-align": t,
		className: q(Ue({ align: t }), e),
		onClick: (e) => {
			e.target.closest("button") || e.currentTarget.parentElement?.querySelector("input")?.focus();
		},
		...n
	});
}
var Ge = L("quill-input-group__button flex items-center gap-2", {
	variants: { size: {
		xs: "quill-input-group__button--size-xs",
		sm: "quill-input-group__button--size-sm",
		"icon-xs": "quill-input-group__button--size-icon-xs",
		"icon-sm": "quill-input-group__button--size-icon-sm"
	} },
	defaultVariants: { size: "xs" }
}), Ke = w.forwardRef(({ className: e, type: t = "button", variant: n, size: r = "sm", ...i }, a) => /* @__PURE__ */ N(J, {
	ref: a,
	type: t,
	"data-size": r,
	variant: n,
	className: q(Ge({ size: r }), e),
	...i
}));
Ke.displayName = "InputGroupButton";
function qe({ className: e, ...t }) {
	return /* @__PURE__ */ N("span", {
		className: q("quill-input-group__text flex items-end gap-2", e),
		...t
	});
}
var Je = w.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ N(Be, {
	ref: n,
	"data-slot": "input-group-control",
	className: q("quill-input-group__control", e),
	...t
}));
Je.displayName = "InputGroupInput";
function Ye({ className: e, ...t }) {
	return /* @__PURE__ */ N(Ve, {
		"data-slot": "input-group-control",
		className: q("quill-input-group__control quill-input-group__control--textarea", e),
		...t
	});
}
function Xe({ className: e, inputRef: t, ...n }) {
	return /* @__PURE__ */ N(R.Root, {
		...n,
		children: /* @__PURE__ */ N(R.ScrubArea, {
			"data-slot": "input-group-scrub-area",
			className: "cursor-ew-resize",
			children: /* @__PURE__ */ N(R.Input, {
				ref: t,
				"data-slot": "input-group-control",
				className: q("quill-input-group__control h-8 w-full min-w-0 px-2 py-0.5 text-xs tabular-nums text-center outline-none placeholder:text-muted-foreground disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50", e)
			})
		})
	});
}
function Ze({ className: e, children: t, ...n }) {
	return /* @__PURE__ */ N("div", {
		...n,
		"data-slot": "menu-empty",
		role: "status",
		"aria-live": "polite",
		className: q(ze({
			size: "sm",
			left: !0,
			inert: !0
		}), "quill-menu-empty", e),
		children: t
	});
}
function Qe({ className: e, render: t, ...n }) {
	return B({
		defaultTagName: "div",
		props: z({
			"data-quill": "",
			"data-slot": "menu-label",
			className: q("quill-menu-label", e)
		}, n),
		render: t
	});
}
function $e({ className: e, orientation: t = "horizontal", ...n }) {
	return /* @__PURE__ */ N(ne, {
		"data-quill": !0,
		"data-slot": "separator",
		orientation: t,
		className: q("quill-separator shrink-0", e),
		...n
	});
}
var et = w.createContext(null), tt = I.Root;
function nt({ children: e, autoHighlight: t = !0, ...n }) {
	let r = w.useRef(null);
	return /* @__PURE__ */ N(et.Provider, {
		value: r,
		children: /* @__PURE__ */ N(tt, {
			...n,
			autoHighlight: t,
			children: e
		})
	});
}
function rt({ ...e }) {
	return /* @__PURE__ */ N(I.Value, {
		"data-slot": "autocomplete-value",
		...e
	});
}
var it = w.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ P(I.Trigger, {
	ref: r,
	"data-slot": "autocomplete-trigger",
	className: q("quill-autocomplete__trigger", e),
	...n,
	children: [t, /* @__PURE__ */ N(c, { className: "pointer-events-none size-3.5 text-muted-foreground" })]
}));
it.displayName = "AutocompleteTrigger";
function at({ className: e, ...t }) {
	return /* @__PURE__ */ N(I.Clear, {
		"data-slot": "autocomplete-clear",
		render: /* @__PURE__ */ N(Ke, { size: "icon-xs" }),
		className: q(e),
		...t,
		children: /* @__PURE__ */ N(C, { className: "pointer-events-none" })
	});
}
function ot({ className: e, children: t, disabled: n = !1, showSearchIcon: r = !0, showClear: i = !1, ...a }) {
	return /* @__PURE__ */ P("div", {
		"data-slot": "autocomplete-input-group-wrapper",
		children: [/* @__PURE__ */ P(He, {
			ref: w.useContext(et),
			className: q("w-auto", e),
			children: [
				r && /* @__PURE__ */ N(We, {
					align: "inline-start",
					children: /* @__PURE__ */ N(x, {})
				}),
				/* @__PURE__ */ N(I.Input, {
					render: /* @__PURE__ */ N(Je, { disabled: n }),
					...a
				}),
				t ? /* @__PURE__ */ N(We, {
					align: "inline-end",
					children: t
				}) : null,
				i && /* @__PURE__ */ N(We, {
					align: "inline-end",
					children: /* @__PURE__ */ N(at, { disabled: n })
				})
			]
		}), /* @__PURE__ */ N($e, {
			orientation: "horizontal",
			"data-slot": "autocomplete-popover-separator",
			className: "w-[calc(100%+var(--spacing))]"
		})]
	});
}
function st({ className: e, side: t = "bottom", sideOffset: n = 6, align: r = "start", alignOffset: i = 0, anchor: a, ...o }) {
	let s = w.useContext(et), c = a ?? s;
	return /* @__PURE__ */ N(I.Portal, { children: /* @__PURE__ */ N(I.Positioner, {
		"data-quill": !0,
		"data-quill-portal": "popover",
		side: t,
		sideOffset: n,
		align: r,
		alignOffset: i,
		anchor: c,
		className: "isolate",
		children: /* @__PURE__ */ N(I.Popup, {
			"data-slot": "autocomplete-content",
			className: q("quill-autocomplete__content group/autocomplete-content", e),
			...o
		})
	}) });
}
function ct({ className: e, ...t }) {
	return /* @__PURE__ */ N(I.List, {
		"data-slot": "autocomplete-list",
		className: q("quill-autocomplete__list scroll-mask-t-2 scroll-mask-b-4 scroll-pb-4 scroll-pt-6 empty:hidden", e),
		...t
	});
}
function lt({ className: e, children: t, title: n, ...r }) {
	return /* @__PURE__ */ N(I.Item, {
		"data-slot": "autocomplete-item",
		className: q("quill-autocomplete__item", e),
		title: n ?? (typeof t == "string" ? t : void 0),
		render: /* @__PURE__ */ N(J, {
			left: !0,
			className: "font-normal min-w-0 aria-selected:bg-fill-selected data-highlighted:border-ring data-highlighted:ring-2 data-highlighted:ring-ring/30 ring-offset-1"
		}),
		tabIndex: -1,
		...r,
		children: /* @__PURE__ */ N("span", {
			className: "flex items-center gap-1.5 min-w-0 truncate",
			children: t
		})
	});
}
function ut({ className: e, ...t }) {
	return /* @__PURE__ */ N(I.Group, {
		"data-slot": "autocomplete-group",
		className: q("pb-1", e),
		...t
	});
}
function dt({ className: e, ...t }) {
	return /* @__PURE__ */ N(I.GroupLabel, {
		"data-slot": "autocomplete-label",
		className: q("quill-autocomplete__label mb-1 -mx-1 w-[calc(100%+var(--spacing)*2)]", e),
		render: /* @__PURE__ */ N(Qe, {}),
		...t
	});
}
function ft({ ...e }) {
	return /* @__PURE__ */ N(I.Collection, {
		"data-slot": "autocomplete-collection",
		...e
	});
}
function pt({ className: e, children: t, ...n }) {
	return /* @__PURE__ */ N(I.Empty, {
		"data-slot": "autocomplete-empty",
		className: q("quill-autocomplete__empty", e),
		...n,
		children: /* @__PURE__ */ N(Ze, { children: t })
	});
}
function mt({ className: e, ...t }) {
	return /* @__PURE__ */ N(I.Separator, {
		"data-slot": "autocomplete-separator",
		className: q("quill-autocomplete__separator my-0", e),
		...t
	});
}
function ht(e) {
	return Array.isArray(e) ? e.reduce((e, t) => t && typeof t == "object" && "items" in t && Array.isArray(t.items) ? e + t.items.length : e + 1, 0) : 0;
}
function gt({ className: e, children: t, emptyContent: n, ...r }) {
	let i = ht(I.useFilteredItems()), a;
	return a = typeof t == "function" ? t(i) : t === void 0 ? i === 0 ? n : `${i} ${i === 1 ? "result" : "results"}` : t, /* @__PURE__ */ N(I.Status, {
		"data-slot": "autocomplete-status",
		className: q("quill-autocomplete__status bg-card border-b border-border text-xs text-muted-foreground px-2 py-1.5 empty:hidden", e),
		...r,
		children: a
	});
}
function _t() {
	let e = w.useContext(et);
	if (e === null) throw Error("useAutocompleteAnchor must be used within an Autocomplete");
	return e;
}
var vt = w.forwardRef(function({ className: e, size: t = "default", ...n }, r) {
	return /* @__PURE__ */ N(re.Root, {
		ref: r,
		"data-quill": !0,
		"data-slot": "avatar",
		"data-size": t,
		className: q("quill-avatar", e),
		...n
	});
}), yt = w.forwardRef(function({ className: e, ...t }, n) {
	return /* @__PURE__ */ N(re.Image, {
		ref: n,
		"data-slot": "avatar-image",
		className: q("quill-avatar__image", e),
		...t
	});
}), bt = w.forwardRef(function({ className: e, ...t }, n) {
	return /* @__PURE__ */ N(re.Fallback, {
		ref: n,
		"data-slot": "avatar-fallback",
		className: q("quill-avatar__fallback", e),
		...t
	});
});
function xt({ className: e, stacked: t = !1, reverse: n = !1, size: r = "default", children: i, style: a, ...o }) {
	let s = w.Children.toArray(i);
	return /* @__PURE__ */ N("div", {
		"data-quill": !0,
		"data-slot": "avatar-group",
		"data-stacked": t ? "" : void 0,
		"data-reverse": n ? "" : void 0,
		"data-size": r,
		className: q("quill-avatar-group", e),
		style: {
			...a,
			"--avatar-count": s.length
		},
		...o,
		children: s.map((e, t) => {
			let n = w.isValidElement(e) && e.type === vt && e.props.size === void 0 ? w.cloneElement(e, { size: r }) : e;
			return /* @__PURE__ */ N("span", {
				"data-slot": "avatar-group-item",
				className: "quill-avatar-group__item",
				style: { "--avatar-index": t },
				children: n
			}, t);
		})
	});
}
vt.displayName = "Avatar", yt.displayName = "AvatarImage", bt.displayName = "AvatarFallback";
var St = L("quill-badge inline-flex w-fit shrink-0 items-center justify-center gap-1 overflow-hidden whitespace-nowrap", {
	variants: { variant: {
		default: "quill-badge--variant-default",
		info: "quill-badge--variant-info",
		destructive: "quill-badge--variant-destructive",
		warning: "quill-badge--variant-warning",
		success: "quill-badge--variant-success",
		completed: "quill-badge--variant-completed"
	} },
	defaultVariants: { variant: "default" }
});
function Ct({ className: e, variant: t = "default", render: n, ...r }) {
	return B({
		defaultTagName: "span",
		props: z({
			"data-quill": "",
			className: q(St({ variant: t }), e)
		}, r),
		render: n,
		state: {
			slot: "badge",
			variant: t
		}
	});
}
function wt({ className: e, ...t }) {
	return /* @__PURE__ */ N("div", {
		"data-quill": !0,
		"data-slot": "bubble-group",
		className: q("quill-chat-bubble-group", e),
		...t
	});
}
var Tt = L("quill-chat-bubble", {
	variants: { variant: {
		default: "quill-chat-bubble--variant-default",
		secondary: "quill-chat-bubble--variant-secondary",
		muted: "quill-chat-bubble--variant-muted",
		tinted: "quill-chat-bubble--variant-tinted",
		outline: "quill-chat-bubble--variant-outline",
		ghost: "quill-chat-bubble--variant-ghost",
		destructive: "quill-chat-bubble--variant-destructive"
	} },
	defaultVariants: { variant: "default" }
});
function Et({ variant: e = "default", align: t = "start", className: n, ...r }) {
	return /* @__PURE__ */ N("div", {
		"data-quill": !0,
		"data-slot": "bubble",
		"data-variant": e,
		"data-align": t,
		className: q(Tt({ variant: e }), n),
		...r
	});
}
function Dt({ className: e, render: t, ...n }) {
	return B({
		defaultTagName: "div",
		props: z({
			"data-slot": "bubble-content",
			className: q("quill-chat-bubble__content", e)
		}, n),
		render: t,
		state: { slot: "bubble-content" }
	});
}
function Ot({ side: e = "bottom", align: t = "end", className: n, ...r }) {
	return /* @__PURE__ */ N("div", {
		"data-slot": "bubble-reactions",
		"data-align": t,
		"data-side": e,
		className: q("quill-chat-bubble-reactions", n),
		...r
	});
}
var kt = "(prefers-reduced-motion: reduce)";
function At(e) {
	let t = window.matchMedia(kt);
	return t.addEventListener("change", e), () => t.removeEventListener("change", e);
}
function jt() {
	return w.useSyncExternalStore(At, () => window.matchMedia(kt).matches, () => !1);
}
var Mt = {
	left: "M6.057 11.565 C2.081 11.565 0.371 8.159 0.371 5.964 C0.371 3.642 2.152 0.329 6.05 0.329",
	midLeft: "M6.012 11.55 C4.575 10.496 3.333 8.116 3.321 5.964 C3.307 3.399 4.974 0.977 6.012 0.329",
	midRight: "M6.012 11.55 C7.211 10.781 8.715 8.287 8.715 5.964 C8.715 3.399 7.24 1.233 6.012 0.329",
	right: "M6.012 11.55 C9.677 11.55 11.65 8.487 11.65 5.964 C11.65 3.499 9.748 0.329 6.012 0.329"
}, Nt = [
	Mt.left,
	Mt.midLeft,
	Mt.midRight,
	Mt.right,
	Mt.left
].join(";"), Pt = 13.48;
Math.round((Pt - 12) / 2 * 100) / 100;
var Ft = `-0.74 -0.74 ${Pt} ${Pt}`, It = .95, Lt = "7.2s", Rt = [
	"0s",
	"-1.2s",
	"-2.4s",
	"-3.6s",
	"-4.8s",
	"-6s"
], zt = "0.42 0 0.58 1";
function Bt({ className: e, ...t }) {
	let n = jt();
	return /* @__PURE__ */ P("svg", {
		"data-quill": !0,
		"data-slot": "globe",
		viewBox: Ft,
		width: "14",
		height: "14",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: It,
		strokeLinecap: "round",
		"aria-hidden": "true",
		className: q("quill-chat-globe", e),
		...t,
		children: [
			/* @__PURE__ */ N("circle", {
				cx: "6",
				cy: "6",
				r: "5.7",
				opacity: "0.9"
			}),
			/* @__PURE__ */ N("line", {
				x1: "0.3",
				y1: "6",
				x2: "11.7",
				y2: "6",
				opacity: "0.9"
			}),
			n ? /* @__PURE__ */ P(M, { children: [/* @__PURE__ */ N("path", {
				d: Mt.midLeft,
				opacity: "0.9"
			}), /* @__PURE__ */ N("path", {
				d: Mt.midRight,
				opacity: "0.9"
			})] }) : Rt.map((e) => /* @__PURE__ */ P("path", {
				d: Mt.left,
				opacity: "0",
				children: [/* @__PURE__ */ N("animate", {
					attributeName: "d",
					dur: Lt,
					begin: e,
					repeatCount: "indefinite",
					calcMode: "spline",
					keyTimes: "0;0.25;0.5;0.75;1",
					keySplines: [
						zt,
						zt,
						zt,
						zt
					].join(";"),
					values: Nt
				}), /* @__PURE__ */ N("animate", {
					attributeName: "opacity",
					dur: Lt,
					begin: e,
					repeatCount: "indefinite",
					calcMode: "linear",
					keyTimes: "0;0.05;0.7;0.75;1",
					values: "0;0.9;0.9;0;0"
				})]
			}, e))
		]
	});
}
var Vt = L("quill-chat-marker", {
	variants: { variant: {
		default: "",
		separator: "quill-chat-marker--separator",
		border: "quill-chat-marker--border"
	} },
	defaultVariants: { variant: "default" }
}), Ht = w.createContext(void 0);
function Ut({ body: e, ...t }) {
	return e != null && e !== !1 && e !== "" ? /* @__PURE__ */ N(Gt, {
		body: e,
		...t
	}) : /* @__PURE__ */ N(Wt, { ...t });
}
function Wt({ className: e, variant: t = "default", status: n, render: r, defaultOpen: i, open: a, onOpenChange: o, ...s }) {
	let c = B({
		defaultTagName: "div",
		props: z({
			"data-quill": "",
			"data-slot": "marker",
			"data-variant": t,
			"data-status": n,
			className: q("quill-chat-row", Vt({
				variant: t,
				className: e
			}))
		}, s),
		render: r,
		state: {
			slot: "marker",
			variant: t,
			status: n
		}
	});
	return /* @__PURE__ */ N(Ht.Provider, {
		value: n,
		children: c
	});
}
function Gt({ className: e, variant: t = "default", status: n, body: r, defaultOpen: i, open: a, onOpenChange: o, children: s, render: c, ...l }) {
	return /* @__PURE__ */ N(Ht.Provider, {
		value: n,
		children: /* @__PURE__ */ P(V.Root, {
			"data-quill": !0,
			"data-slot": "marker",
			"data-variant": t,
			"data-status": n,
			defaultOpen: i,
			open: a,
			onOpenChange: o,
			className: q(Vt({ variant: t }), "quill-chat-marker--collapsible"),
			children: [/* @__PURE__ */ P(V.Trigger, {
				className: q("quill-chat-row", "quill-chat-row--interactive", "quill-chat-marker__trigger", e),
				render: c,
				...l,
				children: [s, /* @__PURE__ */ N(d, {
					"aria-hidden": "true",
					className: q("quill-chat-chevron", "quill-chat-chevron--reveal")
				})]
			}), /* @__PURE__ */ N(V.Panel, {
				"data-slot": "marker-panel",
				className: q("quill-chat-collapse", "quill-chat-rail", "quill-chat-marker__panel"),
				children: r
			})]
		})
	});
}
function Kt({ className: e, ...t }) {
	return /* @__PURE__ */ N("span", {
		"data-slot": "marker-icon",
		"aria-hidden": "true",
		className: q("quill-chat-marker__icon", e),
		...t
	});
}
function qt({ className: e, ...t }) {
	return /* @__PURE__ */ N("span", {
		"data-slot": "marker-content",
		className: q("quill-chat-marker__content", w.useContext(Ht) === "running" && "quill-shimmer", e),
		...t
	});
}
function Jt({ className: e, ...t }) {
	return /* @__PURE__ */ N("span", {
		"data-slot": "marker-value",
		className: q("quill-chat-marker__value", e),
		...t
	});
}
function Yt({ className: e, ...t }) {
	return /* @__PURE__ */ N("div", {
		"data-quill": !0,
		"data-slot": "message-group",
		className: q("quill-chat-message-group", e),
		...t
	});
}
function Xt({ className: e, align: t = "start", ...n }) {
	return /* @__PURE__ */ N("div", {
		"data-quill": !0,
		"data-slot": "message",
		"data-align": t,
		className: q("quill-chat-message", e),
		...n
	});
}
function Zt({ className: e, ...t }) {
	return /* @__PURE__ */ N("div", {
		"data-slot": "message-avatar",
		className: q("quill-chat-message__avatar", e),
		...t
	});
}
function Qt({ className: e, ...t }) {
	return /* @__PURE__ */ N("div", {
		"data-slot": "message-content",
		className: q("quill-chat-message__content", e),
		...t
	});
}
function $t({ className: e, ...t }) {
	return /* @__PURE__ */ N("div", {
		"data-slot": "message-header",
		className: q("quill-chat-message__header", e),
		...t
	});
}
function en({ className: e, ...t }) {
	return /* @__PURE__ */ N("div", {
		"data-slot": "message-footer",
		className: q("quill-chat-message__footer", e),
		...t
	});
}
function tn({ defaultTagName: e, props: t, render: n, state: r = {}, stateAttributesMapping: i }) {
	let a = nn(rn(r, i), t);
	if (!n) return w.createElement(e, a);
	if (typeof n == "function") return n(a, r);
	if (!w.isValidElement(n)) return null;
	let o = n.props, s = {
		...nn(a, o),
		ref: sn(a.ref, o.ref)
	};
	return w.cloneElement(n, s);
}
function nn(...e) {
	let t = {};
	for (let n of e) {
		if (!n) continue;
		let e = n;
		for (let n of Object.keys(e)) {
			let r = e[n];
			if (r === void 0) continue;
			let i = t[n];
			n === "className" ? t[n] = [i, r].filter(Boolean).join(" ") : n === "style" ? t[n] = {
				...i,
				...r
			} : n === "ref" ? t[n] = sn(i, r) : on(n) && typeof i == "function" && typeof r == "function" ? t[n] = an(r, i) : t[n] = r;
		}
	}
	return t;
}
function rn(e, t) {
	let n = {};
	for (let r of Object.keys(e)) {
		let i = e[r], a = t?.[r]?.(i);
		if (a) {
			Object.assign(n, a);
			continue;
		}
		if (r === "slot") {
			n["data-slot"] = i;
			continue;
		}
		let o = `data-${String(r).replace(/[A-Z]/g, (e) => `-${e.toLowerCase()}`)}`;
		typeof i == "boolean" ? n[o] = i ? "" : void 0 : i != null && (n[o] = String(i));
	}
	return n;
}
function an(e, t) {
	return function(n) {
		e(n), n.defaultPrevented || t(n);
	};
}
function on(e) {
	return /^on[A-Z]/.test(e);
}
function sn(...e) {
	let t = e.filter(Boolean);
	if (t.length !== 0) return (e) => {
		for (let n of t) typeof n == "function" ? n(e) : n && (n.current = e);
	};
}
var cn = 8, ln = 64, un = 0, dn = .5, fn = 180, pn = /* @__PURE__ */ new Set([
	"ArrowDown",
	"ArrowUp",
	"End",
	"Home",
	"PageDown",
	"PageUp",
	" "
]), mn = {
	start: !1,
	end: !1
}, hn = {
	currentAnchorId: null,
	visibleMessageIds: []
};
function gn({ content: e, scrollEdgeThreshold: t, spacer: n, viewport: r }) {
	if (!r || !e) return mn;
	let i = On({
		content: e,
		spacer: n,
		viewport: r
	});
	return {
		start: r.scrollTop > t,
		end: i - r.scrollTop - r.clientHeight > t
	};
}
function _n({ content: e, scrollMargin: t, scrollPreviousItemPeek: n, spacer: r, viewport: i, visibleMessageIds: a }) {
	if (!e || !i) return hn;
	let o = i.getBoundingClientRect(), s = o.top + t + n, c = typeof IntersectionObserver > "u", l = [], u = null;
	for (let t of vn(e, r)) {
		let e = t.dataset.messageId;
		if (!e) continue;
		let n = t.dataset.scrollAnchor === "true", r = n || c ? t.getBoundingClientRect() : null;
		(c && r ? r.bottom > s && r.top < o.bottom : a.has(e)) && l.push(e), n && r && r.top <= s + dn && (u = e);
	}
	return l.length === 0 && u === null ? hn : {
		currentAnchorId: u,
		visibleMessageIds: l
	};
}
function vn(e, t) {
	return Array.from(e.children).filter((e) => e instanceof HTMLElement && e !== t);
}
function yn(e, t) {
	for (let n = t; n < e.length; n++) {
		let t = e[n];
		if (t?.dataset.scrollAnchor === "true") return t;
	}
	return null;
}
function bn(e, t) {
	for (let n of e) if (n.dataset.scrollAnchor === "true" && !t.has(n)) return n;
	return null;
}
function xn(e, t) {
	let n = 0;
	for (let r = t; r < e.length; r++) if (e[r]?.dataset.scrollAnchor === "true" && (n += 1, n > 1)) return !0;
	return !1;
}
function Sn(e) {
	for (let t = e.length - 1; t >= 0; t--) {
		let n = e[t];
		if (n?.dataset.scrollAnchor === "true") return n;
	}
	return null;
}
function Cn({ content: e, spacer: t, viewport: n }) {
	let r = n.getBoundingClientRect();
	for (let n of vn(e, t)) {
		if (!n.dataset.messageId) continue;
		let e = n.getBoundingClientRect();
		if (e.bottom > r.top && e.top < r.bottom) return n;
	}
	return null;
}
function wn({ align: e, element: t, scrollMargin: n, spacer: r, viewport: i }) {
	let a = Tn(t, i), o = t.getBoundingClientRect().height, s = jn(r);
	if (e === "center") {
		let e = Math.max(0, i.clientHeight - s.start - s.end);
		return a - s.start - (e - o) / 2 - n;
	}
	if (e === "end") return a - i.clientHeight + o + s.end + n;
	if (e === "nearest") {
		let e = a + o, t = i.scrollTop + s.start, r = i.scrollTop + i.clientHeight - s.end;
		return a >= t && e <= r ? i.scrollTop : a < t ? a - s.start - n : e - i.clientHeight + s.end + n;
	}
	return a - s.start - n;
}
function Tn(e, t) {
	let n = e.getBoundingClientRect(), r = t.getBoundingClientRect();
	return n.top - r.top + t.scrollTop;
}
function En(e, t) {
	return e.getBoundingClientRect().top - t.getBoundingClientRect().top;
}
function Dn({ content: e, scrollTop: t, spacer: n, viewport: r }) {
	let i = On({
		content: e,
		spacer: n,
		viewport: r
	});
	return t + r.clientHeight - i;
}
function On({ content: e, spacer: t, viewport: n }) {
	let r = vn(e, t), i = An(e), a = n.getBoundingClientRect(), o = n.scrollTop, s = i.start + i.end;
	for (let e of r) {
		let t = e.getBoundingClientRect();
		s = Math.max(s, t.bottom - a.top + o + i.end);
	}
	return s;
}
function kn(e) {
	return Math.max(0, e.scrollHeight - e.clientHeight);
}
function An(e) {
	let t = window.getComputedStyle(e);
	return {
		end: Nn(t.paddingBlockEnd || t.paddingBottom),
		start: Nn(t.paddingBlockStart || t.paddingTop)
	};
}
function jn(e) {
	let t = e?.parentElement;
	return t ? An(t) : {
		end: 0,
		start: 0
	};
}
function Mn(e) {
	if (!e) return 0;
	let t = window.getComputedStyle(e);
	return Nn(t.rowGap === "normal" ? t.gap : t.rowGap);
}
function Nn(e) {
	if (!e) return 0;
	let t = Number.parseFloat(e);
	return Number.isFinite(t) ? t : 0;
}
function Pn({ refs: e, commitScrollState: t, scheduleStateCommit: n, scheduleVisibilitySync: r }) {
	let { streamingTurnRef: i, autoScrollRef: a, autoscrollingRef: o, autoscrollingTimeoutRef: s, contentRef: c, defaultScrollPositionAppliedRef: l, itemCountRef: u, messageElementsRef: d, modeRef: f, pendingScrollToMessageRef: p, prependRestoreRef: m, scrollMarginRef: h, scrollPreviousItemPeekRef: g, spacerGapRef: _, spacerHeightRef: v, spacerRef: y, viewportRef: b } = e, x = w.useCallback((e) => {
		s.current !== null && (window.clearTimeout(s.current), s.current = null), o.current !== e && (o.current = e, t()), e && (s.current = window.setTimeout(() => {
			s.current = null, o.current = !1, t();
		}, fn));
	}, [t]), S = w.useCallback((e) => {
		let t = y.current;
		if (!t) return;
		let n = Math.max(0, Math.ceil(e));
		v.current !== n && (v.current = n, t.hidden = n === 0, t.style.height = `${n}px`, t.style.marginTop = n > 0 ? `${-_.current}px` : "");
	}, []), C = w.useCallback((e, { behavior: r = "auto", autoscrolling: i = !1 } = {}) => {
		let a = b.current;
		if (!a) return;
		let o = Math.max(0, e);
		if (Math.abs(a.scrollTop - o) <= dn) {
			a.scrollTop = o, t();
			return;
		}
		i && x(!0), a.scrollTo({
			top: o,
			behavior: r
		}), n();
	}, [
		t,
		n,
		x
	]), T = w.useCallback(({ behavior: e = "auto" } = {}) => b.current ? (S(0), i.current = null, f.current = "free-scrolling", C(0, { behavior: e }), r(), !0) : !1, [
		r,
		C,
		S
	]), E = w.useCallback(({ behavior: e = "auto" } = {}) => {
		let t = b.current;
		return t ? (S(0), i.current = null, f.current = a.current ? "following-bottom" : "free-scrolling", C(kn(t), {
			autoscrolling: !0,
			behavior: e
		}), r(), !0) : !1;
	}, [
		r,
		C,
		S
	]), D = w.useCallback((e, { align: t = "start", behavior: n = "auto", scrollMargin: a = h.current } = {}, { keepPreviousPeek: o = !1 } = {}) => {
		let s = c.current, l = b.current;
		if (!s || !l || !s.contains(e)) return !1;
		let u = wn({
			align: t,
			element: e,
			scrollMargin: o ? a + g.current : a,
			spacer: y.current,
			viewport: l
		}), d = Dn({
			content: s,
			scrollTop: u,
			spacer: y.current,
			viewport: l
		});
		return S(d), m.current = {
			element: e,
			viewportTop: En(e, l)
		}, f.current = o ? "anchored-to-message" : "settling-jump", i.current = o ? e : null, C(u, { behavior: n }), r(), !0;
	}, [
		r,
		C,
		S
	]), O = w.useCallback(() => {
		let e = i.current;
		return !e || !e.isConnected || f.current !== "anchored-to-message" ? !1 : D(e, { align: "start" }, { keepPreviousPeek: !0 });
	}, [D]), k = w.useCallback((e, t) => {
		let n = d.current.get(e);
		return n ? (l.current = !0, D(n, t) ? (p.current = null, !0) : (p.current = {
			messageId: e,
			options: t
		}, !0)) : u.current === 0 ? (p.current = {
			messageId: e,
			options: t
		}, l.current = !0, !0) : !1;
	}, [D]);
	return {
		flushPendingScrollToMessage: w.useCallback(() => {
			let e = p.current;
			if (!e) return !1;
			let t = d.current.get(e.messageId);
			return !t || !D(t, e.options) ? !1 : (p.current = null, l.current = !0, !0);
		}, [D]),
		reanchorToAnchoredMessage: O,
		scrollToElement: D,
		scrollToEnd: E,
		scrollToMessage: k,
		scrollToStart: T
	};
}
function Fn(e, t) {
	let n = e, r = /* @__PURE__ */ new Set();
	return {
		getSnapshot: () => n,
		hasListeners: () => r.size > 0,
		setSnapshot: (e) => {
			t(n, e) || (n = e, r.forEach((e) => e()));
		},
		subscribe: (e, t, n) => {
			let i = r.size === 0;
			return r.add(e), i && t?.(), () => {
				r.delete(e), r.size === 0 && n?.();
			};
		}
	};
}
function In(e, t) {
	return Fn(e, t);
}
function Ln() {
	return Fn(hn, zn);
}
function Rn(e, t) {
	return e.start === t.start && e.end === t.end;
}
function zn(e, t) {
	return e.currentAnchorId !== t.currentAnchorId || e.visibleMessageIds.length !== t.visibleMessageIds.length ? !1 : e.visibleMessageIds.every((e, n) => e === t.visibleMessageIds[n]);
}
function Bn({ autoScroll: e, scrollEdgeThreshold: t, scrollMargin: n, scrollPreviousItemPeek: r }) {
	let i = w.useRef(e), a = w.useRef(!1), o = w.useRef(null), s = w.useRef(!1), c = w.useRef(t), l = w.useRef(0), u = w.useRef(null), d = w.useRef(0), f = w.useRef(e ? "following-bottom" : "free-scrolling"), p = w.useRef(/* @__PURE__ */ new Map()), m = w.useRef(null), h = w.useRef(null), g = w.useRef(null), _ = w.useRef(r), v = w.useRef(!0), y = w.useRef(null), b = w.useRef(n), x = w.useRef(null), S = w.useRef(0), C = w.useRef(0), T = w.useRef(null), E = w.useRef(null), D = w.useRef(null), O = w.useRef(null), k = w.useRef(null), A = w.useRef(null), j = w.useRef(null), M = w.useRef(null), N = w.useRef(/* @__PURE__ */ new Set()), P = w.useRef(/* @__PURE__ */ new WeakSet());
	return D.current === null && (D.current = In(mn, Rn)), M.current === null && (M.current = Ln()), i.current = e, c.current = t, b.current = n, _.current = r, {
		autoScrollRef: i,
		autoscrollingRef: a,
		autoscrollingTimeoutRef: O,
		streamingTurnRef: g,
		contentRef: o,
		defaultScrollPositionAppliedRef: s,
		firstItemRef: u,
		itemCountRef: l,
		lastScrollTopRef: d,
		messageElementsRef: p,
		modeRef: f,
		pendingScrollFrameRef: x,
		pendingScrollToMessageRef: m,
		prependRestoreRef: h,
		preserveScrollOnPrependRef: v,
		rootRef: y,
		scrollEdgeThresholdRef: c,
		scrollMarginRef: b,
		scrollPreviousItemPeekRef: _,
		spacerGapRef: S,
		spacerHeightRef: C,
		spacerRef: T,
		stateFrameRef: E,
		stateStore: D.current,
		viewportRef: k,
		visibilityFrameRef: A,
		visibilityObserverRef: j,
		visibilityStore: M.current,
		visibleMessageIdsRef: N,
		handledScrollAnchorsRef: P
	};
}
function Vn(e, t) {
	return w.useCallback((n) => {
		e.current = n, n && t();
	}, [e, t]);
}
function Hn({ autoScroll: e = !1, defaultScrollPosition: t = "end", scrollEdgeThreshold: n = cn, scrollPreviousItemPeek: r = ln, scrollMargin: i = un }) {
	let a = Bn({
		autoScroll: e,
		scrollEdgeThreshold: n,
		scrollMargin: i,
		scrollPreviousItemPeek: r
	}), { streamingTurnRef: o, autoScrollRef: s, autoscrollingRef: c, autoscrollingTimeoutRef: l, contentRef: u, defaultScrollPositionAppliedRef: d, firstItemRef: f, itemCountRef: p, lastScrollTopRef: m, messageElementsRef: h, modeRef: g, pendingScrollFrameRef: _, pendingScrollToMessageRef: v, prependRestoreRef: y, preserveScrollOnPrependRef: b, rootRef: x, scrollEdgeThresholdRef: S, scrollMarginRef: C, scrollPreviousItemPeekRef: T, spacerGapRef: E, spacerHeightRef: D, spacerRef: O, stateFrameRef: k, stateStore: A, viewportRef: j, visibilityFrameRef: M, visibilityObserverRef: N, visibilityStore: P, visibleMessageIdsRef: F, handledScrollAnchorsRef: I } = a, ee = w.useRef(t);
	ee.current !== t && (ee.current = t, d.current = !1);
	let L = w.useCallback((e) => {
		let t = x.current, n = j.current, r = [e.start && "start", e.end && "end"].filter(Boolean).join(" "), i = c.current;
		for (let e of [t, n]) e && (r ? e.setAttribute("data-scrollable", r) : e.removeAttribute("data-scrollable"), e.toggleAttribute("data-autoscrolling", i));
	}, []), R = w.useCallback((e) => {
		let t = j.current?.scrollTop ?? 0, n = t < m.current - dn;
		m.current = t, s.current && !e.end && g.current !== "settling-jump" && g.current !== "anchored-to-message" ? g.current = "following-bottom" : g.current === "following-bottom" && e.end && n && !c.current && (g.current = "free-scrolling");
	}, []), te = w.useCallback(() => {
		let e = gn({
			content: u.current,
			scrollEdgeThreshold: S.current,
			spacer: O.current,
			viewport: j.current
		});
		R(e);
		let t = g.current === "following-bottom" ? {
			...e,
			end: !1
		} : e;
		L(t), A.setSnapshot(t);
	}, [
		R,
		A,
		L
	]), z = w.useCallback(() => {
		k.current === null && (k.current = window.requestAnimationFrame(() => {
			k.current = null, te();
		}));
	}, [te]), B = w.useCallback(() => {
		P.hasListeners() && M.current === null && (M.current = window.requestAnimationFrame(() => {
			M.current = null, P.hasListeners() && P.setSnapshot(_n({
				content: u.current,
				scrollMargin: C.current,
				scrollPreviousItemPeek: T.current,
				spacer: O.current,
				viewport: j.current,
				visibleMessageIds: F.current
			}));
		}));
	}, [P]), { flushPendingScrollToMessage: ne, reanchorToAnchoredMessage: re, scrollToElement: V, scrollToEnd: H, scrollToMessage: ie, scrollToStart: U } = Pn({
		refs: a,
		commitScrollState: te,
		scheduleStateCommit: z,
		scheduleVisibilitySync: B
	}), ae = w.useCallback(() => {
		let e = y.current, t = j.current;
		if (!e || !t || !e.element.isConnected) return !1;
		let n = En(e.element, t) - e.viewportTop;
		return Math.abs(n) <= dn ? !1 : (t.scrollTop += n, e.viewportTop = En(e.element, t), z(), B(), !0);
	}, [z, B]), W = w.useCallback(() => {
		let e = u.current, t = j.current;
		if (!e || !t) {
			y.current = null;
			return;
		}
		let n = Cn({
			content: e,
			spacer: O.current,
			viewport: t
		});
		y.current = n ? {
			element: n,
			viewportTop: En(n, t)
		} : null;
	}, []), G = w.useCallback(() => {
		_.current === null && (_.current = window.requestAnimationFrame(() => {
			_.current = null, ne() && W();
		}));
	}, [W, ne]), oe = w.useCallback(() => {
		if (!t || d.current || p.current === 0) return !1;
		let e = !1;
		if (t === "last-anchor") {
			let t = u.current, n = j.current, r = t && n ? Sn(vn(t, O.current)) : null;
			if (!t || !n || !r) e = H({ behavior: "auto" });
			else {
				let i = Tn(r, n);
				e = On({
					content: t,
					spacer: O.current,
					viewport: n
				}) - i <= n.clientHeight ? H({ behavior: "auto" }) : V(r, { align: "start" }, { keepPreviousPeek: !0 });
			}
		} else e = t === "end" ? H({ behavior: "auto" }) : U({ behavior: "auto" });
		return e ? (d.current = !0, !0) : !1;
	}, [
		t,
		V,
		H,
		U
	]), se = w.useCallback(() => {
		let e = u.current;
		if (!e) return;
		let t = vn(e, O.current), n = p.current, r = f.current;
		p.current = t.length, f.current = t[0] ?? null, (() => {
			if (ne()) return;
			if (n === 0) {
				if (oe() || t.length > 0 && s.current && H({ behavior: "auto" })) return;
				te(), B();
				return;
			}
			let e = r ? t.indexOf(r) : -1;
			if (b.current && e > 0) {
				ae();
				return;
			}
			if (t.length > n) {
				let e = yn(t, n);
				if (e) {
					if (s.current && g.current === "following-bottom" && xn(t, n)) {
						H({ behavior: "auto" });
						return;
					}
					V(e, { align: "start" }, { keepPreviousPeek: !0 }), I.current.add(e);
					return;
				}
			}
			if (t.length === n) {
				let e = bn(t, I.current);
				if (e) {
					V(e, { align: "start" }, { keepPreviousPeek: !0 }), I.current.add(e);
					return;
				}
			}
			g.current === "following-bottom" && s.current ? H({ behavior: "auto" }) : (te(), B());
		})(), W();
	}, [
		oe,
		W,
		te,
		ne,
		ae,
		B,
		V,
		H
	]), ce = w.useCallback(() => {
		if (g.current === "following-bottom" && s.current) {
			H({ behavior: "auto" });
			return;
		}
		let e = D.current;
		if (re()) {
			s.current && e > 0 && D.current === 0 && H({ behavior: "auto" });
			return;
		}
		z(), B();
	}, [
		re,
		z,
		B,
		H
	]), le = w.useCallback(() => {
		let e = j.current;
		if (!(!e || !P.hasListeners())) {
			if (typeof IntersectionObserver > "u") {
				B();
				return;
			}
			N.current ||= new IntersectionObserver((e) => {
				for (let t of e) {
					let e = t.target.dataset.messageId;
					e && (t.isIntersecting ? F.current.add(e) : F.current.delete(e));
				}
				B();
			}, {
				root: e,
				rootMargin: `${-(C.current + T.current)}px 0px 0px 0px`,
				threshold: [
					0,
					.01,
					.5,
					1
				]
			}), h.current.forEach((e) => {
				N.current?.observe(e);
			}), B();
		}
	}, [B, P]), ue = w.useCallback(() => {
		M.current !== null && (window.cancelAnimationFrame(M.current), M.current = null), N.current?.disconnect(), N.current = null, F.current.clear(), P.setSnapshot(hn);
	}, [P]), de = w.useCallback((e, t, n) => {
		if (t) {
			h.current.set(e, t), N.current?.observe(t), B(), v.current?.messageId === e && G();
			return;
		}
		n && h.current.get(e) === n && (h.current.delete(e), F.current.delete(e), N.current?.unobserve(n), B());
	}, [G, B]), fe = w.useCallback(() => {
		(g.current === "following-bottom" || g.current === "anchored-to-message" || g.current === "settling-jump") && (o.current = null, g.current = "free-scrolling");
	}, []), K = w.useCallback(() => L(A.getSnapshot()), [A, L]), pe = Vn(x, K), me = Vn(j, K), he = w.useCallback((e) => {
		u.current = e;
	}, []), ge = w.useCallback((e) => {
		O.current = e, E.current = Mn(e?.parentElement ?? null);
	}, []), _e = w.useCallback(() => {
		te(), B(), W();
	}, [
		W,
		te,
		B
	]), ve = w.useMemo(() => ({
		handleContentChange: se,
		handleResize: ce,
		observeVisibility: le,
		preserveScrollOnPrependRef: b,
		scrollToEnd: H,
		scrollToMessage: ie,
		scrollToStart: U,
		setContentElement: he,
		setRootElement: pe,
		setSpacerElement: ge,
		setViewportElement: me,
		stateStore: A,
		syncAfterScroll: _e,
		unobserveVisibility: ue,
		userScrollIntent: fe,
		viewportRef: j,
		visibilityStore: P
	}), [
		se,
		ce,
		le,
		H,
		ie,
		U,
		he,
		pe,
		ge,
		me,
		A,
		_e,
		ue,
		fe,
		P
	]);
	return w.useLayoutEffect(() => {
		oe();
	}, [oe]), w.useEffect(() => () => {
		k.current !== null && (window.cancelAnimationFrame(k.current), k.current = null), M.current !== null && (window.cancelAnimationFrame(M.current), M.current = null), l.current !== null && (window.clearTimeout(l.current), l.current = null), _.current !== null && (window.cancelAnimationFrame(_.current), _.current = null), N.current?.disconnect(), N.current = null;
	}, []), w.useLayoutEffect(() => {
		if (e && g.current === "following-bottom" && p.current > 0) {
			H({ behavior: "auto" });
			return;
		}
		te();
	}, [
		e,
		te,
		H
	]), {
		context: ve,
		registerMessage: de
	};
}
function Un(e) {
	let t = w.useRef(e);
	return t.current = e, t;
}
var Wn = w.createContext(null), Gn = w.createContext(null);
function Kn() {
	let e = w.useContext(Wn);
	if (!e) throw Error("useMessageScroller must be used within a MessageScroller.");
	return e;
}
function qn() {
	let e = w.useContext(Gn);
	if (!e) throw Error("MessageScrollerItem must be used within a MessageScroller.");
	return e;
}
function Jn() {
	let { scrollToEnd: e, scrollToMessage: t, scrollToStart: n } = Kn();
	return w.useMemo(() => ({
		scrollToEnd: e,
		scrollToMessage: t,
		scrollToStart: n
	}), [
		e,
		t,
		n
	]);
}
function Yn() {
	let { stateStore: e } = Kn();
	return w.useSyncExternalStore(e.subscribe, e.getSnapshot, e.getSnapshot);
}
function Xn() {
	let { observeVisibility: e, unobserveVisibility: t, visibilityStore: n } = Kn(), r = w.useCallback((r) => n.subscribe(r, e, t), [
		e,
		t,
		n
	]);
	return w.useSyncExternalStore(r, n.getSnapshot, n.getSnapshot);
}
function Zn({ autoScroll: e = !1, children: t, defaultScrollPosition: n = "end", scrollEdgeThreshold: r, scrollPreviousItemPeek: i, scrollMargin: a }) {
	let { context: o, registerMessage: s } = Hn({
		autoScroll: e,
		defaultScrollPosition: n,
		scrollEdgeThreshold: r,
		scrollPreviousItemPeek: i,
		scrollMargin: a
	});
	return N(Wn.Provider, {
		value: o,
		children: N(Gn.Provider, {
			value: s,
			children: t
		})
	});
}
function Qn({ children: e, ...t }) {
	let { setRootElement: n } = Kn();
	return N("div", {
		ref: n,
		...t,
		children: e
	});
}
function $n({ "aria-label": e, children: t, onKeyDown: n, onScroll: r, onTouchMove: i, onWheel: a, preserveScrollOnPrepend: o = !0, ref: s, role: c, tabIndex: l, ...u }) {
	let { handleResize: d, preserveScrollOnPrependRef: f, setViewportElement: p, syncAfterScroll: m, userScrollIntent: h, viewportRef: g } = Kn();
	f.current = o;
	let _ = w.useCallback((e) => {
		p(e), sn(s)?.(e);
	}, [s, p]);
	function v(e) {
		m(), r?.(e);
	}
	function y(e) {
		h(), a?.(e);
	}
	function b(e) {
		h(), i?.(e);
	}
	function x(e) {
		pn.has(e.key) && h(), n?.(e);
	}
	return w.useEffect(() => {
		let e = g.current;
		if (!e || typeof ResizeObserver > "u") return;
		let t = 0, n = new ResizeObserver(() => {
			window.cancelAnimationFrame(t), t = window.requestAnimationFrame(d);
		});
		return n.observe(e), () => {
			window.cancelAnimationFrame(t), n.disconnect();
		};
	}, [d, g]), N("div", {
		ref: _,
		role: c ?? "region",
		"aria-label": e ?? "Messages",
		tabIndex: l ?? 0,
		onKeyDown: x,
		onScroll: v,
		onTouchMove: b,
		onWheel: y,
		...u,
		children: t
	});
}
function er({ "aria-relevant": e, children: t, ref: n, role: r, spacerClassName: i, ...a }) {
	let { handleContentChange: o, handleResize: s, setContentElement: c, setSpacerElement: l } = Kn(), u = w.useRef(null), d = w.useCallback((e) => {
		u.current = e, c(e), sn(n)?.(e);
	}, [n, c]);
	return w.useLayoutEffect(() => {
		let e = u.current;
		if (!e || (o(), typeof MutationObserver > "u")) return;
		let t = new MutationObserver(() => {
			o();
		});
		return t.observe(e, { childList: !0 }), () => t.disconnect();
	}, [o]), w.useEffect(() => {
		let e = u.current;
		if (!e || typeof ResizeObserver > "u") return;
		let t = 0, n = new ResizeObserver(() => {
			window.cancelAnimationFrame(t), t = window.requestAnimationFrame(s);
		});
		return n.observe(e), () => {
			window.cancelAnimationFrame(t), n.disconnect();
		};
	}, [s]), P("div", {
		ref: d,
		role: r ?? "log",
		"aria-relevant": e ?? "additions",
		...a,
		children: [t, N("div", {
			ref: l,
			"aria-hidden": "true",
			"data-message-scroller-spacer": "",
			hidden: !0,
			className: i
		})]
	});
}
function tr({ messageId: e, ref: t, scrollAnchor: n = !1, ...r }) {
	let i = qn(), a = w.useRef(null);
	return N("div", {
		ref: w.useCallback((n) => {
			let r = a.current;
			a.current = n, e && i(e, n, r), sn(t)?.(n);
		}, [
			e,
			t,
			i
		]),
		"data-message-id": e,
		"data-scroll-anchor": n ? "true" : "false",
		...r
	});
}
function nr({ behavior: e = "smooth", children: t, direction: n = "end", onClick: r, render: i, tabIndex: a, type: o = "button", ...s }) {
	let { scrollToEnd: c, scrollToStart: l, stateStore: u } = Kn(), d = Un(r), f = w.useCallback((e) => u.subscribe(e), [u]), p = w.useCallback(() => {
		let e = u.getSnapshot();
		return n === "start" ? e.start : e.end;
	}, [n, u]), m = w.useSyncExternalStore(f, p, p), h = w.useCallback((t) => {
		m && (d.current?.(t), t.defaultPrevented || (t.currentTarget.blur(), n === "start" ? l({ behavior: e }) : c({ behavior: e })));
	}, [
		e,
		n,
		m,
		d,
		c,
		l
	]);
	return tn({
		defaultTagName: "button",
		props: nn({
			type: o,
			inert: !m,
			tabIndex: m ? a : -1,
			children: t ?? P("span", { children: ["Scroll to ", n] }),
			onClick: h
		}, s),
		render: i,
		state: {
			active: m,
			direction: n
		},
		stateAttributesMapping: { active: (e) => ({ "data-active": e ? "true" : "false" }) }
	});
}
var rr = {
	Provider: Zn,
	Root: Qn,
	Viewport: $n,
	Content: er,
	Item: tr,
	Button: nr
};
function ir(e) {
	return /* @__PURE__ */ N(rr.Provider, { ...e });
}
function ar({ className: e, ...t }) {
	return /* @__PURE__ */ N(rr.Root, {
		"data-quill": !0,
		"data-slot": "chat-message-scroller",
		className: q("quill-chat-message-scroller group/chat-message-scroller", e),
		...t
	});
}
function or({ className: e, ...t }) {
	return /* @__PURE__ */ N(rr.Viewport, {
		"data-slot": "chat-message-scroller-viewport",
		className: q("quill-chat-message-scroller__viewport", e),
		...t
	});
}
function sr({ className: e, density: t = "default", ...n }) {
	return /* @__PURE__ */ N(rr.Content, {
		"data-slot": "chat-message-scroller-content",
		"data-density": t,
		className: q("quill-chat-message-scroller__content", e),
		...n
	});
}
function cr({ className: e, scrollAnchor: t = !1, ...n }) {
	return /* @__PURE__ */ N(rr.Item, {
		"data-slot": "chat-message-scroller-item",
		scrollAnchor: t,
		className: q("quill-chat-message-scroller__item", e),
		...n
	});
}
function lr({ direction: e = "end", className: t, children: r, render: i, ...a }) {
	return /* @__PURE__ */ N(rr.Button, {
		"data-slot": "chat-message-scroller-button",
		"data-direction": e,
		direction: e,
		className: q("quill-chat-message-scroller__button", t),
		render: i ?? /* @__PURE__ */ N(J, {
			variant: "outline",
			size: "icon"
		}),
		...a,
		children: r ?? /* @__PURE__ */ P(M, { children: [/* @__PURE__ */ N(n, { className: "size-4" }), /* @__PURE__ */ N("span", {
			className: "sr-only",
			children: e === "end" ? "Scroll to end" : "Scroll to start"
		})] })
	});
}
var ur = {
	pending: /* @__PURE__ */ N(h, {}),
	loading: /* @__PURE__ */ N(Bt, {}),
	done: /* @__PURE__ */ N(m, {})
};
function dr({ className: e, ...t }) {
	return /* @__PURE__ */ N("ul", {
		"data-quill": !0,
		"data-slot": "source-list",
		className: q("quill-chat-source-list", e),
		...t
	});
}
function fr({ status: e = "pending", className: t, children: n, href: r, render: i, ...a }) {
	return /* @__PURE__ */ N("li", {
		"data-status": e,
		className: "quill-chat-source-item",
		children: B({
			defaultTagName: r == null ? "span" : "a",
			props: z({
				"data-slot": "source",
				href: r,
				className: q("quill-chat-source", t),
				children: /* @__PURE__ */ P(M, { children: [
					/* @__PURE__ */ N("span", {
						"data-slot": "source-bullet",
						"data-status": e,
						className: "quill-chat-bullet",
						children: /* @__PURE__ */ N(w.Fragment, { children: ur[e] }, e)
					}),
					n,
					r != null && /* @__PURE__ */ N(o, {
						"aria-hidden": "true",
						className: "quill-chat-source__arrow"
					})
				] })
			}, a),
			render: i,
			state: {
				slot: "source",
				status: e
			}
		})
	});
}
function pr({ className: e, ...t }) {
	return /* @__PURE__ */ N("span", {
		"data-slot": "source-title",
		className: q("quill-chat-source__title", e),
		...t
	});
}
function mr({ className: e, ...t }) {
	return /* @__PURE__ */ N("span", {
		"data-slot": "source-url",
		className: q("quill-chat-source__url", e),
		...t
	});
}
function hr({ pinned: e = !1, className: t, children: n, onScroll: r, ...i }) {
	let a = w.useRef(null), o = w.useRef(null), [s, c] = w.useState(e), l = w.useCallback(() => {
		let e = a.current, t = o.current;
		if (!e || !t) return;
		let n = (t, n) => {
			e.toggleAttribute("data-fade-top", t), e.toggleAttribute("data-fade-bottom", n);
		};
		if (s) {
			let r = Math.max(0, t.offsetHeight - e.clientHeight);
			t.style.setProperty("--quill-chat-stream-offset", `${-r}px`), n(r > 0, !1);
			return;
		}
		t.style.setProperty("--quill-chat-stream-offset", "0px"), n(e.scrollTop > 1, e.scrollTop + e.clientHeight < e.scrollHeight - 1);
	}, [s]);
	w.useLayoutEffect(() => {
		let e = o.current;
		if (!e) return;
		let t = new ResizeObserver(l);
		return t.observe(e), () => t.disconnect();
	}, [l]), w.useEffect(() => {
		if (e) {
			c(!0);
			return;
		}
		let t = o.current;
		if (!s || !t) return;
		let n = !1, r = () => {
			n || (n = !0, c(!1));
		}, i = (e) => {
			e.propertyName === "translate" && r();
		};
		t.addEventListener("transitionend", i);
		let a = parseFloat(getComputedStyle(t).transitionDuration) * 1e3 || 0, l = setTimeout(r, a + 50);
		return () => {
			t.removeEventListener("transitionend", i), clearTimeout(l);
		};
	}, [e, s]);
	let u = w.useRef(s);
	return w.useLayoutEffect(() => {
		let e = a.current, t = o.current;
		if (u.current && !s && e && t) {
			let n = Math.max(0, t.offsetHeight - e.clientHeight), r = t.style.transition;
			t.style.transition = "none", t.style.setProperty("--quill-chat-stream-offset", "0px"), e.scrollTop = n, t.offsetHeight, t.style.transition = r;
		}
		u.current = s, l();
	}, [s, l]), /* @__PURE__ */ N("div", {
		ref: a,
		"data-quill": !0,
		"data-slot": "stream",
		"data-pinned": s || void 0,
		onScroll: (e) => {
			l(), r?.(e);
		},
		className: q("quill-chat-stream", t),
		...i,
		children: /* @__PURE__ */ N("div", {
			ref: o,
			"data-slot": "stream-lines",
			className: "quill-chat-stream__lines",
			children: n
		})
	});
}
function gr({ className: e, ...t }) {
	return /* @__PURE__ */ N("p", {
		"data-slot": "stream-line",
		className: q("quill-chat-stream__line", e),
		...t
	});
}
var _r = {
	pending: /* @__PURE__ */ N(h, {}),
	active: /* @__PURE__ */ N(p, {}),
	done: /* @__PURE__ */ N(m, {}),
	failed: /* @__PURE__ */ N(g, {})
}, vr = w.createContext(null);
function yr(e) {
	let t = w.useContext(vr);
	if (!t) throw Error(`${e} must be used within a ChatTaskList`);
	return t;
}
function br({ value: e, total: t, className: n, ...r }) {
	let i = w.useMemo(() => ({
		value: e,
		total: t
	}), [e, t]);
	return /* @__PURE__ */ N(vr.Provider, {
		value: i,
		children: /* @__PURE__ */ N(V.Root, {
			"data-quill": !0,
			"data-slot": "task-list",
			className: q("quill-chat-task-list", n),
			...r
		})
	});
}
function xr({ className: e, children: t, ...n }) {
	return /* @__PURE__ */ N(V.Trigger, {
		"data-slot": "task-list-trigger",
		className: q("quill-chat-row", "quill-chat-row--interactive", "quill-chat-task-list__trigger", e),
		...n,
		children: t
	});
}
function Sr({ className: e, ...t }) {
	let { value: n, total: r } = yr("ChatTaskListProgress"), i = r > 0 && n >= r;
	return /* @__PURE__ */ P("span", {
		"data-slot": "task-list-progress",
		"aria-hidden": "true",
		className: q("quill-chat-swap", "quill-chat-task-list__progress", e),
		...t,
		children: [/* @__PURE__ */ N("span", {
			"data-slot": "task-list-progress-icon",
			"data-status": i ? "done" : void 0,
			className: q("quill-chat-bullet", "quill-chat-swap__icon"),
			children: n <= 0 || r <= 0 ? /* @__PURE__ */ N(v, {}) : i ? /* @__PURE__ */ N(m, {}) : /* @__PURE__ */ N(Cr, {
				value: n,
				total: r
			})
		}), /* @__PURE__ */ N(d, {
			"aria-hidden": "true",
			className: q("quill-chat-chevron", "quill-chat-swap__chevron")
		})]
	});
}
function Cr({ value: e, total: t }) {
	let n = Math.round(Math.min(Math.max(e, 0), t) / t * 100);
	return /* @__PURE__ */ P("svg", {
		viewBox: "0 0 24 24",
		width: "14",
		height: "14",
		fill: "none",
		className: "quill-chat-task-list__ring",
		children: [/* @__PURE__ */ N("circle", {
			className: "quill-chat-task-list__ring-track",
			cx: "12",
			cy: "12",
			r: "10.5",
			stroke: "currentColor",
			strokeWidth: "2.2",
			strokeDasharray: "2.2 4.4",
			strokeLinecap: "round"
		}), /* @__PURE__ */ N("circle", {
			className: "quill-chat-task-list__ring-fill",
			cx: "12",
			cy: "12",
			r: "10.5",
			pathLength: "100",
			stroke: "currentColor",
			strokeWidth: "2.2",
			strokeDasharray: `${n} 100`,
			strokeLinecap: "round"
		})]
	});
}
function wr({ className: e, ...t }) {
	return /* @__PURE__ */ N("span", {
		"data-slot": "task-list-label",
		className: q("quill-chat-task-list__label", e),
		...t
	});
}
function Tr({ className: e, ...t }) {
	let { value: n, total: r } = yr("ChatTaskListCount"), i = `${Math.min(Math.max(n, 0), r)}/${r}`;
	return /* @__PURE__ */ P("span", {
		"data-slot": "task-list-count",
		className: q("quill-chat-task-list__count", e),
		...t,
		children: [/* @__PURE__ */ P("span", {
			className: "sr-only",
			children: [
				Math.min(Math.max(n, 0), r),
				" of ",
				r,
				" done"
			]
		}), /* @__PURE__ */ N("span", {
			"aria-hidden": "true",
			className: "quill-chat-task-list__digits",
			children: i.split("").map((e, t) => /* @__PURE__ */ N(Dr, { char: e }, t))
		})]
	});
}
var Er = 250;
function Dr({ char: e }) {
	let t = w.useRef(e), [n, r] = w.useState(null), i = jt();
	return w.useEffect(() => {
		if (e === t.current) return;
		let n = t.current;
		if (t.current = e, i) return;
		r({
			from: n,
			to: e
		});
		let a = setTimeout(() => r(null), Er);
		return () => clearTimeout(a);
	}, [e, i]), n ? /* @__PURE__ */ N("span", {
		className: "quill-chat-task-list__char",
		children: /* @__PURE__ */ P("span", {
			className: "quill-chat-task-list__char-roll",
			children: [/* @__PURE__ */ N("span", { children: n.from }), /* @__PURE__ */ N("span", { children: n.to })]
		})
	}) : /* @__PURE__ */ N("span", {
		className: "quill-chat-task-list__char",
		children: e
	});
}
function Or({ className: e, children: t, ...n }) {
	return /* @__PURE__ */ N(V.Panel, {
		"data-slot": "task-list-panel",
		className: q("quill-chat-collapse", "quill-chat-rail", "quill-chat-task-list__panel"),
		children: /* @__PURE__ */ N("ol", {
			"data-slot": "task-list-items",
			className: q("quill-chat-task-list__items", e),
			...n,
			children: t
		})
	});
}
function kr({ status: e = "pending", truncate: t = !1, className: n, children: r, ...i }) {
	return /* @__PURE__ */ P("li", {
		"data-slot": "task",
		"data-status": e,
		className: q("quill-chat-task", t && "quill-chat-task--truncate", n),
		...i,
		children: [/* @__PURE__ */ N("span", {
			"data-status": e,
			className: "quill-chat-bullet",
			children: /* @__PURE__ */ N(w.Fragment, { children: _r[e] }, e)
		}), /* @__PURE__ */ N("span", {
			"data-slot": "task-label",
			className: q("quill-chat-task__label", e === "active" && "quill-shimmer"),
			children: r
		})]
	});
}
function Ar({ className: e, ...t }) {
	return /* @__PURE__ */ N("span", {
		"data-slot": "task-detail",
		className: q("quill-chat-task__detail", e),
		...t
	});
}
function jr({ delay: e = 250, ...t }) {
	return /* @__PURE__ */ N(U.Provider, {
		"data-slot": "tooltip-provider",
		delay: e,
		...t
	});
}
function Mr({ ...e }) {
	return /* @__PURE__ */ N(U.Root, {
		"data-slot": "tooltip",
		...e
	});
}
function Nr({ ...e }) {
	return /* @__PURE__ */ N(U.Trigger, {
		"data-slot": "tooltip-trigger",
		...e
	});
}
function Pr({ className: e, side: t = "top", sideOffset: n = 4, align: r = "center", alignOffset: i = 0, children: a, ...o }) {
	return /* @__PURE__ */ N(U.Portal, { children: /* @__PURE__ */ N(U.Positioner, {
		"data-quill": !0,
		"data-quill-portal": "tooltip",
		align: r,
		alignOffset: i,
		side: t,
		sideOffset: n,
		className: "isolate",
		children: /* @__PURE__ */ P(U.Popup, {
			"data-slot": "tooltip-content",
			className: q("quill-tooltip__content inline-flex items-center gap-1.5", e),
			...o,
			children: [a, /* @__PURE__ */ N(U.Arrow, { className: "quill-tooltip__arrow data-[side=bottom]:top-[5px] data-[side=inline-end]:top-1/2! data-[side=inline-end]:-start-1 data-[side=inline-end]:-translate-y-1/2 data-[side=inline-start]:top-1/2! data-[side=inline-start]:-end-1 data-[side=inline-start]:-translate-y-1/2 data-[side=left]:top-1/2! data-[side=left]:-right-[2px] data-[side=left]:-translate-y-1/2 data-[side=right]:top-1/2! data-[side=right]:-left-[2px] data-[side=right]:-translate-y-1/2 data-[side=top]:-bottom-[9px]" })]
		})
	}) });
}
function Fr({ className: e, ...t }) {
	return /* @__PURE__ */ N("div", {
		"data-quill": !0,
		"data-slot": "thread-item-group",
		className: q("quill-thread-item-group", e),
		...t
	});
}
function Ir({ className: e, ...t }) {
	return /* @__PURE__ */ N("article", {
		"data-quill": !0,
		"data-slot": "thread-item",
		className: q("quill-thread-item", e),
		...t
	});
}
function Lr({ className: e, ...t }) {
	return /* @__PURE__ */ N("div", {
		"data-slot": "thread-item-gutter",
		className: q("quill-thread-item__gutter", e),
		...t
	});
}
function Rr({ className: e, ...t }) {
	return /* @__PURE__ */ N("div", {
		"data-slot": "thread-item-content",
		className: q("quill-thread-item__content", e),
		...t
	});
}
function zr({ className: e, ...t }) {
	return /* @__PURE__ */ N("div", {
		"data-slot": "thread-item-header",
		className: q("quill-thread-item__header", e),
		...t
	});
}
function Br({ className: e, render: t, ...n }) {
	return B({
		defaultTagName: "span",
		props: z({
			"data-slot": "thread-item-author",
			className: q("quill-thread-item__author", e)
		}, n),
		render: t,
		state: { slot: "thread-item-author" }
	});
}
function Vr({ className: e, ...t }) {
	return /* @__PURE__ */ N("time", {
		"data-slot": "thread-item-timestamp",
		className: q("quill-thread-item__timestamp", e),
		...t
	});
}
function Hr({ className: e, ...t }) {
	return /* @__PURE__ */ N("div", {
		"data-slot": "thread-item-body",
		className: q("quill-thread-item__body", e),
		...t
	});
}
function Ur({ className: e, render: t, ...n }) {
	return B({
		defaultTagName: "span",
		props: z({
			"data-slot": "thread-item-mention",
			className: q("quill-thread-item__mention", e)
		}, n),
		render: t,
		state: { slot: "thread-item-mention" }
	});
}
function Wr({ className: e, render: t, ...n }) {
	return B({
		defaultTagName: "a",
		props: z({
			"data-slot": "thread-item-link",
			className: q("quill-thread-item__link", e)
		}, n),
		render: t,
		state: { slot: "thread-item-link" }
	});
}
function Gr({ className: e, defaultOpen: t = !0, ...n }) {
	return /* @__PURE__ */ N(V.Root, {
		"data-quill": !0,
		"data-slot": "thread-item-attachment",
		defaultOpen: t,
		className: q("quill-thread-item__attachment", e),
		...n
	});
}
function Kr({ children: e, className: t, ...n }) {
	return /* @__PURE__ */ P(V.Trigger, {
		"data-slot": "thread-item-attachment-trigger",
		className: q("quill-thread-item__attachment-trigger", t),
		...n,
		children: [e, /* @__PURE__ */ N(c, {
			"data-chevron": "down",
			className: "pointer-events-none shrink-0"
		})]
	});
}
function qr({ children: e, className: t, ...n }) {
	return /* @__PURE__ */ N(V.Panel, {
		"data-slot": "thread-item-attachment-content",
		className: "quill-thread-item__attachment-panel",
		...n,
		children: /* @__PURE__ */ N("div", {
			className: q("quill-thread-item__attachment-panel-content", t),
			children: e
		})
	});
}
function Jr({ className: e, alt: t, ...n }) {
	return /* @__PURE__ */ N("img", {
		alt: t,
		"data-slot": "thread-item-attachment-image",
		className: q("quill-thread-item__attachment-image", e),
		...n
	});
}
function Yr({ className: e, "aria-label": t = "Reactions", ...n }) {
	return /* @__PURE__ */ N("div", {
		role: "group",
		"aria-label": t,
		"data-slot": "thread-item-reactions",
		className: q("quill-thread-item__reactions", e),
		...n
	});
}
var Xr = w.forwardRef(function({ className: e, ...t }, n) {
	return /* @__PURE__ */ N(H, {
		ref: n,
		"data-quill": !0,
		"data-slot": "thread-item-reaction",
		className: q("quill-thread-item__reaction", e),
		...t
	});
});
function Zr({ className: e, ...t }) {
	return /* @__PURE__ */ N("span", {
		"aria-hidden": "true",
		"data-slot": "thread-item-reaction-emoji",
		className: q("quill-thread-item__reaction-emoji", e),
		...t
	});
}
var Qr = w.createContext(!1);
function $r({ className: e, "aria-label": t = "Message actions", ...n }) {
	return /* @__PURE__ */ N(Qr.Provider, {
		value: !0,
		children: /* @__PURE__ */ N(jr, { children: /* @__PURE__ */ N(ie.Root, {
			"aria-label": t,
			"data-slot": "thread-item-actions",
			className: q("quill-thread-item__actions", e),
			...n
		}) })
	});
}
var ei = w.forwardRef(function({ label: e, tooltipSide: t = "top", size: n = "icon-sm", children: r, ...i }, a) {
	let o = w.useContext(Qr), s = /* @__PURE__ */ N(J, {
		ref: a,
		"data-slot": "thread-item-action",
		size: n,
		"aria-label": e,
		...i
	});
	return /* @__PURE__ */ P(Mr, { children: [/* @__PURE__ */ N(Nr, {
		render: o ? /* @__PURE__ */ N(ie.Button, { render: s }) : s,
		children: r
	}), /* @__PURE__ */ N(Pr, {
		side: t,
		children: e
	})] });
});
function ti({ className: e, ...t }) {
	return /* @__PURE__ */ N(J, {
		"data-slot": "thread-item-replies",
		left: !0,
		className: q("quill-thread-item__replies", e),
		...t
	});
}
function ni({ className: e, ...t }) {
	return /* @__PURE__ */ N("span", {
		"data-slot": "thread-item-replies-label",
		className: q("quill-thread-item__replies-label", e),
		...t
	});
}
function ri({ className: e, ...t }) {
	return /* @__PURE__ */ N("span", {
		"data-slot": "thread-item-replies-meta",
		className: q("quill-thread-item__replies-meta", e),
		...t
	});
}
var ii = L("quill-button-group", {
	variants: { orientation: {
		horizontal: "",
		vertical: ""
	} },
	defaultVariants: { orientation: "horizontal" }
});
function ai({ className: e, orientation: t = "horizontal", ...n }) {
	return /* @__PURE__ */ N("div", {
		role: "group",
		"data-quill": !0,
		"data-slot": "button-group",
		"data-orientation": t,
		className: q(ii({ orientation: t }), e),
		...n
	});
}
function oi({ className: e, render: t, ...n }) {
	return B({
		defaultTagName: "div",
		props: z({ className: q("quill-button-group__text flex items-center gap-2", e) }, n),
		render: t,
		state: { slot: "button-group-text" }
	});
}
function si({ className: e, orientation: t = "vertical", ...n }) {
	return /* @__PURE__ */ N($e, {
		"data-slot": "button-group-separator",
		orientation: t,
		className: q("quill-button-group__separator", e),
		...n
	});
}
function ci({ className: e, size: t = "default", flush: n = !1, ...r }) {
	return /* @__PURE__ */ N("div", {
		"data-quill": !0,
		"data-slot": "card",
		"data-size": t,
		"data-flush": n ? "" : void 0,
		className: q("quill-card group/card flex flex-col", e),
		...r
	});
}
function li({ className: e, ...t }) {
	return /* @__PURE__ */ N("div", {
		"data-slot": "card-header",
		className: q("quill-card__header group/card-header", e),
		...t
	});
}
var ui = w.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ N("div", {
	ref: n,
	"data-slot": "card-title",
	className: q("quill-card__title", e),
	...t
}));
ui.displayName = "CardTitle";
function di({ className: e, ...t }) {
	return /* @__PURE__ */ N("div", {
		"data-slot": "card-description",
		className: q("quill-card__description", e),
		...t
	});
}
function fi({ className: e, ...t }) {
	return /* @__PURE__ */ N("div", {
		"data-slot": "card-content",
		className: q("quill-card__content", e),
		...t
	});
}
function pi({ className: e, ...t }) {
	return /* @__PURE__ */ N("div", {
		"data-slot": "card-footer",
		className: q("quill-card__footer", e),
		...t
	});
}
function mi({ className: e, size: t = "default", ...n }) {
	return /* @__PURE__ */ N("div", {
		"data-quill": !0,
		"data-slot": "card-group",
		"data-size": t,
		className: q("quill-card-group group/card-group", e),
		...n
	});
}
var hi = L("quill-checkbox-indicator flex shrink-0 items-center justify-center", {
	variants: { size: {
		default: "quill-checkbox-indicator--size-default",
		sm: "quill-checkbox-indicator--size-sm"
	} },
	defaultVariants: { size: "default" }
}), gi = L("", {
	variants: { size: {
		default: "quill-checkbox-icon--size-default",
		sm: "quill-checkbox-icon--size-sm"
	} },
	defaultVariants: { size: "default" }
});
function _i({ checked: e, className: t, size: n = "default" }) {
	return /* @__PURE__ */ N("span", {
		"data-slot": "checkbox-indicator",
		className: q(hi({ size: n }), e && "quill-checkbox-indicator--checked", t),
		children: e && /* @__PURE__ */ N(s, { className: gi({ size: n }) })
	});
}
var vi = L("quill-checkbox peer flex shrink-0 items-center justify-center", {
	variants: { size: {
		default: "quill-checkbox--size-default",
		sm: "quill-checkbox--size-sm"
	} },
	defaultVariants: { size: "default" }
});
function yi({ className: e, size: t = "default", ...n }) {
	return /* @__PURE__ */ N(ae.Root, {
		"data-quill": !0,
		"data-slot": "checkbox",
		className: q(vi({ size: t }), e),
		...n,
		children: /* @__PURE__ */ N(ae.Indicator, {
			"data-slot": "checkbox-primitive-indicator",
			className: "grid place-content-center text-current transition-none",
			children: /* @__PURE__ */ N(_i, {
				checked: !0,
				size: t ?? "default",
				className: "border-none bg-transparent"
			})
		})
	});
}
var bi = w.forwardRef(({ className: e, size: t = "sm", children: n, ...r }, i) => /* @__PURE__ */ N(J, {
	ref: i,
	render: /* @__PURE__ */ N("div", {}),
	"data-quill": !0,
	"data-slot": "chip",
	size: t,
	variant: "outline",
	className: q("quill-chip gap-1", e),
	...r,
	children: n
}));
bi.displayName = "Chip";
var xi = w.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ N(J, {
	ref: r,
	"data-slot": "chip-close",
	size: "icon-xs",
	className: q("quill-chip-close rounded-xs", e),
	...n,
	children: t ?? /* @__PURE__ */ N(C, {})
}));
xi.displayName = "ChipClose";
function Si({ className: e, ...t }) {
	return /* @__PURE__ */ N(ai, {
		"data-slot": "chip-group",
		className: q("flex-wrap gap-0", e),
		...t
	});
}
var Ci = w.createContext("default");
function wi({ variant: e = "default", className: t, ...n }) {
	return /* @__PURE__ */ N(Ci.Provider, {
		value: e,
		children: /* @__PURE__ */ N(V.Root, {
			"data-quill": !0,
			"data-slot": "collapsible",
			"data-variant": e,
			className: q("group/collapsible", e === "default" && "quill-collapsible--variant-default", t),
			...n
		})
	});
}
function Ti({ className: e, ...t }) {
	return /* @__PURE__ */ N("div", {
		"data-slot": "collapsible-header",
		className: q("quill-collapsible__header flex w-full items-center gap-1.5", e),
		...t
	});
}
function Ei({ children: e, className: t, iconOnly: n = !1, icon: r, ...i }) {
	let a = w.useContext(Ci);
	if (n) return /* @__PURE__ */ P(V.Trigger, {
		"data-slot": "collapsible-trigger",
		"data-variant": a,
		className: q("quill-collapsible__trigger quill-collapsible__trigger--icon group/collapsible-trigger", r != null && "quill-collapsible__trigger--swap", t),
		render: /* @__PURE__ */ N(J, { size: "icon-sm" }),
		...i,
		children: [
			r != null && /* @__PURE__ */ N("span", {
				"data-slot": "collapsible-trigger-rest-icon",
				className: "pointer-events-none shrink-0",
				children: r
			}),
			/* @__PURE__ */ N(d, {
				"data-slot": "collapsible-trigger-icon",
				"data-chevron": "right",
				className: "pointer-events-none shrink-0"
			}),
			e != null && /* @__PURE__ */ N("span", {
				className: "sr-only",
				children: e
			})
		]
	});
	let o = /* @__PURE__ */ P(M, { children: [/* @__PURE__ */ N(c, {
		"data-slot": "collapsible-trigger-icon",
		"data-chevron": "down",
		className: "pointer-events-none shrink-0"
	}), /* @__PURE__ */ N(f, {
		"data-slot": "collapsible-trigger-icon",
		"data-chevron": "up",
		className: "pointer-events-none shrink-0"
	})] });
	return /* @__PURE__ */ P(V.Trigger, {
		"data-slot": "collapsible-trigger",
		"data-variant": a,
		className: q("quill-collapsible__trigger group/collapsible-trigger flex items-center gap-2 justify-start", a === "folder" && "quill-collapsible__trigger--variant-folder", t),
		render: /* @__PURE__ */ N(J, { size: "sm" }),
		...i,
		children: [
			a === "folder" && o,
			e,
			a === "default" && o
		]
	});
}
function Di({ children: e, className: t, ...n }) {
	let r = w.useContext(Ci);
	return /* @__PURE__ */ N(V.Panel, {
		"data-slot": "collapsible-content",
		className: "quill-collapsible__panel",
		...n,
		children: /* @__PURE__ */ N("div", {
			className: q("quill-collapsible__panel-content", r === "folder" && "quill-collapsible__panel-content--variant-folder", t),
			children: e
		})
	});
}
var Oi = w.createContext(null);
function ki({ children: e, ...t }) {
	let n = w.useRef(null);
	return /* @__PURE__ */ N(Oi.Provider, {
		value: n,
		children: /* @__PURE__ */ N(W.Root, {
			...t,
			children: e
		})
	});
}
function Ai({ ...e }) {
	return /* @__PURE__ */ N(W.Value, {
		"data-slot": "combobox-value",
		...e
	});
}
var ji = w.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ P(W.Trigger, {
	ref: r,
	"data-slot": "combobox-trigger",
	className: q("quill-combobox__trigger", e),
	...n,
	children: [t, /* @__PURE__ */ N(c, { className: "pointer-events-none size-3.5 text-muted-foreground" })]
}));
ji.displayName = "ComboboxTrigger";
function Mi({ className: e, ...t }) {
	return /* @__PURE__ */ N(W.Clear, {
		"data-slot": "combobox-clear",
		render: /* @__PURE__ */ N(Ke, { size: "icon-xs" }),
		className: q(e),
		...t,
		children: /* @__PURE__ */ N(C, { className: "pointer-events-none" })
	});
}
function Ni({ className: e, children: t, disabled: n = !1, showTrigger: r = !0, showClear: i = !1, ...a }) {
	return /* @__PURE__ */ N("div", {
		"data-slot": "combobox-input-group-wrapper",
		children: /* @__PURE__ */ P(He, {
			ref: w.useContext(Oi),
			className: q("w-auto", e),
			children: [
				/* @__PURE__ */ N(W.Input, {
					render: /* @__PURE__ */ N(Je, { disabled: n }),
					...a
				}),
				/* @__PURE__ */ P(We, {
					align: "inline-end",
					children: [r && /* @__PURE__ */ N(Ke, {
						size: "icon-xs",
						render: /* @__PURE__ */ N(ji, {}),
						"data-slot": "input-group-button",
						className: "group-has-data-[slot=combobox-clear]/input-group:hidden data-pressed:bg-transparent rounded-xs",
						disabled: n
					}), i && /* @__PURE__ */ N(Mi, { disabled: n })]
				}),
				t
			]
		})
	});
}
function Pi({ className: e, side: t = "bottom", sideOffset: n = 6, align: r = "start", alignOffset: i = 0, anchor: a, ...o }) {
	let s = w.useContext(Oi), c = a ?? s;
	return /* @__PURE__ */ N(W.Portal, { children: /* @__PURE__ */ N(W.Positioner, {
		"data-quill": !0,
		"data-quill-portal": "popover",
		side: t,
		sideOffset: n,
		align: r,
		alignOffset: i,
		anchor: c,
		className: "isolate",
		children: /* @__PURE__ */ N(W.Popup, {
			"data-slot": "combobox-content",
			"data-chips": !!c,
			className: q("quill-combobox__content group/combobox-content", e),
			...o
		})
	}) });
}
function Fi({ className: e, ...t }) {
	return /* @__PURE__ */ N(W.List, {
		"data-slot": "combobox-list",
		className: q("quill-combobox__list scroll-mask-t-4 scroll-py-4", "not-has-[[data-slot=combobox-list-footer]]:scroll-mask-b-4", e),
		...t
	});
}
function Ii({ className: e, children: t, title: n, ...r }) {
	return /* @__PURE__ */ P(W.Item, {
		"data-slot": "combobox-item",
		className: q("quill-combobox__item", e),
		title: n ?? (typeof t == "string" ? t : void 0),
		nativeButton: !("render" in r),
		render: /* @__PURE__ */ N(J, {
			left: !0,
			className: "min-w-0 aria-selected:bg-fill-selected"
		}),
		...r,
		children: [/* @__PURE__ */ N("span", {
			className: "flex items-center gap-1.5 min-w-0 truncate",
			children: t
		}), /* @__PURE__ */ N(W.ItemIndicator, {
			render: /* @__PURE__ */ N("span", { className: "pointer-events-none absolute start-2 flex items-center justify-center" }),
			children: /* @__PURE__ */ N(s, { className: "pointer-events-none" })
		})]
	});
}
function Li({ className: e, ...t }) {
	return /* @__PURE__ */ N(W.Group, {
		"data-slot": "combobox-group",
		className: q(e),
		...t
	});
}
function Ri({ className: e, ...t }) {
	return /* @__PURE__ */ N(W.GroupLabel, {
		"data-slot": "combobox-label",
		className: e,
		render: /* @__PURE__ */ N(Qe, {}),
		...t
	});
}
function zi({ ...e }) {
	return /* @__PURE__ */ N(W.Collection, {
		"data-slot": "combobox-collection",
		...e
	});
}
function Bi({ className: e, children: t, ...n }) {
	return /* @__PURE__ */ N(W.Empty, {
		"data-slot": "combobox-empty",
		className: q("hidden group-data-empty/combobox-content:flex", e),
		...n,
		render: /* @__PURE__ */ N(Ze, { children: t })
	});
}
function Vi({ className: e, ...t }) {
	return /* @__PURE__ */ N(W.Separator, {
		"data-slot": "combobox-separator",
		className: q("quill-combobox__separator", e),
		...t
	});
}
function Hi({ className: e, ...t }) {
	return /* @__PURE__ */ N(W.Chips, {
		"data-slot": "combobox-chips",
		className: q("quill-combobox__chips flex flex-wrap items-center gap-1 py-1", e),
		...t
	});
}
function Ui({ className: e, children: t, title: n, showRemove: r = !0, ...i }) {
	return /* @__PURE__ */ P(W.Chip, {
		render: /* @__PURE__ */ N(bi, { title: n ?? (typeof t == "string" ? t : void 0) }),
		"data-slot": "combobox-chip",
		className: q(e),
		...i,
		children: [/* @__PURE__ */ N("span", {
			className: "truncate flex-1",
			children: t
		}), r && /* @__PURE__ */ N(W.ChipRemove, {
			render: /* @__PURE__ */ N(xi, {}),
			children: /* @__PURE__ */ N(C, { className: "pointer-events-none" })
		})]
	});
}
function Wi({ className: e, ...t }) {
	return /* @__PURE__ */ N(W.Input, {
		"data-slot": "combobox-chip-input",
		className: q("quill-combobox__chips-input", e),
		...t
	});
}
function Gi({ className: e, ...t }) {
	return /* @__PURE__ */ N("div", {
		"data-slot": "combobox-list-footer",
		className: q("quill-combobox__list-footer quill-scroll-fade-top", e),
		children: /* @__PURE__ */ N("div", {
			className: "p-1",
			...t
		})
	});
}
function Ki() {
	let e = w.useContext(Oi);
	if (e === null) throw Error("useComboboxAnchor must be used within a Combobox");
	return e;
}
function qi({ className: e, ...t }) {
	return /* @__PURE__ */ N("kbd", {
		"data-quill": !0,
		"data-slot": "kbd",
		className: q(ze({
			variant: "outline",
			size: "xs"
		}), "quill-kbd inline-flex w-fit items-center justify-center gap-1", e),
		...t
	});
}
function Ji({ className: e, ...t }) {
	return /* @__PURE__ */ N("kbd", {
		"data-slot": "kbd-text",
		className: q("quill-kbd-text inline-flex w-fit items-center justify-center gap-1", e),
		...t
	});
}
function Yi({ className: e, ...t }) {
	return /* @__PURE__ */ N("kbd", {
		"data-slot": "kbd-group",
		className: q("inline-flex items-center gap-1", e),
		...t
	});
}
var Xi = L("quill-radio-indicator", {
	variants: { size: {
		default: "quill-radio-indicator--size-default",
		sm: "quill-radio-indicator--size-sm"
	} },
	defaultVariants: { size: "default" }
}), Zi = L("quill-radio-dot", {
	variants: { size: {
		default: "quill-radio-dot--size-default",
		sm: "quill-radio-dot--size-sm"
	} },
	defaultVariants: { size: "default" }
});
function Qi({ checked: e, className: t, size: n = "default" }) {
	return /* @__PURE__ */ N("span", {
		"data-slot": "radio-indicator",
		className: q(Xi({ size: n }), e && "quill-radio-indicator--checked", t),
		children: e && /* @__PURE__ */ N("span", { className: Zi({ size: n }) })
	});
}
function $i({ className: e, ...t }) {
	return /* @__PURE__ */ N(se, {
		"data-quill": !0,
		"data-slot": "radio-group",
		className: q("grid w-full gap-3", e),
		...t
	});
}
var ea = L("quill-radio group/radio-group-item peer", {
	variants: { size: {
		default: "quill-radio--size-default",
		sm: "quill-radio--size-sm"
	} },
	defaultVariants: { size: "default" }
}), ta = L("quill-radio__indicator", {
	variants: { size: {
		default: "quill-radio__indicator--size-default",
		sm: "quill-radio__indicator--size-sm"
	} },
	defaultVariants: { size: "default" }
});
function na({ className: e, size: t = "default", ...n }) {
	return /* @__PURE__ */ N(oe.Root, {
		"data-slot": "radio-group-item",
		className: q(ea({ size: t }), e),
		...n,
		children: /* @__PURE__ */ N(oe.Indicator, {
			"data-slot": "radio-group-indicator",
			className: ta({ size: t }),
			children: /* @__PURE__ */ N("span", { className: Zi({ size: t }) })
		})
	});
}
function ra({ ...e }) {
	return /* @__PURE__ */ N(G.Root, {
		"data-slot": "context-menu",
		...e
	});
}
function ia({ ...e }) {
	return /* @__PURE__ */ N(G.Portal, {
		"data-slot": "context-menu-portal",
		...e
	});
}
function aa({ className: e, ...t }) {
	return /* @__PURE__ */ N(G.Trigger, {
		"data-slot": "context-menu-trigger",
		className: q("select-none", e),
		...t
	});
}
function oa({ className: e, align: t = "start", alignOffset: n = 4, side: r = "inline-end", sideOffset: i = 0, children: a, ...o }) {
	return /* @__PURE__ */ N(G.Portal, { children: /* @__PURE__ */ N(G.Positioner, {
		"data-quill": !0,
		"data-quill-portal": "popover",
		className: "isolate outline-none",
		align: t,
		alignOffset: n,
		side: r,
		sideOffset: i,
		children: /* @__PURE__ */ N(G.Popup, {
			"data-slot": "context-menu-content",
			className: q("quill-menu__content", e),
			...o,
			children: /* @__PURE__ */ N("div", {
				className: "quill-menu__scroller scroll-mask-y-4 scroll-py-4",
				children: a
			})
		})
	}) });
}
function sa({ ...e }) {
	return /* @__PURE__ */ N(G.Group, {
		"data-slot": "context-menu-group",
		...e
	});
}
function ca({ className: e, inset: t, ...n }) {
	return /* @__PURE__ */ N(G.GroupLabel, {
		"data-slot": "context-menu-label",
		"data-inset": t,
		className: q("px-2 py-1.5 text-xs text-muted-foreground", t && "quill-menu-item--inset", e),
		...n
	});
}
function la({ className: e, inset: t, variant: n = "default", children: r, ...i }) {
	return /* @__PURE__ */ N(G.Item, {
		"data-slot": "context-menu-item",
		"data-inset": t,
		"data-variant": n,
		className: q("group/context-menu-item relative flex cursor-default items-center outline-hidden select-none data-disabled:pointer-events-none data-disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-3.5", t && "quill-menu-item--inset", e),
		nativeButton: !("render" in i),
		render: /* @__PURE__ */ N(J, {
			variant: n,
			className: "w-full font-normal",
			left: !0
		}),
		...i,
		children: r
	});
}
function ua({ ...e }) {
	return /* @__PURE__ */ N(G.SubmenuRoot, {
		"data-slot": "context-menu-sub",
		...e
	});
}
function da({ className: e, inset: t, children: n, ...r }) {
	return /* @__PURE__ */ P(G.SubmenuTrigger, {
		"data-slot": "context-menu-sub-trigger",
		"data-inset": t,
		className: q("flex cursor-default items-center outline-hidden select-none [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-3.5", t && "quill-menu-item--inset", e),
		nativeButton: !("render" in r),
		render: /* @__PURE__ */ N(J, {
			className: "w-full font-normal",
			left: !0
		}),
		...r,
		children: [n, /* @__PURE__ */ N(d, { className: "rtl:rotate-180 ms-auto" })]
	});
}
function fa({ className: e, align: t = "start", alignOffset: n = -3, side: r = "inline-end", sideOffset: i = 0, ...a }) {
	return /* @__PURE__ */ N(oa, {
		"data-slot": "context-menu-sub-content",
		className: q("quill-menu__sub-content w-auto", e),
		align: t,
		alignOffset: n,
		side: r,
		sideOffset: i,
		...a
	});
}
function pa({ className: e, children: t, checked: n, inset: r, ...i }) {
	return /* @__PURE__ */ P(G.CheckboxItem, {
		"data-slot": "context-menu-checkbox-item",
		"data-inset": r,
		className: q("quill-menu-item--inset relative flex cursor-default items-center pe-2 text-xs outline-hidden select-none data-disabled:pointer-events-none data-disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-3.5", e),
		nativeButton: !("render" in i),
		render: /* @__PURE__ */ N(J, {
			className: "w-full font-normal",
			left: !0
		}),
		checked: n,
		...i,
		children: [/* @__PURE__ */ P("span", {
			className: "pointer-events-none absolute start-2 flex items-center justify-center",
			children: [/* @__PURE__ */ N(yi, {
				size: "sm",
				tabIndex: -1
			}), /* @__PURE__ */ N(G.CheckboxItemIndicator, {
				className: "absolute",
				children: /* @__PURE__ */ N(yi, {
					size: "sm",
					checked: !0,
					tabIndex: -1
				})
			})]
		}), t]
	});
}
function ma({ ...e }) {
	return /* @__PURE__ */ N(G.RadioGroup, {
		"data-slot": "context-menu-radio-group",
		...e
	});
}
function ha({ className: e, children: t, inset: n, ...r }) {
	return /* @__PURE__ */ P(G.RadioItem, {
		"data-slot": "context-menu-radio-item",
		"data-inset": n,
		className: q("quill-menu-item--inset relative flex cursor-default items-center pe-2 outline-hidden select-none data-disabled:pointer-events-none data-disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-3.5", e),
		nativeButton: !("render" in r),
		render: /* @__PURE__ */ N(J, {
			className: "w-full font-normal",
			left: !0
		}),
		...r,
		children: [/* @__PURE__ */ P("span", {
			className: "pointer-events-none absolute start-2 flex items-center justify-center",
			children: [/* @__PURE__ */ N(Qi, { size: "sm" }), /* @__PURE__ */ N(G.RadioItemIndicator, {
				className: "absolute",
				children: /* @__PURE__ */ N(Qi, {
					size: "sm",
					checked: !0
				})
			})]
		}), t]
	});
}
function ga({ className: e, ...t }) {
	return /* @__PURE__ */ N(G.Separator, {
		"data-slot": "context-menu-separator",
		className: q("quill-menu__separator", e),
		...t
	});
}
function _a({ className: e, ...t }) {
	return /* @__PURE__ */ N(qi, {
		"data-slot": "context-menu-shortcut",
		className: q("quill-menu__shortcut", e),
		...t
	});
}
var va = [
	"top",
	"right",
	"bottom",
	"left"
];
function ya(e) {
	return e ? e === "all" ? va : Array.isArray(e) ? e : [e] : [];
}
var ba = {
	top: {
		label: "Scroll to top",
		Icon: a,
		positionClasses: "top-2 left-1/2 -translate-x-1/2",
		visibleClasses: "group-data-[overflow-y-start]/scroll-area:opacity-100 group-data-[overflow-y-start]/scroll-area:scale-100 group-data-[overflow-y-start]/scroll-area:pointer-events-auto",
		getScrollTarget: () => ({ top: 0 })
	},
	bottom: {
		label: "Scroll to bottom",
		Icon: t,
		positionClasses: "bottom-2 left-1/2 -translate-x-1/2",
		visibleClasses: "group-data-[overflow-y-end]/scroll-area:opacity-100 group-data-[overflow-y-end]/scroll-area:scale-100 group-data-[overflow-y-end]/scroll-area:pointer-events-auto",
		getScrollTarget: (e) => ({ top: e.scrollHeight })
	},
	left: {
		label: "Scroll to start",
		Icon: r,
		positionClasses: "left-2 top-1/2 -translate-y-1/2 not-disabled:active:-translate-y-1/2",
		visibleClasses: "group-data-[overflow-x-start]/scroll-area:opacity-100 group-data-[overflow-x-start]/scroll-area:scale-100 group-data-[overflow-x-start]/scroll-area:pointer-events-auto",
		getScrollTarget: () => ({ left: 0 })
	},
	right: {
		label: "Scroll to end",
		Icon: i,
		positionClasses: "right-2 top-1/2 -translate-y-1/2 not-disabled:active:-translate-y-1/2",
		visibleClasses: "group-data-[overflow-x-end]/scroll-area:opacity-100 group-data-[overflow-x-end]/scroll-area:scale-100 group-data-[overflow-x-end]/scroll-area:pointer-events-auto",
		getScrollTarget: (e) => ({ left: e.scrollWidth })
	}
};
function xa({ edge: e, viewportRef: t }) {
	let n = ba[e], { Icon: r } = n;
	return /* @__PURE__ */ N(J, {
		type: "button",
		size: "icon",
		variant: "outline",
		"aria-label": n.label,
		onClick: () => {
			let e = t.current;
			if (!e) return;
			let r = typeof window < "u" && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
			e.scrollTo({
				...n.getScrollTarget(e),
				behavior: r ? "auto" : "smooth"
			});
		},
		className: q("bg-background not-disabled:hover:bg-fill-hover absolute z-10 grid place-items-center rounded-full shadow-md", "opacity-0 scale-95 pointer-events-none", "transition-[opacity,transform,background-color] duration-150 ease-out", "motion-reduce:transition-none", "focus-visible:opacity-100 focus-visible:scale-100 focus-visible:pointer-events-auto", n.positionClasses, n.visibleClasses),
		children: /* @__PURE__ */ N(r, { className: "size-4" })
	});
}
var Sa = "quill-scroll-area-shadows", Ca = "\n[data-component=\"scroll-area\"][data-scroll-shadows=\"true\"] {\n    --shadow-x-start: 0 0 0 0 transparent;\n    --shadow-x-end: 0 0 0 0 transparent;\n    --shadow-y-start: 0 0 0 0 transparent;\n    --shadow-y-end: 0 0 0 0 transparent;\n}\n[data-component=\"scroll-area\"][data-scroll-shadows=\"true\"][data-overflow-x-start] {\n    --shadow-x-start: 16px 0 16px -16px rgb(0 0 0 / 25%);\n}\n[data-component=\"scroll-area\"][data-scroll-shadows=\"true\"][data-overflow-x-end] {\n    --shadow-x-end: -16px 0 16px -16px rgb(0 0 0 / 25%);\n}\n[data-component=\"scroll-area\"][data-scroll-shadows=\"true\"][data-overflow-y-start] {\n    --shadow-y-start: 0 16px 16px -16px rgb(0 0 0 / 25%);\n}\n[data-component=\"scroll-area\"][data-scroll-shadows=\"true\"][data-overflow-y-end] {\n    --shadow-y-end: 0 -16px 16px -16px rgb(0 0 0 / 25%);\n}\n[data-component=\"scroll-area\"][data-scroll-shadows=\"true\"]::before,\n[data-component=\"scroll-area\"][data-scroll-shadows=\"true\"]::after {\n    content: '';\n    position: absolute;\n    inset: 0;\n    pointer-events: none;\n    z-index: 2;\n    border-radius: inherit;\n    transition: box-shadow 200ms ease;\n}\n[data-component=\"scroll-area\"][data-scroll-shadows=\"true\"]::before {\n    box-shadow: var(--shadow-x-start) inset, var(--shadow-y-start) inset;\n}\n[data-component=\"scroll-area\"][data-scroll-shadows=\"true\"]::after {\n    box-shadow: var(--shadow-x-end) inset, var(--shadow-y-end) inset;\n}\n.dark [data-component=\"scroll-area\"][data-scroll-shadows=\"true\"][data-overflow-x-start] {\n    --shadow-x-start: 28px 0 24px -16px rgb(0 0 0 / 100%);\n}\n.dark [data-component=\"scroll-area\"][data-scroll-shadows=\"true\"][data-overflow-x-end] {\n    --shadow-x-end: -28px 0 24px -16px rgb(0 0 0 / 100%);\n}\n.dark [data-component=\"scroll-area\"][data-scroll-shadows=\"true\"][data-overflow-y-start] {\n    --shadow-y-start: 0 28px 24px -16px rgb(0 0 0 / 100%);\n}\n.dark [data-component=\"scroll-area\"][data-scroll-shadows=\"true\"][data-overflow-y-end] {\n    --shadow-y-end: 0 -28px 24px -16px rgb(0 0 0 / 100%);\n}\n";
if (typeof document < "u" && !document.getElementById("quill-scroll-area-shadows")) {
	let e = document.createElement("style");
	e.id = Sa, e.textContent = Ca, document.head.appendChild(e);
}
function wa({ className: e, children: t, scrollShadows: n = !0, hideScrollbars: r = !1, alwaysShowScrollbars: i = !1, showScrollToButton: a, viewportClassName: o, ...s }) {
	let c = w.useRef(null), l = ya(a);
	return typeof process < "u" && process.env.NODE_ENV !== "production" && r && i && console.warn("[ScrollArea] `hideScrollbars` and `alwaysShowScrollbars` are mutually exclusive; `alwaysShowScrollbars` will be ignored."), /* @__PURE__ */ P(le.Root, {
		"data-quill": !0,
		"data-slot": "scroll-area",
		"data-component": "scroll-area",
		"data-scroll-shadows": n,
		className: q("quill-scroll-area group/scroll-area", e),
		...s,
		children: [
			/* @__PURE__ */ N(le.Viewport, {
				ref: c,
				"data-slot": "scroll-area-viewport",
				className: q("quill-scroll-area__viewport", o),
				children: t
			}),
			!r && /* @__PURE__ */ P(M, { children: [
				/* @__PURE__ */ N(Ta, {
					orientation: "horizontal",
					alwaysVisible: i
				}),
				/* @__PURE__ */ N(Ta, {
					orientation: "vertical",
					alwaysVisible: i
				}),
				/* @__PURE__ */ N(le.Corner, {
					"data-slot": "scroll-area-corner",
					className: "quill-scroll-area__corner"
				})
			] }),
			l.map((e) => /* @__PURE__ */ N(xa, {
				edge: e,
				viewportRef: c
			}, e))
		]
	});
}
function Ta({ className: e, orientation: t = "vertical", alwaysVisible: n = !1, ...r }) {
	return /* @__PURE__ */ N(le.Scrollbar, {
		"data-slot": "scroll-area-scrollbar",
		"data-orientation": t,
		orientation: t,
		className: q("quill-scroll-area__scrollbar group/scrollbar flex", n ? "quill-scroll-area__scrollbar--always" : "quill-scroll-area__scrollbar--auto", e),
		...r,
		children: /* @__PURE__ */ N(le.Thumb, {
			"data-slot": "scroll-area-thumb",
			className: "quill-scroll-area__thumb"
		})
	});
}
function Ea({ ...e }) {
	return /* @__PURE__ */ N(ce.Root, {
		"data-slot": "dialog",
		...e
	});
}
function Da({ ...e }) {
	return /* @__PURE__ */ N(ce.Trigger, {
		"data-slot": "dialog-trigger",
		...e
	});
}
function Oa({ ...e }) {
	return /* @__PURE__ */ N(ce.Portal, {
		"data-slot": "dialog-portal",
		...e
	});
}
function ka({ ...e }) {
	return /* @__PURE__ */ N(ce.Close, {
		"data-slot": "dialog-close focus-visible:z-10",
		...e
	});
}
function Aa({ className: e, ...t }) {
	return /* @__PURE__ */ N(ce.Backdrop, {
		"data-quill": !0,
		"data-quill-portal": "modal-overlay",
		"data-slot": "dialog-overlay",
		className: q("quill-dialog__overlay", e),
		...t
	});
}
function ja({ className: e, children: t, showCloseButton: n = !0, nested: r = !1, size: i, ...a }) {
	return /* @__PURE__ */ P(Oa, { children: [/* @__PURE__ */ N(Aa, {}), /* @__PURE__ */ P(ce.Popup, {
		"data-quill": !0,
		"data-quill-portal": "modal-content",
		"data-slot": "dialog-content",
		"data-size": i,
		className: q("quill-dialog__content grid", e),
		...a,
		children: [t, n && /* @__PURE__ */ P(ce.Close, {
			"data-slot": "dialog-close",
			render: /* @__PURE__ */ N(J, {
				className: "absolute top-2 end-2",
				size: "icon-sm"
			}),
			children: [/* @__PURE__ */ N(C, {}), /* @__PURE__ */ N("span", {
				className: "sr-only",
				children: "Close"
			})]
		})]
	})] });
}
function Ma({ className: e, ...t }) {
	return /* @__PURE__ */ N("div", {
		"data-slot": "dialog-header",
		className: q("quill-dialog__header flex flex-col gap-1", e),
		...t
	});
}
function Na({ className: e, showCloseButton: t = !1, children: n, ...r }) {
	return /* @__PURE__ */ P("div", {
		"data-slot": "dialog-footer",
		className: q("quill-dialog__footer flex flex-col-reverse gap-2 sm:flex-row sm:justify-end", e),
		...r,
		children: [n, t && /* @__PURE__ */ N(ce.Close, {
			render: /* @__PURE__ */ N(J, { variant: "outline" }),
			children: "Close"
		})]
	});
}
function Pa({ className: e, render: t, children: n, viewportClassName: r, ...i }) {
	let a = t ?? /* @__PURE__ */ N(wa, {
		"data-slot": "dialog-body",
		className: q("quill-dialog__body", e),
		viewportClassName: r
	});
	return B({
		defaultTagName: "div",
		props: z({
			className: q("quill-dialog__body", e),
			children: n
		}, i),
		render: a,
		state: { slot: "dialog-body" }
	});
}
function Fa({ className: e, ...t }) {
	return /* @__PURE__ */ N(ce.Title, {
		"data-slot": "dialog-title",
		className: q("quill-dialog__title", e),
		...t
	});
}
function Ia({ className: e, ...t }) {
	return /* @__PURE__ */ N(ce.Description, {
		"data-slot": "dialog-description",
		className: q("quill-dialog__description", e),
		...t
	});
}
var La = L("quill-dot relative inline-flex p-0.5 shrink-0 items-center justify-center whitespace-nowrap", {
	variants: {
		variant: {
			default: "quill-dot--variant-default",
			info: "quill-dot--variant-info",
			destructive: "quill-dot--variant-destructive",
			warning: "quill-dot--variant-warning",
			success: "quill-dot--variant-success"
		},
		pulse: {
			true: "quill-dot--pulse",
			false: ""
		}
	},
	defaultVariants: { variant: "default" }
});
function Ra({ className: e, variant: t = "default", pulse: n = !1, ...r }) {
	return /* @__PURE__ */ P("span", {
		"data-quill": !0,
		"data-slot": "dot",
		className: q(La({
			variant: t,
			pulse: n
		}), e),
		...r,
		children: [n && /* @__PURE__ */ N("span", {
			"aria-hidden": !0,
			"data-slot": "dot-pulse",
			className: "quill-dot__pulse pointer-events-none absolute inset-px"
		}), /* @__PURE__ */ N("span", {
			"data-slot": "dot-inner",
			className: "quill-dot__inner"
		})]
	});
}
function za({ ...e }) {
	return /* @__PURE__ */ N(fe.Root, {
		"data-slot": "drawer",
		...e
	});
}
function Ba({ ...e }) {
	return /* @__PURE__ */ N(fe.Trigger, {
		"data-slot": "drawer-trigger",
		...e
	});
}
function Va({ ...e }) {
	return /* @__PURE__ */ N(fe.Portal, {
		"data-slot": "drawer-portal",
		...e
	});
}
function Ha({ ...e }) {
	return /* @__PURE__ */ N(fe.Close, {
		"data-slot": "drawer-close",
		...e
	});
}
function Ua({ className: e, ...t }) {
	return /* @__PURE__ */ N(fe.Backdrop, {
		"data-quill": !0,
		"data-quill-portal": "drawer-backdrop",
		"data-slot": "drawer-backdrop",
		className: q("quill-drawer__backdrop", e),
		...t
	});
}
function Wa({ className: e, children: t, ...n }) {
	return /* @__PURE__ */ P(Va, { children: [/* @__PURE__ */ N(Ua, {}), /* @__PURE__ */ N(fe.Viewport, {
		"data-quill": !0,
		"data-quill-portal": "drawer-viewport",
		"data-slot": "drawer-viewport",
		className: "quill-drawer__viewport",
		children: /* @__PURE__ */ P(fe.Popup, {
			"data-quill": !0,
			"data-slot": "drawer-content",
			className: q("quill-drawer__content group/drawer-content flex h-auto flex-col", e),
			...n,
			children: [/* @__PURE__ */ N(Ga, {}), /* @__PURE__ */ N("div", {
				className: "w-full max-w-[32rem] mx-auto",
				children: t
			})]
		})
	})] });
}
function Ga({ className: e, ...t }) {
	return /* @__PURE__ */ N("div", {
		"data-slot": "drawer-handle",
		"aria-hidden": "true",
		className: q("quill-drawer__handle", e),
		...t
	});
}
function Ka({ className: e, ...t }) {
	return /* @__PURE__ */ N("div", {
		"data-slot": "drawer-header",
		className: q("quill-drawer__header flex flex-col gap-1 p-4", e),
		...t
	});
}
function qa({ className: e, ...t }) {
	return /* @__PURE__ */ N("div", {
		"data-slot": "drawer-footer",
		className: q("quill-drawer__footer mt-auto flex flex-col gap-2 p-4", e),
		...t
	});
}
function Ja({ className: e, ...t }) {
	return /* @__PURE__ */ N(fe.Title, {
		"data-slot": "drawer-title",
		className: q("quill-drawer__title", e),
		...t
	});
}
function Ya({ className: e, ...t }) {
	return /* @__PURE__ */ N(fe.Description, {
		"data-slot": "drawer-description",
		className: q("quill-drawer__description", e),
		...t
	});
}
function Xa({ ...e }) {
	return /* @__PURE__ */ N(K.Root, {
		"data-slot": "dropdown-menu",
		...e
	});
}
function Za({ ...e }) {
	return /* @__PURE__ */ N(K.Portal, {
		"data-slot": "dropdown-menu-portal",
		...e
	});
}
function Qa({ ...e }) {
	return /* @__PURE__ */ N(K.Trigger, {
		"data-slot": "dropdown-menu-trigger",
		...e
	});
}
function $a({ align: e = "start", alignOffset: t = 0, side: n = "bottom", sideOffset: r = 4, className: i, anchor: a, children: o, ...s }) {
	return /* @__PURE__ */ N(K.Portal, { children: /* @__PURE__ */ N(K.Positioner, {
		"data-quill": !0,
		"data-quill-portal": "popover",
		className: "isolate outline-none",
		align: e,
		alignOffset: t,
		side: n,
		sideOffset: r,
		anchor: a,
		children: /* @__PURE__ */ N(K.Popup, {
			"data-slot": "dropdown-menu-content",
			className: q("quill-menu__content w-(--anchor-width)", i),
			...s,
			children: /* @__PURE__ */ N("div", {
				className: "quill-menu__scroller scroll-mask-y-4 scroll-py-4",
				children: o
			})
		})
	}) });
}
function eo({ ...e }) {
	return /* @__PURE__ */ N(K.Group, {
		"data-slot": "dropdown-menu-group",
		...e
	});
}
function to({ className: e, inset: t, ...n }) {
	return /* @__PURE__ */ N(K.GroupLabel, {
		"data-slot": "dropdown-menu-label",
		"data-inset": t,
		className: q(t && "quill-menu-item--inset", e),
		render: /* @__PURE__ */ N(Qe, {}),
		...n
	});
}
function no({ className: e, inset: t, variant: n = "default", ...r }) {
	return /* @__PURE__ */ N(K.Item, {
		"data-slot": "dropdown-menu-item",
		"data-inset": t,
		"data-variant": n,
		className: q("group/dropdown-menu-item relative flex cursor-default items-center text-xs/relaxed outline-hidden select-none data-disabled:pointer-events-none data-disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-3.5", t && "quill-menu-item--inset", e),
		nativeButton: !("render" in r),
		render: /* @__PURE__ */ N(J, {
			variant: n,
			className: "w-full font-normal [&_kbd]:ml-auto",
			left: !0
		}),
		...r
	});
}
function ro({ ...e }) {
	return /* @__PURE__ */ N(K.SubmenuRoot, {
		"data-slot": "dropdown-menu-sub",
		...e
	});
}
function io({ className: e, inset: t, children: n, ...r }) {
	return /* @__PURE__ */ P(K.SubmenuTrigger, {
		"data-slot": "dropdown-menu-sub-trigger",
		"data-inset": t,
		className: q("flex cursor-default items-center text-xs outline-hidden select-none [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-3.5", t && "quill-menu-item--inset", e),
		nativeButton: !("render" in r),
		render: /* @__PURE__ */ N(J, {
			className: "w-full font-normal",
			left: !0
		}),
		...r,
		children: [n, /* @__PURE__ */ N(d, { className: "rtl:rotate-180 ms-auto" })]
	});
}
function ao({ align: e = "start", alignOffset: t = -3, side: n = "inline-end", sideOffset: r = 0, className: i, ...a }) {
	return /* @__PURE__ */ N($a, {
		"data-slot": "dropdown-menu-sub-content",
		className: q("quill-menu__sub-content w-auto", i),
		align: e,
		alignOffset: t,
		side: n,
		sideOffset: r,
		...a
	});
}
function oo({ className: e, children: t, checked: n, inset: r, ...i }) {
	return /* @__PURE__ */ P(K.CheckboxItem, {
		"data-slot": "dropdown-menu-checkbox-item",
		"data-inset": r,
		className: q("quill-menu-item--inset relative flex cursor-default items-center pe-2 text-xs outline-hidden select-none data-disabled:pointer-events-none data-disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-3.5", e),
		checked: n,
		nativeButton: !("render" in i),
		render: /* @__PURE__ */ N(J, {
			className: "w-full font-normal",
			left: !0
		}),
		...i,
		children: [/* @__PURE__ */ P("span", {
			className: "pointer-events-none absolute start-2 flex items-center justify-center",
			"data-slot": "dropdown-menu-checkbox-item-indicator",
			children: [/* @__PURE__ */ N(yi, {
				size: "sm",
				tabIndex: -1
			}), /* @__PURE__ */ N(K.CheckboxItemIndicator, {
				className: "absolute",
				children: /* @__PURE__ */ N(yi, {
					size: "sm",
					checked: !0,
					tabIndex: -1
				})
			})]
		}), t]
	});
}
function so({ ...e }) {
	return /* @__PURE__ */ N(K.RadioGroup, {
		"data-slot": "dropdown-menu-radio-group",
		...e
	});
}
function co({ className: e, children: t, inset: n, ...r }) {
	return /* @__PURE__ */ P(K.RadioItem, {
		"data-slot": "dropdown-menu-radio-item",
		"data-inset": n,
		className: q("quill-menu-item--inset relative flex min-h-7 cursor-default items-center pe-2 text-xs outline-hidden select-none data-disabled:pointer-events-none data-disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-3.5", e),
		nativeButton: !("render" in r),
		render: /* @__PURE__ */ N(J, {
			className: "w-full font-normal",
			left: !0
		}),
		...r,
		children: [/* @__PURE__ */ P("span", {
			className: "pointer-events-none absolute start-2 flex items-center justify-center",
			"data-slot": "dropdown-menu-radio-item-indicator",
			children: [/* @__PURE__ */ N(Qi, { size: "sm" }), /* @__PURE__ */ N(K.RadioItemIndicator, {
				className: "absolute",
				children: /* @__PURE__ */ N(Qi, {
					size: "sm",
					checked: !0
				})
			})]
		}), t]
	});
}
function lo({ className: e, ...t }) {
	return /* @__PURE__ */ N(K.Separator, {
		"data-slot": "dropdown-menu-separator",
		className: q("quill-menu__separator", e),
		...t
	});
}
function uo(e, t, n, r) {
	let i = w.useMemo(() => {
		let e = /* @__PURE__ */ new Set();
		for (let n of t) e.add(r ? r(n) : n);
		return e;
	}, [t, r]), a = e.reduce((e, t) => {
		let n = r ? r(t) : t;
		return e + +!!i.has(n);
	}, 0), o = a === 0 ? "none" : a >= e.length ? "all" : "some", s = o === "all";
	return {
		state: o,
		isAllSelected: s,
		toggle: w.useCallback(() => {
			n(s ? [] : e.slice());
		}, [
			s,
			n,
			e
		])
	};
}
function fo({ values: e, selected: t, onChange: n, getKey: r, selectLabel: i = "Select all", deselectLabel: a = "Deselect all", children: o, ...s }) {
	let c = uo(e, t, n, r);
	return o ? /* @__PURE__ */ N(M, { children: o(c) }) : /* @__PURE__ */ N(no, {
		...s,
		"data-slot": "dropdown-menu-select-all",
		"data-state": c.state,
		closeOnClick: !1,
		onClick: c.toggle,
		children: c.isAllSelected ? a : i
	});
}
function po({ className: e, ...t }) {
	return /* @__PURE__ */ N(qi, {
		"data-slot": "dropdown-menu-shortcut",
		className: q("quill-menu__shortcut", e),
		...t
	});
}
function mo({ className: e, ...t }) {
	return /* @__PURE__ */ N("div", {
		"data-quill": !0,
		"data-slot": "empty",
		className: q("quill-empty flex w-full min-w-0 flex-1 flex-col items-center justify-center gap-4", e),
		...t
	});
}
function ho({ className: e, ...t }) {
	return /* @__PURE__ */ N("div", {
		"data-slot": "empty-header",
		className: q("flex max-w-sm flex-col items-center gap-1", e),
		...t
	});
}
var go = L("quill-empty__media flex shrink-0 items-center justify-center", {
	variants: { variant: {
		default: "quill-empty__media--variant-default",
		icon: "quill-empty__media--variant-icon"
	} },
	defaultVariants: { variant: "default" }
});
function _o({ className: e, variant: t = "default", ...n }) {
	return /* @__PURE__ */ N("div", {
		"data-slot": "empty-icon",
		"data-variant": t,
		className: q(go({
			variant: t,
			className: e
		})),
		...n
	});
}
function vo({ className: e, ...t }) {
	return /* @__PURE__ */ N("div", {
		"data-slot": "empty-title",
		className: q("quill-empty__title", e),
		...t
	});
}
function yo({ className: e, ...t }) {
	return /* @__PURE__ */ N("div", {
		"data-slot": "empty-description",
		className: q("quill-empty__description", e),
		...t
	});
}
function bo({ className: e, ...t }) {
	return /* @__PURE__ */ N("div", {
		"data-slot": "empty-content",
		className: q("quill-empty__content flex w-full max-w-sm min-w-0 flex-col items-center gap-2", e),
		...t
	});
}
function xo({ className: e, ...t }) {
	return /* @__PURE__ */ N("label", {
		"data-quill": !0,
		"data-slot": "label",
		className: q("quill-label flex items-center gap-2", e),
		...t
	});
}
function So({ className: e, ...t }) {
	return /* @__PURE__ */ N("fieldset", {
		"data-slot": "field-set",
		className: q("quill-field-set flex flex-col gap-4 has-[>[data-slot=checkbox-group]]:gap-3 has-[>[data-slot=radio-group]]:gap-3", e),
		...t
	});
}
function Co({ className: e, variant: t = "legend", ...n }) {
	return /* @__PURE__ */ N("legend", {
		"data-slot": "field-legend",
		"data-variant": t,
		className: q("quill-field-legend", e),
		...n
	});
}
function wo({ className: e, ...t }) {
	return /* @__PURE__ */ N("div", {
		"data-slot": "field-group",
		className: q("group/field-group @container/field-group flex w-full flex-col gap-4 data-[slot=checkbox-group]:gap-3 *:data-[slot=field-group]:gap-4", e),
		...t
	});
}
var To = L("quill-field group/field flex w-full gap-x-2 gap-y-1", {
	variants: { orientation: {
		vertical: "flex-col *:w-full [&>.sr-only]:w-auto",
		horizontal: "flex-row items-center has-[>[data-slot=field-content]]:items-start *:data-[slot=field-label]:flex-auto has-[>[data-slot=field-content]]:[&>[role=checkbox],[role=radio]]:mt-px",
		responsive: "flex-col *:w-full @md/field-group:flex-row @md/field-group:items-center @md/field-group:*:w-auto @md/field-group:has-[>[data-slot=field-content]]:items-start @md/field-group:*:data-[slot=field-label]:flex-auto [&>.sr-only]:w-auto @md/field-group:has-[>[data-slot=field-content]]:[&>[role=checkbox],[role=radio]]:mt-px"
	} },
	defaultVariants: { orientation: "vertical" }
});
function Eo({ className: e, orientation: t = "vertical", ...n }) {
	return /* @__PURE__ */ N("div", {
		role: "group",
		"data-quill": !0,
		"data-slot": "field",
		"data-orientation": t,
		className: q(To({ orientation: t }), e),
		...n
	});
}
function Do({ className: e, ...t }) {
	return /* @__PURE__ */ N("div", {
		"data-slot": "field-content",
		className: q("quill-field__content group/field-content flex flex-1 flex-col gap-0.5", e),
		...t
	});
}
function Oo({ className: e, ...t }) {
	return /* @__PURE__ */ N(xo, {
		"data-slot": "field-label",
		className: q("quill-field__label group/field-label peer/field-label flex w-fit gap-2", e),
		...t
	});
}
function ko({ className: e, ...t }) {
	return /* @__PURE__ */ N("div", {
		"data-slot": "field-label",
		className: q("quill-field__title flex w-fit items-center gap-2", e),
		...t
	});
}
function Ao({ className: e, ...t }) {
	return /* @__PURE__ */ N("p", {
		"data-slot": "field-description",
		className: q("quill-field__description last:mt-0 nth-last-2:mt-0", e),
		...t
	});
}
function jo({ children: e, className: t, ...n }) {
	return /* @__PURE__ */ P("div", {
		"data-slot": "field-separator",
		"data-content": !!e,
		className: q("quill-field__separator", t),
		...n,
		children: [/* @__PURE__ */ N($e, { className: "absolute inset-0 top-1/2" }), e && /* @__PURE__ */ N("span", {
			className: "quill-field__separator-content",
			"data-slot": "field-separator-content",
			children: e
		})]
	});
}
function Mo({ className: e, children: t, errors: n, ...r }) {
	let i = O(() => {
		if (t) return t;
		if (!n?.length) return null;
		let e = [...new Map(n.map((e) => [e?.message, e])).values()];
		return e?.length == 1 ? e[0]?.message : /* @__PURE__ */ N("ul", {
			className: "ms-4 flex list-disc flex-col gap-1",
			children: e.map((e, t) => e?.message && /* @__PURE__ */ N("li", { children: e.message }, t))
		});
	}, [t, n]);
	return i ? /* @__PURE__ */ N("div", {
		role: "alert",
		"data-slot": "field-error",
		className: q("quill-field__error", e),
		...r,
		children: i
	}) : null;
}
var No = L("text-foreground font-semibold text-balance", {
	variants: { size: {
		"2xl": "text-2xl tracking-tight",
		xl: "text-xl tracking-tight",
		lg: "text-lg",
		base: "text-base",
		sm: "text-sm"
	} },
	defaultVariants: { size: "lg" }
});
function Po({ className: e, size: t = "lg", render: n, ...r }) {
	return B({
		defaultTagName: "h2",
		props: z({
			"data-quill": "",
			className: q(No({ size: t }), e)
		}, r),
		render: n,
		state: {
			slot: "heading",
			size: t
		}
	});
}
function Fo({ className: e, ...t }) {
	return /* @__PURE__ */ N(R.Root, {
		"data-quill": !0,
		"data-slot": "number-field",
		className: q("flex flex-col gap-1", e),
		...t
	});
}
function Io({ className: e, ...t }) {
	return /* @__PURE__ */ N(R.Group, {
		"data-slot": "number-field-group",
		className: q("quill-number-field__group flex items-center", e),
		...t
	});
}
var Lo = w.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ N(R.Input, {
	ref: n,
	"data-slot": "number-field-input",
	className: q("quill-number-field__input", e),
	...t
}));
Lo.displayName = "NumberFieldInput";
function Ro({ className: e, children: t, ...n }) {
	return /* @__PURE__ */ N(R.Increment, {
		"data-slot": "number-field-increment",
		className: q("quill-number-field__increment flex items-center justify-center", e),
		...n,
		children: t ?? /* @__PURE__ */ N(f, { className: "size-3.5" })
	});
}
function zo({ className: e, children: t, ...n }) {
	return /* @__PURE__ */ N(R.Decrement, {
		"data-slot": "number-field-decrement",
		className: q("quill-number-field__decrement flex items-center justify-center", e),
		...n,
		children: t ?? /* @__PURE__ */ N(c, { className: "size-3.5" })
	});
}
function Bo({ className: e, ...t }) {
	return /* @__PURE__ */ N(R.ScrubArea, {
		"data-slot": "number-field-scrub-area",
		className: q("cursor-ew-resize", e),
		...t
	});
}
function Vo({ className: e, ...t }) {
	return /* @__PURE__ */ N(R.ScrubAreaCursor, {
		"data-slot": "number-field-scrub-area-cursor",
		className: q(e),
		...t
	});
}
function Ho({ className: e, combined: t = !1, ...n }) {
	return /* @__PURE__ */ N("div", {
		role: "list",
		"data-slot": "item-group",
		"data-combined": t ? "" : void 0,
		className: q("quill-item-group group/item-group flex w-full flex-col", t ? "gap-0" : "gap-4 has-data-[size=sm]:gap-2.5 has-data-[size=xs]:gap-2", e),
		...n
	});
}
function Uo({ className: e, ...t }) {
	return /* @__PURE__ */ N($e, {
		"data-slot": "item-separator",
		orientation: "horizontal",
		className: q("my-2", e),
		...t
	});
}
var Wo = L("quill-item item group/item flex w-full flex-wrap items-center", {
	variants: {
		variant: {
			default: "quill-item--variant-default",
			outline: "quill-item--variant-outline",
			pressable: "quill-item--variant-pressable",
			muted: "quill-item--variant-muted",
			menuItem: "quill-item--variant-menu"
		},
		size: {
			default: "quill-item--size-default",
			sm: "quill-item--size-sm",
			xs: "quill-item--size-xs"
		},
		tone: {
			default: "",
			info: "quill-item--tone-info",
			success: "quill-item--tone-success",
			warning: "quill-item--tone-warning",
			completed: "quill-item--tone-completed",
			destructive: "quill-item--tone-destructive"
		}
	},
	defaultVariants: {
		variant: "default",
		size: "default",
		tone: "default"
	}
});
function Go({ className: e, variant: t = "default", size: n = "default", tone: r = "default", role: i, render: a, ...o }) {
	return B({
		defaultTagName: "div",
		props: z({
			"data-quill": "",
			"data-tone": r && r !== "default" ? r : void 0,
			className: q(Wo({
				variant: t,
				size: n,
				tone: r,
				className: e
			})),
			role: t === "pressable" ? "link" : void 0
		}, o),
		render: a,
		state: {
			slot: "item",
			variant: t,
			size: n,
			tone: r
		}
	});
}
var Ko = w.forwardRef(function({ className: e, variant: t = "default", size: n = "default", render: r, ...i }, a) {
	return B({
		defaultTagName: "button",
		props: z({
			className: q(Wo({
				variant: "menuItem",
				size: n,
				className: e
			})),
			role: "menuitem",
			ref: a
		}, i),
		render: r,
		state: {
			slot: "item",
			variant: t,
			size: n
		}
	});
}), qo = w.forwardRef(function({ className: e, variant: t = "default", size: n = "default", render: r, children: i, ...a }, o) {
	let s = a["aria-checked"] === !0 || a["aria-checked"] === "true", c = B({
		defaultTagName: "button",
		props: z({
			className: q(Wo({
				variant: "menuItem",
				size: n,
				className: e
			})),
			role: "checkbox",
			ref: o
		}, a),
		render: r,
		state: {
			slot: "item",
			variant: t,
			size: n
		}
	});
	return w.cloneElement(c, {}, /* @__PURE__ */ N(Xo, {
		variant: "checkbox",
		className: "-mr-2",
		children: /* @__PURE__ */ N(_i, {
			checked: s,
			size: "sm"
		})
	}), i);
}), Jo = w.forwardRef(function({ className: e, variant: t = "default", size: n = "default", render: r, children: i, ...a }, o) {
	let s = a["aria-checked"] === !0 || a["aria-checked"] === "true", c = B({
		defaultTagName: "button",
		props: z({
			className: q(Wo({
				variant: "menuItem",
				size: n,
				className: e
			})),
			role: "radio",
			ref: o
		}, a),
		render: r,
		state: {
			slot: "item",
			variant: t,
			size: n
		}
	});
	return w.cloneElement(c, {}, /* @__PURE__ */ N(Xo, {
		variant: "checkbox",
		className: "-mr-2",
		children: /* @__PURE__ */ N(Qi, {
			checked: s,
			size: "sm"
		})
	}), i);
}), Yo = L("quill-item__media flex shrink-0 items-center justify-center gap-2", {
	variants: { variant: {
		default: "quill-item__media--variant-default",
		icon: "quill-item__media--variant-icon",
		image: "quill-item__media--variant-image",
		checkbox: "quill-item__media--variant-checkbox"
	} },
	defaultVariants: { variant: "default" }
});
function Xo({ className: e, variant: t = "default", ...n }) {
	return /* @__PURE__ */ N("div", {
		"data-slot": "item-media",
		"data-variant": t,
		className: q(Yo({
			variant: t,
			className: e
		})),
		...n
	});
}
var Zo = L("quill-item__content flex flex-1 flex-col gap-1", {
	variants: { variant: {
		default: "",
		menuItem: "quill-item__content--variant-menu"
	} },
	defaultVariants: { variant: "default" }
});
function Qo({ className: e, variant: t = "default", ...n }) {
	return /* @__PURE__ */ N("div", {
		"data-slot": "item-content",
		className: q(Zo({
			variant: t,
			className: e
		})),
		...n
	});
}
function $o({ className: e, ...t }) {
	return /* @__PURE__ */ N("div", {
		"data-slot": "item-title",
		className: q("quill-item__title gap-2", e),
		...t
	});
}
function es({ className: e, ...t }) {
	return /* @__PURE__ */ N("p", {
		"data-slot": "item-description",
		className: q("quill-item__description", e),
		...t
	});
}
function ts({ className: e, ...t }) {
	return /* @__PURE__ */ N("div", {
		"data-slot": "item-actions",
		className: q("flex items-center gap-2", e),
		...t
	});
}
function ns({ className: e, ...t }) {
	return /* @__PURE__ */ N("div", {
		"data-slot": "item-header",
		className: q("flex basis-full items-center justify-between gap-2", e),
		...t
	});
}
function rs({ className: e, ...t }) {
	return /* @__PURE__ */ N("div", {
		"data-slot": "item-footer",
		className: q("flex basis-full items-center justify-between gap-2", e),
		...t
	});
}
function is({ className: e, ...t }) {
	return /* @__PURE__ */ N(pe, {
		"data-quill": !0,
		"data-slot": "menubar",
		className: q("quill-menubar flex items-center", e),
		...t
	});
}
function as({ ...e }) {
	return /* @__PURE__ */ N(Xa, {
		"data-slot": "menubar-menu",
		...e
	});
}
function os({ ...e }) {
	return /* @__PURE__ */ N(eo, {
		"data-slot": "menubar-group",
		...e
	});
}
function ss({ ...e }) {
	return /* @__PURE__ */ N(Za, {
		"data-slot": "menubar-portal",
		...e
	});
}
function cs({ className: e, ...t }) {
	return /* @__PURE__ */ N(Qa, {
		"data-slot": "menubar-trigger",
		className: q("quill-menubar__trigger flex items-center outline-hidden select-none", e),
		...t
	});
}
function ls({ className: e, align: t = "start", alignOffset: n = -4, sideOffset: r = 8, ...i }) {
	return /* @__PURE__ */ N($a, {
		"data-slot": "menubar-content",
		align: t,
		alignOffset: n,
		sideOffset: r,
		className: e,
		...i
	});
}
function us({ className: e, inset: t, variant: n = "default", ...r }) {
	return /* @__PURE__ */ N(no, {
		"data-slot": "menubar-item",
		"data-inset": t,
		variant: n,
		className: q("group/menubar-item min-h-7 gap-2 rounded-sm px-2 py-1 text-xs/relaxed data-disabled:opacity-50", e),
		...r
	});
}
function ds({ className: e, children: t, checked: n, inset: r, ...i }) {
	return /* @__PURE__ */ P(K.CheckboxItem, {
		"data-slot": "menubar-checkbox-item",
		"data-inset": r,
		className: q("quill-menu-item--inset relative flex min-h-7 cursor-default items-center gap-2 rounded-sm py-1.5 pe-2 text-xs outline-hidden select-none hover:bg-[var(--fill-hover)] focus:bg-[var(--fill-hover)] focus-visible:shadow-[0_0_0_2px_color-mix(in_oklab,var(--ring)_30%,transparent)] data-disabled:pointer-events-none data-disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0", e),
		checked: n,
		...i,
		children: [/* @__PURE__ */ P("span", {
			className: "pointer-events-none absolute start-2 flex size-4 items-center justify-center",
			children: [/* @__PURE__ */ N(yi, {
				size: "sm",
				tabIndex: -1
			}), /* @__PURE__ */ N(K.CheckboxItemIndicator, {
				className: "absolute",
				children: /* @__PURE__ */ N(yi, {
					size: "sm",
					checked: !0,
					tabIndex: -1
				})
			})]
		}), t]
	});
}
function fs({ ...e }) {
	return /* @__PURE__ */ N(so, {
		"data-slot": "menubar-radio-group",
		...e
	});
}
function ps({ className: e, children: t, inset: n, ...r }) {
	return /* @__PURE__ */ P(K.RadioItem, {
		"data-slot": "menubar-radio-item",
		"data-inset": n,
		className: q("quill-menu-item--inset relative flex min-h-7 cursor-default items-center gap-2 rounded-sm py-1.5 pe-2 text-xs outline-hidden select-none hover:bg-[var(--fill-hover)] focus:bg-[var(--fill-hover)] focus-visible:shadow-[0_0_0_2px_color-mix(in_oklab,var(--ring)_30%,transparent)] data-disabled:pointer-events-none data-disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-3.5", e),
		...r,
		children: [/* @__PURE__ */ P("span", {
			className: "pointer-events-none absolute start-2 flex size-4 items-center justify-center",
			children: [/* @__PURE__ */ N(Qi, { size: "sm" }), /* @__PURE__ */ N(K.RadioItemIndicator, {
				className: "absolute",
				children: /* @__PURE__ */ N(Qi, {
					size: "sm",
					checked: !0
				})
			})]
		}), t]
	});
}
function ms({ className: e, inset: t, ...n }) {
	return /* @__PURE__ */ N(to, {
		"data-slot": "menubar-label",
		"data-inset": t,
		className: q("px-2 py-1.5 text-xs text-muted-foreground", t && "quill-menu-item--inset", e),
		...n
	});
}
function hs({ className: e, ...t }) {
	return /* @__PURE__ */ N(lo, {
		"data-slot": "menubar-separator",
		className: q("quill-menu__separator", e),
		...t
	});
}
function gs({ className: e, ...t }) {
	return /* @__PURE__ */ N(po, {
		"data-slot": "menubar-shortcut",
		className: q("quill-menu__shortcut", e),
		...t
	});
}
function _s({ ...e }) {
	return /* @__PURE__ */ N(ro, {
		"data-slot": "menubar-sub",
		...e
	});
}
function vs({ className: e, inset: t, ...n }) {
	return /* @__PURE__ */ N(io, {
		"data-slot": "menubar-sub-trigger",
		"data-inset": t,
		className: q("min-h-7 gap-2 rounded-sm px-2 py-1 text-xs focus:bg-fill-hover data-open:bg-fill-selected [&_svg:not([class*='size-'])]:size-3.5", t && "quill-menu-item--inset", e),
		...n
	});
}
function ys({ className: e, ...t }) {
	return /* @__PURE__ */ N(ao, {
		"data-slot": "menubar-sub-content",
		className: e,
		...t
	});
}
function bs({ className: e, ...t }) {
	return /* @__PURE__ */ N("nav", {
		"aria-label": "Pagination",
		"data-quill": !0,
		"data-slot": "pagination",
		className: q("quill-pagination", e),
		...t
	});
}
var xs = w.forwardRef(function({ className: e, ...t }, n) {
	return /* @__PURE__ */ N("ul", {
		ref: n,
		"data-slot": "pagination-content",
		className: q("quill-pagination__content", e),
		...t
	});
}), Ss = w.forwardRef(function({ className: e, ...t }, n) {
	return /* @__PURE__ */ N("li", {
		ref: n,
		"data-slot": "pagination-item",
		className: q("quill-pagination__item", e),
		...t
	});
}), Cs = w.forwardRef(function({ isActive: e, size: t = "icon-sm", className: n, ...r }, i) {
	return /* @__PURE__ */ N(J, {
		ref: i,
		"data-slot": "pagination-button",
		"aria-current": e ? "page" : void 0,
		"aria-selected": e ? !0 : void 0,
		size: t,
		className: q("quill-pagination__button", n),
		...r
	});
}), ws = w.forwardRef(function({ className: e, children: t, ...n }, r) {
	return /* @__PURE__ */ P(Cs, {
		ref: r,
		"aria-label": "Go to previous page",
		size: "sm",
		className: q("gap-1 px-2", e),
		...n,
		children: [/* @__PURE__ */ N(l, { className: "size-3.5" }), t ?? /* @__PURE__ */ N("span", { children: "Previous" })]
	});
}), Ts = w.forwardRef(function({ className: e, children: t, ...n }, r) {
	return /* @__PURE__ */ P(Cs, {
		ref: r,
		"aria-label": "Go to next page",
		size: "sm",
		className: q("gap-1 px-2", e),
		...n,
		children: [t ?? /* @__PURE__ */ N("span", { children: "Next" }), /* @__PURE__ */ N(u, { className: "size-3.5" })]
	});
});
function Es({ className: e, ...t }) {
	return /* @__PURE__ */ P("span", {
		"aria-hidden": !0,
		"data-slot": "pagination-ellipsis",
		className: q("quill-pagination__ellipsis", e),
		...t,
		children: [/* @__PURE__ */ N(b, { className: "size-3.5" }), /* @__PURE__ */ N("span", {
			className: "sr-only",
			children: "More pages"
		})]
	});
}
function Ds(e, t, n = 1) {
	if (e <= n * 2 + 5) return Array.from({ length: e }, (e, t) => t);
	let r = Math.max(t - n, 0), i = Math.min(t + n, e - 1), a = r > 2, o = i < e - 3, s = e - 1, c = [0];
	if (a) c.push("ellipsis");
	else for (let e = 1; e < r; e++) c.push(e);
	for (let e = r; e <= i; e++) e !== 0 && e !== s && c.push(e);
	if (o) c.push("ellipsis");
	else for (let e = i + 1; e < s; e++) c.push(e);
	return c.push(s), c;
}
bs.displayName = "Pagination", xs.displayName = "PaginationContent", Ss.displayName = "PaginationItem", Cs.displayName = "PaginationButton", ws.displayName = "PaginationPrevious", Ts.displayName = "PaginationNext";
function Os({ ...e }) {
	return /* @__PURE__ */ N(me.Root, {
		"data-slot": "popover",
		...e
	});
}
function ks({ ...e }) {
	return /* @__PURE__ */ N(me.Trigger, {
		"data-slot": "popover-trigger",
		...e
	});
}
function As({ className: e, ...t }) {
	return /* @__PURE__ */ N(me.Arrow, {
		"data-slot": "popover-arrow",
		className: q("quill-popover__arrow", e),
		...t
	});
}
function js({ className: e, align: t = "center", alignOffset: n = 0, side: r = "bottom", arrow: i = !1, sideOffset: a = i ? 9 : 4, arrowPadding: o, collisionAvoidance: s, container: c, children: l, ...u }) {
	return /* @__PURE__ */ N(me.Portal, {
		container: c,
		children: /* @__PURE__ */ N(me.Positioner, {
			"data-quill": !0,
			"data-quill-portal": "popover",
			align: t,
			alignOffset: n,
			side: r,
			sideOffset: a,
			arrowPadding: o,
			collisionAvoidance: s,
			className: "isolate",
			children: /* @__PURE__ */ P(me.Popup, {
				"data-slot": "popover-content",
				className: q("quill-popover__content flex flex-col gap-4", e),
				...u,
				children: [i && /* @__PURE__ */ N(As, {}), l]
			})
		})
	});
}
var Ms = L("quill-progress__indicator", {
	variants: { variant: {
		default: "quill-progress__indicator--variant-default",
		info: "quill-progress__indicator--variant-info",
		success: "quill-progress__indicator--variant-success",
		warning: "quill-progress__indicator--variant-warning",
		destructive: "quill-progress__indicator--variant-destructive"
	} },
	defaultVariants: { variant: "default" }
});
function Ns({ className: e, children: t, value: n, variant: r = "default", ...i }) {
	return /* @__PURE__ */ P(he.Root, {
		value: n,
		"data-quill": !0,
		"data-slot": "progress",
		"data-variant": r,
		className: q("flex flex-wrap gap-3", e),
		...i,
		children: [t, /* @__PURE__ */ N(Ps, { children: /* @__PURE__ */ N(Fs, { variant: r }) })]
	});
}
function Ps({ className: e, ...t }) {
	return /* @__PURE__ */ N(he.Track, {
		className: q("quill-progress__track relative flex items-center", e),
		"data-slot": "progress-track",
		...t
	});
}
function Fs({ className: e, variant: t = "default", ...n }) {
	return /* @__PURE__ */ N(he.Indicator, {
		"data-slot": "progress-indicator",
		"data-variant": t,
		className: q(Ms({ variant: t }), e),
		...n
	});
}
function Is({ className: e, ...t }) {
	return /* @__PURE__ */ N(he.Label, {
		className: q("quill-progress__label", e),
		"data-slot": "progress-label",
		...t
	});
}
function Ls({ className: e, ...t }) {
	return /* @__PURE__ */ N(he.Value, {
		className: q("quill-progress__value ms-auto", e),
		"data-slot": "progress-value",
		...t
	});
}
var Rs = w.createContext(null), zs = w.createContext(null), Bs = w.createContext(null);
function Vs(e) {
	let t = w.useContext(zs);
	if (!t) throw Error(`${e} must be used within a Questionnaire.Root component.`);
	return t;
}
function Hs(e) {
	let t = w.useContext(Rs);
	if (!t) throw Error(`${e} must be used within a Questionnaire.Choice component.`);
	return t;
}
function Us(e) {
	let t = w.useContext(Bs);
	if (!t) throw Error(`${e} must be used within a Questionnaire.Item component.`);
	return t;
}
function Ws(e) {
	return Array.isArray(e) ? e.some((e) => String(e).trim().length > 0) : e != null && String(e).trim().length > 0;
}
function Gs(e) {
	return e === "letters" ? Array.from({ length: 26 }, (e, t) => String.fromCharCode(65 + t)) : e === "numbers" ? Array.from({ length: 9 }, (e, t) => String(t + 1)) : [];
}
function Ks(e, t) {
	let n = t === "letters" ? e.toUpperCase() : e;
	return Gs(t).includes(n) ? n : null;
}
function qs(e, t) {
	return [e, t ? "Enter" : null].filter(Boolean).join(" ") || void 0;
}
function Js(e) {
	return e.type === "choice" ? e.element.checked : e.element.hasAttribute("name") && Ws(e.element.value);
}
function Ys(e) {
	return e?.type === "input" && [
		"email",
		"password",
		"search",
		"tel",
		"text",
		"url"
	].includes(e.element.type) && !Ws(e.element.value);
}
function Xs(e) {
	return e instanceof HTMLTextAreaElement || e instanceof HTMLSelectElement ? !0 : e instanceof HTMLInputElement ? ![
		"button",
		"checkbox",
		"radio",
		"reset",
		"submit"
	].includes(e.type) : e instanceof HTMLElement && e.isContentEditable;
}
function Zs(e) {
	return e instanceof HTMLInputElement && e.type === "radio";
}
function Qs(e, t) {
	if (e.element === t.element) return 0;
	let n = e.element.compareDocumentPosition(t.element);
	return n & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : n & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
}
function $s(e, t) {
	if (e.element === t.element) return 0;
	let n = e.element.compareDocumentPosition(t.element);
	return n & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : n & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
}
function ec({ checked: e, defaultChecked: t = !1, disabled: n = !1, onChange: r, value: i }) {
	let { disabled: a, hasInputAnswer: o, invalid: s, multiple: c, name: l, registerAnswerControl: u, registerAnswerSelection: d, required: f, resetVersion: p, selectedAnswerIds: m, setAnswerDefault: h, setAnswerSelectionFromInteraction: g, shortcutByAnswerId: _, shortcutByChoiceValue: v, status: y, syncControlledAnswerSelection: b } = Us("Questionnaire.Choice"), x = w.useId(), [S, C] = w.useState(null), T = w.useRef(t), E = e !== void 0, D = a || n, O = m.includes(x), k = E ? y === "skipped" ? !1 : e : O, A = c ? "checkbox" : "radio", j = v?.get(i) ?? _.get(x) ?? null;
	w.useLayoutEffect(() => d(x, T.current), [x, d]), w.useLayoutEffect(() => h(x, t), [
		x,
		t,
		h
	]), w.useLayoutEffect(() => {
		if (S) return u({
			disabled: D,
			element: S,
			id: x,
			ownDisabled: n,
			type: "choice",
			value: i
		});
	}, [
		x,
		n,
		D,
		S,
		u,
		i
	]), w.useLayoutEffect(() => {
		E && b(x, e);
	}, [
		x,
		E,
		e,
		p,
		b
	]), w.useLayoutEffect(() => {
		S && (S.defaultChecked = E ? e : t, p > 0 && (S.checked = k));
	}, [
		k,
		E,
		e,
		t,
		S,
		p
	]);
	function M(t) {
		if (r?.(t), !t.defaultPrevented) {
			if (!E) {
				g(x, t.target.checked);
				return;
			}
			y === "skipped" && e === t.target.checked && g(x, e);
		}
	}
	let N = {
		checked: k,
		disabled: D,
		invalid: s,
		shortcut: j,
		type: A
	};
	return {
		inputProps: {
			ref: C,
			"aria-invalid": s || void 0,
			"aria-keyshortcuts": qs(j, !D && k),
			checked: k,
			disabled: D,
			id: x,
			name: y === "skipped" ? void 0 : l,
			onChange: M,
			required: f && !c && !o,
			type: A,
			value: i
		},
		state: N
	};
}
function tc({ defaultValue: e, disabled: t = !1, onChange: n, ref: r, type: i = "text", value: a }) {
	let { disabled: o, invalid: s, name: c, registerAnswerControl: l, registerAnswerSelection: u, resetVersion: d, selectedAnswerIds: f, setAnswerDefault: p, setAnswerSelectionFromInteraction: m, syncControlledAnswerSelection: h } = Us("Questionnaire.Input"), g = w.useId(), _ = w.useRef(null), v = w.useRef(Ws(e)), y = a !== void 0, b = Ws(e), x = Ws(a), [S, C] = w.useState(b), T = o || t, E = y ? x : S, D = f.includes(g);
	w.useLayoutEffect(() => u(g, v.current), [g, u]), w.useLayoutEffect(() => p(g, b), [
		b,
		g,
		p
	]), w.useLayoutEffect(() => {
		let e = _.current;
		if (e) return l({
			disabled: T,
			element: e,
			id: g,
			type: "input"
		});
	}, [
		T,
		g,
		l
	]), w.useLayoutEffect(() => {
		if (y) {
			h(g, x);
			return;
		}
		d > 0 && C(b);
	}, [
		y,
		x,
		a,
		b,
		g,
		d,
		h
	]), w.useLayoutEffect(() => {
		let e = _.current;
		!e || !y || (e.defaultValue = String(a));
	}, [y, a]);
	function O(e) {
		if (n?.(e), e.defaultPrevented) return;
		let t = e.target.value.trim().length > 0;
		y || (C(t), m(g, t));
	}
	let k = {
		disabled: T,
		filled: E,
		invalid: s
	}, A = w.useCallback((e) => {
		_.current = e, sn(r)?.(e);
	}, [r]);
	return {
		inputProps: {
			"aria-invalid": s || void 0,
			"aria-keyshortcuts": qs(null, !T && E && D),
			defaultValue: y ? void 0 : e,
			disabled: T,
			form: D ? void 0 : "",
			id: g,
			name: D ? c : void 0,
			onChange: O,
			ref: A,
			type: i,
			value: y ? a : void 0
		},
		state: k
	};
}
function nc(e) {
	return e === void 0 ? null : {
		enabledItems: e.filter((e) => !e.disabled),
		itemByName: new Map(e.map((e) => [e.name, e])),
		items: e
	};
}
function rc(e, t) {
	if (!e) return t ?? null;
	let n = t ? e.itemByName.get(t) : void 0;
	return n && !n.disabled ? n.name : e.enabledItems[0]?.name ?? null;
}
function ic(e, t) {
	let n = /* @__PURE__ */ new Map();
	if (!e || !t) return n;
	let r = Gs(t), i = 0;
	for (let t of e.choices ?? []) {
		if (t.disabled) continue;
		let e = r[i];
		if (!e) break;
		n.set(t.value, e), i += 1;
	}
	return n;
}
function ac(e, t) {
	let n = [], r = /* @__PURE__ */ new Set();
	for (let t of e.items) {
		r.has(t.name) && n.push(`Item name "${t.name}" is defined more than once.`), r.add(t.name);
		let e = /* @__PURE__ */ new Set();
		for (let r of t.choices ?? []) e.has(r.value) && n.push(`Choice value "${r.value}" is defined more than once in item "${t.name}".`), e.add(r.value);
	}
	if (t) {
		let r = e.itemByName.get(t);
		(!r || r.disabled) && n.push(`defaultItem "${t}" does not identify an enabled item. The first enabled item will be used instead.`);
	}
	return n;
}
function oc(e, t, n) {
	let r = [], i = new Map(t.map((e) => [e.name, e]));
	for (let t of e.items) {
		let e = i.get(t.name);
		if (!e) {
			t.disabled || r.push(`Item "${t.name}" is defined but has no rendered Questionnaire.Item.`);
			continue;
		}
		e.disabled !== !!t.disabled && r.push(`Item "${t.name}" has different disabled values in Root.items and Questionnaire.Item.`), e.required !== !!t.required && r.push(`Item "${t.name}" has different required values in Root.items and Questionnaire.Item.`);
		let a = t.choices ?? [], o = new Map(a.map((e) => [e.value, e])), s = new Map(e.choices.map((e) => [e.value, e]));
		for (let e of a) {
			let n = s.get(e.value);
			if (!n) {
				r.push(`Choice "${e.value}" is defined for item "${t.name}" but has no rendered Questionnaire.Choice.`);
				continue;
			}
			n.disabled !== !!e.disabled && r.push(`Choice "${e.value}" in item "${t.name}" has different disabled values in Root.items and Questionnaire.Choice.`);
		}
		if (n) {
			for (let n of e.choices) o.has(n.value) || r.push(`Rendered choice "${n.value}" in item "${t.name}" is missing from Root.items and will not receive a shortcut.`);
			let n = a.filter((e) => !e.disabled).map((e) => e.value), i = e.choices.filter((e) => !e.disabled).map((e) => e.value);
			n.length > 0 && n.length === i.length && n.every((e) => i.includes(e)) && n.some((e, t) => e !== i[t]) && r.push(`Choice order for item "${t.name}" differs between Root.items and the rendered Questionnaire.Choice elements.`);
		}
	}
	for (let n of t) !n.disabled && !e.itemByName.has(n.name) && r.push(`Rendered item "${n.name}" is missing from Root.items and is excluded from the questionnaire collection.`);
	return r;
}
function sc({ "aria-describedby": e, "aria-keyshortcuts": t, disabled: n = !1, invalid: r = !1, multiple: i = !1, name: a, onStatusChange: o, ref: s, required: c = !1 }) {
	let { activeItemName: l, domVersion: u, first: d, itemDefinitionByName: f, last: p, nativeValidation: m, registerItem: h, shortcuts: g } = Vs("Questionnaire.Item"), [_, v] = w.useState(null), [y, b] = w.useState([]), [x, S] = w.useState(!1), [C, T] = w.useState([]), [E, D] = w.useState(!1), [O, k] = w.useState(0), [A, j] = w.useState([]), [M, N] = w.useState([]), P = w.useRef([]), F = w.useRef(i), I = w.useRef(i);
	F.current = i;
	let ee = !n && l === a, L = w.useMemo(() => [...y].sort($s), [y, u]), R = w.useMemo(() => L.filter((e) => !e.disabled), [L]), te = R.some((e) => C.includes(e.id)), z = E ? "skipped" : te ? "answered" : "unanswered", B = z === "skipped" && !c, ne = n || B || !r && z === "answered", re = !n && !B && (r || x && !ne), V = R.some((e) => e.type === "input"), H = w.useRef(z), ie = f?.get(a), U = w.useMemo(() => f ? ic(ie, g) : null, [
		ie,
		f,
		g
	]), ae = w.useMemo(() => {
		if (U) return /* @__PURE__ */ new Map();
		let e = Gs(g), t = R.filter((e) => e.type === "choice");
		return new Map(t.slice(0, e.length).map((t, n) => [t.id, e[n]]));
	}, [
		R,
		U,
		g
	]), W = w.useCallback((e) => (b((t) => [...t.filter((t) => t.element !== e.element && t.id !== e.id), e]), () => {
		b((t) => t.filter((t) => t !== e));
	}), []);
	w.useLayoutEffect(() => {
		H.current !== z && (H.current = z, o?.(z));
	}, [o, z]);
	let G = w.useCallback((e, t) => {
		T((n) => t ? i ? n.includes(e) ? n : [...n, e] : [e] : n.filter((t) => t !== e));
	}, [i]), oe = w.useCallback((e, t) => {
		D(!1), G(e, t);
	}, [G]), se = w.useCallback((e, t) => {
		t && D(!1), G(e, t);
	}, [G]), ce = w.useCallback((e, t) => (t && (P.current = [...P.current.filter((t) => t !== e), e], T((t) => F.current ? t.includes(e) ? t : [...t, e] : t.length ? t : [e])), () => {
		P.current = P.current.filter((t) => t !== e), T((t) => t.filter((t) => t !== e));
	}), []), le = w.useCallback((e, t) => {
		if (t) {
			P.current = P.current.includes(e) ? P.current : [...P.current, e];
			return;
		}
		P.current = P.current.filter((t) => t !== e);
	}, []), ue = w.useCallback((e) => (j((t) => t.includes(e) ? t : [...t, e]), () => {
		j((t) => t.filter((t) => t !== e));
	}), []), de = w.useCallback((e) => (N((t) => t.includes(e) ? t : [...t, e]), () => {
		N((t) => t.filter((t) => t !== e));
	}), []), fe = w.useCallback(() => {
		if (S(!0), !ne) return !1;
		if (!m) return !0;
		let e = R.find((e) => Js(e) && e.element.willValidate && !e.element.validity.valid);
		return e ? (e.element.focus(), e.element.reportValidity(), !1) : !0;
	}, [
		R,
		m,
		ne
	]), K = w.useCallback(() => {
		_?.focus();
	}, [_]), pe = w.useCallback(() => {
		let e = _?.querySelector("input[data-filled][name]:not(:disabled)"), t = _?.querySelector("input:not([type=hidden]):not(:disabled), textarea:not(:disabled)");
		(e ?? t ?? _)?.focus();
	}, [_]), me = w.useCallback(() => {
		S(!1), D(!1), T(i ? [...P.current] : P.current.slice(0, 1)), k((e) => e + 1);
	}, [i]), he = w.useCallback(() => {
		c || (T([]), D(!0));
	}, [c]);
	w.useLayoutEffect(() => {
		let e = I.current;
		I.current = i, !(!e || i) && T((e) => {
			let t = R.find((t) => e.includes(t.id));
			return t ? [t.id] : [];
		});
	}, [R, i]);
	let ge = w.useCallback((e) => R.find((t) => t.element === e) ?? null, [R]), _e = w.useCallback((e) => {
		if (U) {
			let t = Array.from(U.entries()).find(([, t]) => t === e)?.[0];
			return R.find((e) => e.type === "choice" && e.value === t) ?? null;
		}
		let t = Array.from(ae.entries()).find(([, t]) => t === e)?.[0];
		return R.find((e) => e.id === t) ?? null;
	}, [
		R,
		ae,
		U
	]), ve = w.useCallback((e, t) => {
		let n = R.findIndex((t) => t.element === e), r = n < 0 ? null : R[n] ?? null;
		if (!R.length || Xs(e) && !Ys(r) || n < 0 && e !== _) return !1;
		let i = n < 0 ? R.find(Js) ?? (t === "next" ? R[0] : R[R.length - 1]) : R[(n + (t === "next" ? 1 : -1) + R.length) % R.length];
		return !i || i.element === e || n >= 0 && Zs(e) && Zs(i.element) ? !1 : (i.element.focus(), i.type === "choice" && Zs(i.element) && i.element.click(), !0);
	}, [R, _]);
	w.useLayoutEffect(() => {
		if (_) return h({
			choices: L.flatMap((e) => e.type === "choice" ? [{
				disabled: e.ownDisabled,
				value: e.value
			}] : []),
			disabled: n,
			element: _,
			focus: K,
			focusInvalid: pe,
			getAnswerByElement: ge,
			getAnswerByShortcut: _e,
			moveAnswerFocus: ve,
			name: a,
			required: c,
			reset: me,
			skip: he,
			status: z,
			validate: fe
		});
	}, [
		L,
		n,
		_,
		K,
		pe,
		ge,
		_e,
		ve,
		a,
		h,
		c,
		me,
		he,
		z,
		fe
	]);
	let ye = w.useMemo(() => ({
		active: ee,
		disabled: n,
		hasInputAnswer: V,
		invalid: re,
		multiple: i,
		name: a,
		registerAnswerControl: W,
		registerAnswerSelection: ce,
		registerDescription: ue,
		registerError: de,
		required: c,
		resetVersion: O,
		selectedAnswerIds: C,
		setAnswerDefault: le,
		setAnswerSelectionFromInteraction: oe,
		shortcutByAnswerId: ae,
		shortcutByChoiceValue: U,
		shortcuts: g,
		status: z,
		syncControlledAnswerSelection: se
	}), [
		ee,
		n,
		V,
		re,
		i,
		a,
		W,
		ce,
		ue,
		de,
		c,
		O,
		C,
		le,
		oe,
		ae,
		U,
		g,
		z,
		se
	]), be = w.useCallback((e) => {
		v(e), sn(s)?.(e);
	}, [s]), xe = [
		...A,
		...re ? M : [],
		e
	].filter(Boolean).join(" ") || void 0, Se = [
		t,
		ee ? "Meta+Enter Control+Enter" : void 0,
		ee && R.length ? "ArrowUp ArrowDown" : void 0,
		ee && !d ? "ArrowLeft" : void 0,
		ee && !p && z !== "unanswered" ? "ArrowRight" : void 0
	].filter(Boolean).join(" ") || void 0;
	return {
		context: ye,
		itemProps: {
			"aria-describedby": xe,
			"aria-invalid": re || void 0,
			"aria-keyshortcuts": Se,
			disabled: n,
			hidden: !ee,
			inert: !ee,
			ref: be,
			tabIndex: -1
		},
		state: {
			active: ee,
			disabled: n,
			invalid: re,
			multiple: i,
			required: c,
			status: z
		}
	};
}
function cc({ defaultItem: e, item: t, items: n, noValidate: r, onItemChange: i, onReset: a, onSubmit: o, ref: s, shortcuts: c }) {
	let l = w.useMemo(() => nc(n), [n]), [u, d] = w.useState([]), [f, p] = w.useState(() => rc(l, e)), [m, h] = w.useState(null), [g, _] = w.useState(0), v = w.useRef(null), y = t !== void 0, b = y ? t : f, x = w.useRef(b), S = r === !1, C = c ?? null, T = w.useRef(/* @__PURE__ */ new Set());
	w.useLayoutEffect(() => {
		if (process.env.NODE_ENV === "production") return;
		if (!l || !m) {
			T.current.clear();
			return;
		}
		let t = !1;
		return queueMicrotask(() => {
			if (t) return;
			let n = [...ac(l, e), ...oc(l, u, C)], r = new Set(n);
			r.forEach((e) => {
				T.current.has(e) || console.warn(`[Questionnaire] ${e}`);
			}), T.current = r;
		}), () => {
			t = !0;
		};
	}, [
		l,
		e,
		u,
		m,
		C
	]), w.useLayoutEffect(() => {
		if (!m || typeof MutationObserver > "u") return;
		let e = new MutationObserver(() => {
			_((e) => e + 1);
		});
		return e.observe(m, {
			childList: !0,
			subtree: !0
		}), () => e.disconnect();
	}, [m]);
	let E = w.useMemo(() => u.filter((e) => !e.disabled).sort(Qs), [g, u]), D = w.useMemo(() => new Map(E.map((e) => [e.name, e])), [E]), O = l?.enabledItems ?? E, k = O.findIndex((e) => e.name === b), A = k < 0 || !b ? null : D.get(b) ?? null, j = b ? l?.itemByName.get(b) : void 0, M = k < 0 ? null : j ? !!j.required : A?.required ?? !1, N = k < 0 ? null : A?.status ?? (b ? "unanswered" : null), P = w.useMemo(() => l ? l.enabledItems.flatMap((e) => {
		let t = D.get(e.name);
		return t ? [t] : [];
	}) : E, [
		l,
		D,
		E
	]), F = O.length, I = k < 0 ? 0 : k + 1, ee = F > 0 && k === 0, L = F > 0 && k === F - 1, R = w.useCallback((e, t = "item") => {
		e !== b && (v.current = {
			name: e,
			target: t
		}, y || p(e), i?.(e));
	}, [
		b,
		y,
		i
	]);
	w.useLayoutEffect(() => {
		if (F === 0) return;
		if (k < 0) {
			if (!y && b === null) {
				p(O[0].name);
				return;
			}
			R(O[0].name);
			return;
		}
		let e = v.current, t = x.current !== b;
		if (x.current = b, !e || e.name !== b) {
			y && t && (v.current = null, A?.focus());
			return;
		}
		e.target === "invalid" ? A?.focusInvalid() : A?.focus(), v.current = null;
	}, [
		A,
		b,
		y,
		k,
		O,
		R,
		F
	]);
	let te = w.useCallback((e) => (d((t) => [...t.filter((t) => t.element !== e.element && t.name !== e.name), e]), () => {
		d((t) => t.filter((t) => t !== e));
	}), []), z = w.useCallback(() => {
		k <= 0 || R(O[k - 1].name);
	}, [
		k,
		O,
		R
	]), B = w.useCallback(() => {
		if (!(!A || k >= F - 1)) {
			if (!A.validate()) {
				A.focusInvalid();
				return;
			}
			R(O[k + 1].name);
		}
	}, [
		A,
		k,
		O,
		R,
		F
	]), ne = w.useCallback(() => {
		if (A) {
			if (!A.validate()) {
				A.focusInvalid();
				return;
			}
			if (L) {
				m?.requestSubmit();
				return;
			}
			R(O[k + 1].name);
		}
	}, [
		A,
		k,
		L,
		O,
		m,
		R
	]), re = w.useCallback(() => {
		if (!(!A || A.required)) {
			if (A.skip(), !L) {
				R(O[k + 1].name);
				return;
			}
			queueMicrotask(() => {
				m?.requestSubmit();
			});
		}
	}, [
		A,
		k,
		L,
		O,
		m,
		R
	]);
	function V(t) {
		if (a?.(t), t.defaultPrevented) return;
		for (let e of u) e.reset();
		let n = l ? rc(l, e) : E.find((t) => t.name === e)?.name ?? E[0]?.name;
		n && R(n);
	}
	function H(e) {
		let t = P.find((e) => !e.validate());
		if (t) {
			e.preventDefault(), R(t.name, "invalid"), t.name === b && (t.focusInvalid(), v.current = null);
			return;
		}
		o?.(e);
	}
	function ie(e) {
		if (e.defaultPrevented || e.nativeEvent.isComposing || e.keyCode === 229 || !A || !(e.target instanceof Element)) return;
		if (e.key === "Enter" && (e.metaKey || e.ctrlKey) && !e.altKey && !e.shiftKey) {
			e.preventDefault(), e.repeat || ne();
			return;
		}
		if (e.metaKey || e.ctrlKey || e.altKey) return;
		if ((e.key === "ArrowUp" || e.key === "ArrowDown") && A.moveAnswerFocus(e.target, e.key === "ArrowDown" ? "next" : "previous")) {
			e.preventDefault();
			return;
		}
		if ((e.key === "ArrowLeft" || e.key === "ArrowRight") && !Xs(e.target) && !Zs(e.target)) {
			if (e.preventDefault(), e.repeat) return;
			e.key === "ArrowLeft" ? z() : A.status !== "unanswered" && B();
			return;
		}
		if (e.key === "Enter") {
			let t = A.getAnswerByElement(e.target);
			if (!t) return;
			e.preventDefault(), !e.repeat && Js(t) && ne();
			return;
		}
		if (!C || Xs(e.target)) return;
		let t = Ks(e.key, C), n = t ? A.getAnswerByShortcut(t) : null;
		n && (e.preventDefault(), !e.repeat && (n.element.focus(), n.type === "choice" && n.element.click()));
	}
	let U = {
		current: I,
		first: ee,
		last: L,
		total: F
	}, ae = w.useMemo(() => ({
		...U,
		activeItem: A,
		activeItemName: b,
		activeItemRequired: M,
		activeItemStatus: N,
		domVersion: g,
		goNext: B,
		goPrevious: z,
		itemDefinitionByName: l?.itemByName ?? null,
		nativeValidation: S,
		registerItem: te,
		shortcuts: C,
		skipCurrent: re
	}), [
		A,
		b,
		M,
		N,
		l,
		I,
		g,
		ee,
		B,
		z,
		L,
		S,
		te,
		C,
		re,
		F
	]), W = w.useCallback((e) => {
		h(e), sn(s)?.(e);
	}, [s]);
	return {
		context: ae,
		rootProps: {
			"data-shortcuts": C ?? void 0,
			onKeyDown: ie,
			onReset: V,
			onSubmit: H,
			ref: W
		},
		state: U
	};
}
function lc({ defaultItem: e, item: t, items: n, noValidate: r = !0, onItemChange: i, onReset: a, onSubmit: o, ref: s, shortcuts: c, ...l }) {
	let { context: u, rootProps: d, state: f } = cc({
		defaultItem: e,
		item: t,
		items: n,
		noValidate: r,
		onItemChange: i,
		onReset: a,
		onSubmit: o,
		ref: s,
		shortcuts: c
	}), p = tn({
		defaultTagName: "form",
		props: nn({
			...d,
			noValidate: r
		}, l),
		state: f
	});
	return N(zs.Provider, {
		value: u,
		children: p
	});
}
function uc({ children: e, render: t, ...n }) {
	let { current: r, first: i, last: a, total: o } = Vs("Questionnaire.Progress"), s = o ? `Question ${r} of ${o}` : void 0;
	return tn({
		defaultTagName: "div",
		props: nn({
			"aria-label": "Questionnaire progress",
			"aria-live": "polite",
			"aria-valuemax": o || void 0,
			"aria-valuemin": o ? 1 : void 0,
			"aria-valuenow": o ? r : void 0,
			"aria-valuetext": s,
			children: e ?? s,
			role: "progressbar"
		}, n),
		render: t,
		state: {
			current: r,
			first: i,
			last: a,
			total: o
		}
	});
}
function dc({ "aria-describedby": e, "aria-keyshortcuts": t, children: n, disabled: r = !1, invalid: i = !1, multiple: a = !1, name: o, onStatusChange: s, ref: c, required: l = !1, ...u }) {
	let { context: d, itemProps: f, state: p } = sc({
		"aria-describedby": e,
		"aria-keyshortcuts": t,
		disabled: r,
		invalid: i,
		multiple: a,
		name: o,
		onStatusChange: s,
		ref: c,
		required: l
	}), m = tn({
		defaultTagName: "fieldset",
		props: nn({
			...f,
			children: n
		}, u),
		state: p,
		stateAttributesMapping: { active: (e) => ({ "data-active": e ? "" : void 0 }) }
	});
	return N(Bs.Provider, {
		value: d,
		children: m
	});
}
function fc({ render: e, ...t }) {
	return Us("Questionnaire.Title"), tn({
		defaultTagName: "legend",
		props: t,
		render: e
	});
}
function pc({ id: e, render: t, ...n }) {
	let { registerDescription: r } = Us("Questionnaire.Description"), i = w.useId(), a = e ?? i;
	return w.useLayoutEffect(() => r(a), [a, r]), tn({
		defaultTagName: "p",
		props: nn({ id: a }, n),
		render: t
	});
}
function mc({ render: e, ...t }) {
	let { shortcuts: n } = Us("Questionnaire.Choices");
	return tn({
		defaultTagName: "div",
		props: t,
		render: e,
		state: { shortcuts: n }
	});
}
function hc({ checked: e, children: t, defaultChecked: n = !1, disabled: r = !1, onChange: i, render: a, value: o, ...s }) {
	let { inputProps: c, state: l } = ec({
		checked: e,
		defaultChecked: n,
		disabled: r,
		onChange: i,
		value: o
	}), u = tn({
		defaultTagName: "label",
		props: nn({ children: t }, s),
		render: a,
		state: l,
		stateAttributesMapping: { checked: (e) => ({
			"data-checked": e ? "" : void 0,
			"data-unchecked": e ? void 0 : ""
		}) }
	});
	return N(Rs.Provider, {
		value: {
			inputProps: c,
			state: l
		},
		children: u
	});
}
function gc({ render: e, ...t }) {
	let { inputProps: n, state: r } = Hs("Questionnaire.ChoiceInput");
	return tn({
		defaultTagName: "input",
		props: nn(n, t),
		render: e,
		state: r,
		stateAttributesMapping: { checked: (e) => ({
			"data-checked": e ? "" : void 0,
			"data-unchecked": e ? void 0 : ""
		}) }
	});
}
function _c({ render: e, ...t }) {
	return Hs("Questionnaire.ChoiceLabel"), tn({
		defaultTagName: "span",
		props: t,
		render: e
	});
}
function vc({ children: e, render: t, ...n }) {
	let { state: r } = Hs("Questionnaire.ChoiceShortcut"), i = { shortcut: r.shortcut };
	return tn({
		defaultTagName: "span",
		props: nn({
			"aria-hidden": !0,
			children: e ?? r.shortcut,
			hidden: r.shortcut === null
		}, n),
		render: t,
		state: i
	});
}
function yc({ defaultValue: e, disabled: t = !1, onChange: n, ref: r, render: i, type: a = "text", value: o, ...s }) {
	let { inputProps: c, state: l } = tc({
		defaultValue: e,
		disabled: t,
		onChange: n,
		ref: r,
		type: a,
		value: o
	});
	return tn({
		defaultTagName: "input",
		props: nn(c, s),
		render: i,
		state: l,
		stateAttributesMapping: { filled: (e) => ({
			"data-empty": e ? void 0 : "",
			"data-filled": e ? "" : void 0
		}) }
	});
}
function bc({ children: e, id: t, render: n, ...r }) {
	let { invalid: i, registerError: a, required: o } = Us("Questionnaire.Error"), s = w.useId(), c = t ?? s;
	return w.useLayoutEffect(() => a(c), [c, a]), tn({
		defaultTagName: "p",
		props: nn({
			children: e ?? (o ? "Choose an answer to continue." : "Choose an answer or skip this question."),
			hidden: !i,
			id: c,
			role: i ? "alert" : void 0
		}, r),
		render: n,
		state: { invalid: i }
	});
}
function xc({ children: e, disabled: t = !1, onClick: n, render: r, tabIndex: i, type: a = "button", ...o }) {
	let s = Vs("Questionnaire.Previous"), c = s.total > 1 && !s.first;
	function l(e) {
		n?.(e), e.defaultPrevented || s.goPrevious();
	}
	return Tc({
		children: e ?? "Previous",
		disabled: t,
		onClick: l,
		props: o,
		render: r,
		status: s.activeItemStatus,
		tabIndex: i,
		type: a,
		visible: c
	});
}
function Sc({ children: e, disabled: t = !1, onClick: n, render: r, tabIndex: i, type: a = "button", ...o }) {
	let s = Vs("Questionnaire.Skip"), c = s.activeItemRequired === !1;
	function l(e) {
		n?.(e), e.defaultPrevented || s.skipCurrent();
	}
	return Tc({
		children: e ?? "Skip",
		disabled: t,
		onClick: l,
		props: o,
		render: r,
		status: s.activeItemStatus,
		tabIndex: i,
		type: a,
		visible: c
	});
}
function Cc({ children: e, disabled: t = !1, onClick: n, render: r, tabIndex: i, type: a = "button", ...o }) {
	let s = Vs("Questionnaire.Next"), c = s.total > 1 && !s.last;
	function l(e) {
		n?.(e), e.defaultPrevented || s.goNext();
	}
	return Tc({
		children: e ?? "Next",
		disabled: t,
		onClick: l,
		props: o,
		render: r,
		shortcut: "Enter",
		status: s.activeItemStatus,
		tabIndex: i,
		type: a,
		visible: c
	});
}
function wc({ children: e, disabled: t = !1, render: n, tabIndex: r, type: i = "submit", ...a }) {
	let o = Vs("Questionnaire.Submit"), s = o.total > 0 && o.last;
	return Tc({
		children: e ?? "Submit",
		disabled: t,
		props: a,
		render: n,
		shortcut: "Enter",
		status: o.activeItemStatus,
		tabIndex: r,
		type: i,
		visible: s
	});
}
function Tc({ children: e, disabled: t, onClick: n, props: r, render: i, shortcut: a, status: o, tabIndex: s, type: c, visible: l }) {
	let u = l && !t ? a ?? null : null, d = {
		disabled: t,
		shortcut: u,
		status: o,
		visible: l
	};
	return tn({
		defaultTagName: "button",
		props: nn({
			"aria-hidden": !l || void 0,
			"aria-keyshortcuts": u ?? void 0,
			children: e,
			disabled: t,
			hidden: !l,
			inert: !l,
			onClick: n,
			tabIndex: l ? s : -1,
			type: c
		}, r),
		render: i,
		state: d,
		stateAttributesMapping: { visible: (e) => ({
			"data-hidden": e ? void 0 : "",
			"data-visible": e ? "" : void 0
		}) }
	});
}
var Ec = {
	Root: lc,
	Progress: uc,
	Item: dc,
	Title: fc,
	Description: pc,
	Choices: mc,
	Choice: hc,
	ChoiceInput: gc,
	ChoiceLabel: _c,
	ChoiceShortcut: vc,
	Input: yc,
	Error: bc,
	Previous: xc,
	Skip: Sc,
	Next: Cc,
	Submit: wc
};
function Dc({ className: e, ...t }) {
	return /* @__PURE__ */ N(Ec.Root, {
		"data-quill": !0,
		"data-slot": "questionnaire",
		className: q("quill-questionnaire", e),
		...t
	});
}
function Oc({ className: e, ...t }) {
	return /* @__PURE__ */ N(Ec.Progress, {
		"data-slot": "questionnaire-progress",
		className: q("quill-questionnaire__progress", e),
		...t
	});
}
function kc({ className: e, ...t }) {
	return /* @__PURE__ */ N(Ec.Item, {
		"data-slot": "questionnaire-item",
		className: q("quill-questionnaire__item", e),
		...t
	});
}
function Ac({ className: e, ...t }) {
	return /* @__PURE__ */ N(Ec.Title, {
		"data-slot": "questionnaire-title",
		className: q("quill-questionnaire__title", e),
		...t
	});
}
function jc({ className: e, ...t }) {
	return /* @__PURE__ */ N(Ec.Description, {
		"data-slot": "questionnaire-description",
		className: q("quill-questionnaire__description", e),
		...t
	});
}
function Mc({ className: e, ...t }) {
	return /* @__PURE__ */ N(Ec.Choices, {
		"data-slot": "questionnaire-choices",
		className: q("quill-questionnaire__choices", e),
		...t
	});
}
function Nc({ children: e, className: t, ...n }) {
	return /* @__PURE__ */ P(Ec.Choice, {
		"data-slot": "questionnaire-choice",
		className: q("quill-questionnaire__choice", t),
		...n,
		children: [
			/* @__PURE__ */ N(Ec.ChoiceInput, {
				"data-slot": "questionnaire-choice-input",
				className: "quill-questionnaire__choice-input"
			}),
			/* @__PURE__ */ P("span", {
				"aria-hidden": "true",
				"data-slot": "questionnaire-choice-indicator",
				className: "quill-questionnaire__choice-indicator",
				children: [/* @__PURE__ */ N("span", {
					"data-slot": "questionnaire-choice-indicator-dot",
					className: "quill-questionnaire__choice-indicator-dot"
				}), /* @__PURE__ */ N(s, {
					"data-slot": "questionnaire-choice-indicator-check",
					className: "quill-questionnaire__choice-indicator-check"
				})]
			}),
			/* @__PURE__ */ N(Ec.ChoiceLabel, {
				"data-slot": "questionnaire-choice-label",
				className: "quill-questionnaire__choice-label",
				children: e
			}),
			/* @__PURE__ */ N(Ec.ChoiceShortcut, {
				"data-slot": "questionnaire-choice-shortcut",
				className: q(ze({
					variant: "outline",
					size: "xs"
				}), "quill-questionnaire__choice-shortcut")
			})
		]
	});
}
function Pc({ className: e, ...t }) {
	return /* @__PURE__ */ N("span", {
		"data-slot": "questionnaire-choice-description",
		className: q("quill-questionnaire__choice-description", e),
		...t
	});
}
function Fc({ className: e, render: t, ...n }) {
	return /* @__PURE__ */ N("div", {
		"data-slot": "questionnaire-input-wrapper",
		className: "quill-questionnaire__input-wrapper",
		children: /* @__PURE__ */ N(Ec.Input, {
			"data-slot": "questionnaire-input",
			className: e,
			render: t ?? ((e) => /* @__PURE__ */ P(He, {
				"data-slot": "questionnaire-input-group",
				"aria-disabled": e.disabled ? !0 : void 0,
				"data-filled": e.name !== void 0 || void 0,
				className: "quill-questionnaire__input-group",
				children: [/* @__PURE__ */ N(We, {
					align: "inline-start",
					children: /* @__PURE__ */ P("span", {
						"aria-hidden": "true",
						"data-slot": "questionnaire-input-indicator",
						className: "quill-questionnaire__input-indicator",
						children: [/* @__PURE__ */ N("span", { className: "quill-questionnaire__input-indicator-dot" }), /* @__PURE__ */ N(s, { className: "quill-questionnaire__input-indicator-check" })]
					})
				}), /* @__PURE__ */ N(Je, { ...e })]
			})),
			...n
		})
	});
}
function Ic({ className: e, ...t }) {
	return /* @__PURE__ */ N(Ec.Error, {
		"data-slot": "questionnaire-error",
		className: q("quill-questionnaire__error", e),
		...t
	});
}
function Lc({ className: e, ...t }) {
	return /* @__PURE__ */ N("div", {
		"data-slot": "questionnaire-actions",
		className: q("quill-questionnaire__actions", e),
		...t
	});
}
function Rc({ children: e, className: t, render: n, ...r }) {
	return /* @__PURE__ */ N(Ec.Previous, {
		"data-slot": "questionnaire-previous",
		className: q("quill-questionnaire__previous", t),
		render: n ?? /* @__PURE__ */ N(J, { variant: "outline" }),
		...r,
		children: e ?? "Previous"
	});
}
function zc({ children: e, className: t, render: n, ...r }) {
	return /* @__PURE__ */ N(Ec.Skip, {
		"data-slot": "questionnaire-skip",
		className: q("quill-questionnaire__skip", t),
		render: n ?? /* @__PURE__ */ N(J, { variant: "outline" }),
		...r,
		children: e ?? "Skip"
	});
}
function Bc({ children: e, className: t, render: n, ...r }) {
	return /* @__PURE__ */ N(Ec.Next, {
		"data-slot": "questionnaire-next",
		className: q("quill-questionnaire__next", t),
		render: n ?? /* @__PURE__ */ N(J, { variant: "primary" }),
		...r,
		children: e ?? "Next"
	});
}
function Vc({ children: e, className: t, render: n, ...r }) {
	return /* @__PURE__ */ N(Ec.Submit, {
		"data-slot": "questionnaire-submit",
		className: q("quill-questionnaire__submit", t),
		render: n ?? /* @__PURE__ */ N(J, { variant: "primary" }),
		...r,
		children: e ?? "Submit"
	});
}
function Hc({ className: e, ...t }) {
	return /* @__PURE__ */ N(ge.Group, {
		"data-quill": !0,
		"data-slot": "resizable-panel-group",
		className: q("group/resizable-panel-group flex h-full w-full aria-[orientation=vertical]:flex-col", e),
		...t
	});
}
function Uc({ ...e }) {
	return /* @__PURE__ */ N(ge.Panel, {
		"data-slot": "resizable-panel",
		...e
	});
}
function Wc({ withHandle: e, className: t, ...n }) {
	let r = w.useRef(null);
	return w.useEffect(() => {
		let e = r.current;
		if (!e) return;
		let t = () => {
			e.blur();
		};
		return e.addEventListener("pointerup", t), () => e.removeEventListener("pointerup", t);
	}, []), /* @__PURE__ */ N(ge.Separator, {
		"data-slot": "resizable-handle",
		elementRef: r,
		className: q("quill-resizable__handle flex items-center justify-center", t),
		...n,
		children: e && /* @__PURE__ */ N("div", {})
	});
}
var Gc = _e.Root;
function Kc({ className: e, ...t }) {
	return /* @__PURE__ */ N(_e.Group, {
		"data-slot": "select-group",
		className: q("quill-select__group", e),
		...t
	});
}
function qc({ className: e, ...t }) {
	return /* @__PURE__ */ N(_e.Value, {
		"data-slot": "select-value",
		className: q("quill-select__value", e),
		...t
	});
}
function Jc({ className: e, ...t }) {
	return /* @__PURE__ */ N(c, {
		className: q("quill-select__icon", e),
		...t
	});
}
function Yc({ className: e, size: t = "default", children: n, ...r }) {
	return /* @__PURE__ */ P(_e.Trigger, {
		"data-slot": "select-trigger",
		"data-size": t,
		className: q("quill-select__trigger group/select-trigger flex items-center justify-between gap-3 whitespace-nowrap outline-none", e),
		render: /* @__PURE__ */ N(J, {
			variant: "outline",
			left: !0
		}),
		...r,
		children: [n, /* @__PURE__ */ N(_e.Icon, { render: /* @__PURE__ */ N(Jc, {}) })]
	});
}
function Xc({ className: e, children: t, side: n = "bottom", sideOffset: r = 4, align: i = "center", alignOffset: a = 0, alignItemWithTrigger: o = !0, ...s }) {
	return /* @__PURE__ */ N(_e.Portal, { children: /* @__PURE__ */ N(_e.Positioner, {
		"data-quill": !0,
		"data-quill-portal": "popover",
		side: n,
		sideOffset: r,
		align: i,
		alignOffset: a,
		alignItemWithTrigger: o,
		className: "isolate",
		children: /* @__PURE__ */ P(_e.Popup, {
			"data-slot": "select-content",
			"data-align-trigger": o,
			className: q("quill-select__content", e),
			...s,
			children: [
				/* @__PURE__ */ N(el, { className: "quill-select__scroll-button flex items-center justify-center" }),
				/* @__PURE__ */ N(_e.List, {
					className: "quill-select__list scroll-mask-y-4 scroll-py-4",
					children: t
				}),
				/* @__PURE__ */ N(tl, {})
			]
		})
	}) });
}
function Zc({ className: e, ...t }) {
	return /* @__PURE__ */ N(_e.GroupLabel, {
		"data-slot": "select-label",
		className: e,
		render: /* @__PURE__ */ N(Qe, {}),
		...t
	});
}
function Qc({ className: e, children: t, ...n }) {
	return /* @__PURE__ */ P(_e.Item, {
		"data-slot": "select-item",
		className: q("quill-select__item group/select-item flex w-full cursor-default items-center gap-2 select-none", e),
		...n,
		children: [/* @__PURE__ */ N(_e.ItemText, {
			className: "flex flex-1 shrink-0 gap-2 whitespace-nowrap",
			children: t
		}), /* @__PURE__ */ N(_e.ItemIndicator, {
			render: /* @__PURE__ */ N("span", { className: "pointer-events-none absolute end-2 flex items-center justify-center" }),
			children: /* @__PURE__ */ N(s, { className: "pointer-events-none" })
		})]
	});
}
function $c({ className: e, ...t }) {
	return /* @__PURE__ */ N(_e.Separator, {
		"data-slot": "select-separator",
		className: q("quill-select__separator", e),
		...t
	});
}
function el({ className: e, ...t }) {
	return /* @__PURE__ */ N(_e.ScrollUpArrow, {
		"data-slot": "select-scroll-up-button",
		className: q("quill-select__scroll-button quill-select__scroll-button--up", e),
		render: /* @__PURE__ */ N(J, {
			variant: "outline",
			size: "icon-sm"
		}),
		...t,
		children: /* @__PURE__ */ N(f, {})
	});
}
function tl({ className: e, ...t }) {
	return /* @__PURE__ */ N(_e.ScrollDownArrow, {
		"data-slot": "select-scroll-down-button",
		className: q("quill-select__scroll-button quill-select__scroll-button--down", e),
		render: /* @__PURE__ */ N(J, {
			variant: "outline",
			size: "icon-sm"
		}),
		...t,
		children: /* @__PURE__ */ N(c, {})
	});
}
function nl({ className: e, ...t }) {
	return /* @__PURE__ */ N("div", {
		"data-quill": !0,
		"data-slot": "skeleton",
		className: q("quill-skeleton", e),
		...t
	});
}
function rl({ lines: e = 3, className: t, minWidth: n = 60, maxWidth: r = 100 }) {
	let i = w.useMemo(() => Array.from({ length: e }).map((t, i) => {
		if (i === 0) return `${r}%`;
		if (i === e - 1) return `${Math.max(n, 40)}%`;
		let a = Math.random() * (r - n) + n;
		return `${Math.round(a)}%`;
	}), [
		e,
		n,
		r
	]);
	return /* @__PURE__ */ N("div", {
		"data-quill": !0,
		className: q("flex flex-col", t),
		children: i.map((e, t) => /* @__PURE__ */ N("span", {
			className: "relative block w-full",
			style: { height: "1lh" },
			children: /* @__PURE__ */ N(nl, {
				className: "absolute left-0 right-auto",
				style: {
					width: e,
					height: "0.7em",
					top: "50%",
					transform: "translateY(-50%)"
				}
			})
		}, t))
	});
}
function il({ className: e, defaultValue: t, value: n, min: r = 0, max: i = 100, ...a }) {
	let o = w.useMemo(() => Array.isArray(n) ? n : Array.isArray(t) ? t : [r, i], [
		n,
		t,
		r,
		i
	]);
	return /* @__PURE__ */ N(ve.Root, {
		"data-quill": !0,
		"data-slot": "slider",
		className: q("quill-slider", e),
		defaultValue: t,
		value: n,
		min: r,
		max: i,
		thumbAlignment: "edge",
		...a,
		children: /* @__PURE__ */ P(ve.Control, {
			className: "quill-slider__control",
			children: [/* @__PURE__ */ N(ve.Track, {
				"data-slot": "slider-track",
				className: "quill-slider__track",
				children: /* @__PURE__ */ N(ve.Indicator, {
					"data-slot": "slider-range",
					className: "quill-slider__range"
				})
			}), Array.from({ length: o.length }, (e, t) => /* @__PURE__ */ N(ve.Thumb, {
				"data-slot": "slider-thumb",
				className: "quill-slider__thumb flex items-center justify-center"
			}, t))]
		})
	});
}
var al = ye.createToastManager(), ol = ye.createToastManager(), sl = {
	success: /* @__PURE__ */ N(m, { className: "quill-toast-card__icon--success size-6" }),
	info: /* @__PURE__ */ N(_, { className: "quill-toast-card__icon--info size-6" }),
	warning: /* @__PURE__ */ N(S, { className: "quill-toast-card__icon--warning size-6" }),
	error: /* @__PURE__ */ N(C, { className: "quill-toast-card__icon--error size-6" }),
	loading: /* @__PURE__ */ N(Re, { className: "quill-toast-card__icon--loading size-6" })
}, cl = w.forwardRef(({ className: e, toastTitle: t, toastDescription: n, icon: r, action: i, onDismiss: a, showGapHitArea: o, children: s, ...c }, l) => {
	let u = t !== void 0 && n === void 0, d = n !== void 0 && t === void 0;
	return /* @__PURE__ */ P("div", {
		ref: l,
		className: q("quill-toast-card", e),
		...c,
		children: [
			o && /* @__PURE__ */ N("span", {
				className: "pointer-events-auto absolute left-0 top-full w-full",
				style: { height: "calc(var(--gap) + 1px)" }
			}),
			/* @__PURE__ */ P("div", {
				className: q("flex items-center gap-3", a && "pe-8"),
				children: [r && /* @__PURE__ */ N("span", {
					className: q("shrink-0 self-start mt-1", !t && n && "mt-0"),
					children: r
				}), /* @__PURE__ */ P("div", {
					className: "flex-1 min-w-0",
					children: [t && /* @__PURE__ */ N("div", {
						className: "quill-toast-card__title",
						children: t
					}), n && /* @__PURE__ */ N("div", {
						className: "quill-toast-card__description",
						children: n
					})]
				})]
			}),
			i && /* @__PURE__ */ P("div", {
				className: "flex items-center gap-3 mt-2",
				children: [r && /* @__PURE__ */ N("span", { className: "size-6 shrink-0" }), /* @__PURE__ */ N(J, {
					variant: "outline",
					size: "sm",
					className: "quill-toast-card__action",
					onClick: i.onClick,
					children: i.label
				})]
			}),
			a && /* @__PURE__ */ N(J, {
				size: "icon-sm",
				className: q("absolute right-2", u && "top-1" || d && "top-1" || "top-2"),
				onClick: a,
				children: /* @__PURE__ */ N(C, { className: "size-3.5" })
			}),
			s
		]
	});
});
cl.displayName = "ToastCard";
var ll = {
	"--gap": "0.75rem",
	"--peek": "0.75rem",
	"--scale": "calc(max(0, 1 - (var(--toast-index) * 0.1)))",
	"--shrink": "calc(1 - var(--scale))",
	"--height": "var(--toast-frontmost-height, var(--toast-height))",
	"--offset-y": "calc(var(--toast-offset-y) * -1 + (var(--toast-index) * var(--gap) * -1) + var(--toast-swipe-movement-y))",
	position: "absolute",
	right: 0,
	bottom: 0,
	left: "auto",
	width: "100%",
	height: "auto",
	zIndex: "calc(1000 - var(--toast-index))",
	transformOrigin: "bottom center",
	transform: "translateX(var(--toast-swipe-movement-x)) translateY(calc(var(--toast-swipe-movement-y) - (var(--toast-index) * var(--peek)) - (var(--shrink) * var(--height)))) scale(var(--scale))",
	transition: "transform 0.5s cubic-bezier(0.22, 1, 0.36, 1), opacity 0.5s, height 0.15s"
};
function ul({ children: e, limit: t = 3, timeout: n = 5e3 }) {
	return /* @__PURE__ */ P(ye.Provider, {
		toastManager: al,
		limit: t,
		timeout: n,
		children: [/* @__PURE__ */ P(ye.Provider, {
			toastManager: ol,
			limit: t,
			timeout: n,
			children: [e, /* @__PURE__ */ N(fl, {})]
		}), /* @__PURE__ */ N(dl, {})]
	});
}
function dl() {
	let e = ye.useToastManager();
	return /* @__PURE__ */ N(ye.Portal, { children: /* @__PURE__ */ N(ye.Viewport, {
		"data-quill": !0,
		"data-quill-portal": "toast",
		className: "fixed bottom-4 right-4 w-[360px]",
		children: e.toasts.map((e) => {
			let t = e.type;
			return /* @__PURE__ */ N(ye.Root, {
				toast: e,
				style: ll,
				render: /* @__PURE__ */ N(cl, {
					toastTitle: e.title,
					toastDescription: e.description,
					icon: t ? sl[t] : void 0,
					showGapHitArea: !0,
					action: e.data?.action ? {
						label: e.data.action.label,
						onClick: () => {
							al.close(e.id), e.data?.action?.onClick();
						}
					} : void 0,
					onDismiss: () => al.close(e.id),
					className: q("m-0 p-3", "data-[expanded]:![transform:translateX(var(--toast-swipe-movement-x))_translateY(var(--offset-y))]", "data-[expanded]:![height:var(--toast-height)]", "data-[starting-style]:![transform:translateY(150%)]", "data-[ending-style]:![transform:translateY(150%)]", "data-[ending-style]:opacity-0", "data-[limited]:opacity-0")
				})
			}, e.id);
		})
	}) });
}
function fl() {
	let e = ye.useToastManager();
	return /* @__PURE__ */ N(ye.Portal, { children: /* @__PURE__ */ N(ye.Viewport, {
		"data-quill": !0,
		"data-quill-portal": "toast",
		className: "fixed",
		children: e.toasts.map((t) => /* @__PURE__ */ N(ye.Positioner, {
			toast: t,
			side: "top",
			sideOffset: 8,
			children: /* @__PURE__ */ N(ye.Root, {
				toast: t,
				render: /* @__PURE__ */ N(cl, {
					toastTitle: t.title,
					toastDescription: t.description,
					action: t.data?.action ? {
						label: t.data.action.label,
						onClick: () => {
							e.close(t.id), t.data?.action?.onClick();
						}
					} : void 0,
					onDismiss: t.data?.action ? () => e.close(t.id) : void 0,
					className: q("w-max max-w-[320px]", "data-[starting-style]:opacity-0 data-[starting-style]:scale-95", "data-[ending-style]:opacity-0 data-[ending-style]:scale-95", "transition-[opacity,transform] duration-200 ease-out")
				})
			})
		}, t.id))
	}) });
}
function pl(e) {
	let { title: t, description: n, type: r, timeout: i, onClose: a, action: o } = e;
	return al.add({
		title: t,
		description: n,
		type: r,
		timeout: i,
		onClose: a,
		data: o ? { action: o } : void 0
	});
}
function ml(e) {
	return pl(e);
}
ml.success = (e) => pl({
	...e,
	type: "success"
}), ml.info = (e) => pl({
	...e,
	type: "info"
}), ml.warning = (e) => pl({
	...e,
	type: "warning"
}), ml.error = (e) => pl({
	...e,
	type: "error"
}), ml.loading = (e) => pl({
	...e,
	type: "loading",
	timeout: 0
}), ml.dismiss = (e) => {
	al.close(e);
}, ml.update = (e, t) => {
	let { title: n, description: r, type: i, timeout: a, onClose: o, action: s } = t;
	al.update(e, {
		title: n,
		description: r,
		type: i,
		timeout: a,
		onClose: o,
		data: s ? { action: s } : void 0
	});
};
function hl(e) {
	let { title: t, description: n, type: r, timeout: i, action: a, anchor: o, side: s, sideOffset: c, onClose: l } = e;
	return ol.add({
		title: t,
		description: n,
		type: r,
		timeout: i,
		onClose: l,
		data: a ? { action: a } : void 0,
		positionerProps: {
			anchor: o,
			side: s,
			sideOffset: c
		}
	});
}
hl.dismiss = (e) => {
	ol.close(e);
};
function gl({ className: e, size: t = "default", ...n }) {
	return /* @__PURE__ */ N(be.Root, {
		"data-quill": !0,
		"data-slot": "switch",
		"data-size": t,
		className: q("quill-switch peer group/switch inline-flex shrink-0 items-center", e),
		...n,
		children: /* @__PURE__ */ N(be.Thumb, {
			"data-slot": "switch-thumb",
			className: "quill-switch__thumb"
		})
	});
}
function _l(e, ...t) {
	for (let n of t) typeof n == "function" ? n(e) : n && (n.current = e);
}
function vl(e, t) {
	w.useEffect(() => {
		let n = e.current, r = t.current;
		if (!n || !r) return;
		let i = () => {
			let { scrollTop: e, scrollLeft: t, scrollWidth: i, clientWidth: a, scrollHeight: o, clientHeight: s } = r, c = Math.abs(t);
			n.toggleAttribute("data-scroll-top", e > 0), n.toggleAttribute("data-scroll-bottom", Math.ceil(e + s) < o), n.toggleAttribute("data-scroll-left", c > 0), n.toggleAttribute("data-scroll-right", Math.ceil(c + a) < i);
		};
		i(), r.addEventListener("scroll", i, { passive: !0 });
		let a = new ResizeObserver(i);
		a.observe(r);
		for (let e of Array.from(r.children)) a.observe(e);
		return () => {
			r.removeEventListener("scroll", i), a.disconnect();
		};
	}, [e, t]);
}
var yl = w.forwardRef(function({ className: e, tableClassName: t, stickyHeader: n = !1, fullWidth: r = !1, size: i = "default", viewportRef: a, ...o }, s) {
	let c = w.useRef(null), l = w.useRef(null);
	vl(c, l);
	let u = w.useCallback((e) => _l(e, l, a), [a]);
	return /* @__PURE__ */ N("div", {
		ref: c,
		"data-quill": !0,
		"data-slot": "table-container",
		"data-page-sticky": n === "page" ? "" : void 0,
		className: q("quill-table__root", e),
		children: /* @__PURE__ */ N("div", {
			ref: u,
			"data-slot": "table-viewport",
			className: "quill-table__viewport",
			children: /* @__PURE__ */ N("table", {
				ref: s,
				"data-slot": "table",
				"data-sticky-header": n ? "" : void 0,
				"data-full-width": r ? "" : void 0,
				"data-size": i,
				className: q("quill-table", t),
				...o
			})
		})
	});
}), bl = w.forwardRef(function({ className: e, ...t }, n) {
	return /* @__PURE__ */ N("thead", {
		ref: n,
		"data-slot": "table-header",
		className: q("quill-table__header", e),
		...t
	});
}), xl = w.forwardRef(function({ className: e, ...t }, n) {
	return /* @__PURE__ */ N("tbody", {
		ref: n,
		"data-slot": "table-body",
		className: q("quill-table__body", e),
		...t
	});
}), Sl = w.forwardRef(function({ className: e, ...t }, n) {
	return /* @__PURE__ */ N("tfoot", {
		ref: n,
		"data-slot": "table-footer",
		className: q("quill-table__footer", e),
		...t
	});
}), Cl = w.forwardRef(function({ className: e, ...t }, n) {
	return /* @__PURE__ */ N("tr", {
		ref: n,
		"data-slot": "table-row",
		className: q("quill-table__row", e),
		...t
	});
}), wl = w.forwardRef(function({ className: e, sticky: t, align: n, valign: r, expand: i, scope: a = "col", ...o }, s) {
	return /* @__PURE__ */ N("th", {
		ref: s,
		"data-slot": "table-head",
		"data-sticky": t,
		"data-align": n,
		"data-valign": r,
		"data-expand": i ? "" : void 0,
		scope: a,
		className: q("quill-table__head", e),
		...o
	});
}), Tl = w.forwardRef(function({ className: e, sticky: t, align: n, valign: r, expand: i, ...a }, o) {
	return /* @__PURE__ */ N("td", {
		ref: o,
		"data-slot": "table-cell",
		"data-sticky": t,
		"data-align": n,
		"data-valign": r,
		"data-expand": i ? "" : void 0,
		className: q("quill-table__cell", e),
		...a
	});
}), El = w.forwardRef(function({ className: e, colSpan: t = 1e3, children: n, ...r }, i) {
	return /* @__PURE__ */ N("tbody", {
		"data-slot": "table-empty",
		children: /* @__PURE__ */ N("tr", { children: /* @__PURE__ */ N("td", {
			ref: i,
			colSpan: t,
			className: q("quill-table__empty", e),
			...r,
			children: /* @__PURE__ */ N("div", {
				className: "quill-table__empty-inner",
				children: n
			})
		}) })
	});
}), Dl = w.forwardRef(function({ className: e, ...t }, n) {
	return /* @__PURE__ */ N("caption", {
		ref: n,
		"data-slot": "table-caption",
		className: q("quill-table__caption", e),
		...t
	});
});
yl.displayName = "Table", bl.displayName = "TableHeader", xl.displayName = "TableBody", Sl.displayName = "TableFooter", Cl.displayName = "TableRow", wl.displayName = "TableHead", Tl.displayName = "TableCell", El.displayName = "TableEmpty", Dl.displayName = "TableCaption";
function Ol({ className: e, orientation: t = "horizontal", ...n }) {
	return /* @__PURE__ */ N(xe.Root, {
		"data-slot": "tabs",
		"data-orientation": t,
		className: q("group/tabs flex gap-2 data-[orientation=horizontal]:flex-col", e),
		...n
	});
}
var kl = L("quill-tabs__list group/tabs-list inline-flex w-fit items-center justify-center relative", {
	variants: { variant: {
		default: "quill-tabs__list--variant-default",
		line: "quill-tabs__list--variant-line"
	} },
	defaultVariants: { variant: "default" }
}), Al = L("quill-tabs__indicator", {
	variants: { variant: {
		default: "quill-tabs__indicator--variant-default",
		line: "quill-tabs__indicator--variant-line"
	} },
	defaultVariants: { variant: "default" }
});
function jl({ className: e, variant: t = "default", ...n }) {
	return /* @__PURE__ */ P(xe.List, {
		"data-quill": !0,
		"data-slot": "tabs-list",
		"data-variant": t,
		className: q(kl({ variant: t }), e),
		...n,
		children: [n.children, /* @__PURE__ */ N(xe.Indicator, { className: Al({ variant: t }) })]
	});
}
function Ml({ className: e, ...t }) {
	return /* @__PURE__ */ N(xe.Tab, {
		"data-slot": "tabs-trigger",
		className: q("quill-tabs__trigger inline-flex items-center justify-center gap-1.5 whitespace-nowrap", e),
		...t,
		render: (e) => /* @__PURE__ */ N(J, { ...e })
	});
}
function Nl({ className: e, ...t }) {
	return /* @__PURE__ */ N(xe.Panel, {
		"data-slot": "tabs-content",
		className: q("quill-tabs__panel", e),
		...t
	});
}
var Pl = L("", {
	variants: {
		size: {
			lg: "text-lg",
			base: "text-base",
			sm: "text-sm",
			xs: "text-xs",
			xxs: "text-xxs"
		},
		variant: {
			default: "text-foreground",
			muted: "text-muted-foreground",
			destructive: "text-destructive-foreground"
		},
		weight: {
			normal: "font-normal",
			medium: "font-medium",
			semibold: "font-semibold"
		}
	},
	defaultVariants: {
		size: "base",
		variant: "default",
		weight: "normal"
	}
});
function Fl({ className: e, size: t = "base", variant: n = "default", weight: r = "normal", render: i, ...a }) {
	return B({
		defaultTagName: "p",
		props: z({
			"data-quill": "",
			className: q(Pl({
				size: t,
				variant: n,
				weight: r
			}), e)
		}, a),
		render: i,
		state: {
			slot: "text",
			size: t,
			variant: n,
			weight: r
		}
	});
}
var Il = L("quill-toggle group/toggle inline-flex items-center justify-center gap-1 whitespace-nowrap", {
	variants: {
		variant: {
			default: "quill-toggle--variant-default",
			outline: "quill-toggle--variant-outline"
		},
		size: {
			default: "quill-toggle--size-default",
			sm: "quill-toggle--size-sm",
			lg: "quill-toggle--size-lg",
			icon: "quill-toggle--size-icon"
		}
	},
	defaultVariants: {
		variant: "default",
		size: "default"
	}
});
function Ll({ className: e, variant: t = "default", size: n = "default", ...r }) {
	return /* @__PURE__ */ N(H, {
		"data-quill": !0,
		"data-slot": "toggle",
		className: q(Il({
			variant: t,
			size: n,
			className: e
		})),
		...r
	});
}
var Rl = w.createContext({
	size: "default",
	variant: "default",
	spacing: 0,
	orientation: "horizontal"
});
function zl({ className: e, variant: t, size: n, spacing: r = 0, orientation: i = "horizontal", children: a, ...o }) {
	return /* @__PURE__ */ N(Se, {
		"data-quill": !0,
		"data-slot": "toggle-group",
		"data-variant": t,
		"data-size": n,
		"data-spacing": r,
		"data-orientation": i,
		style: { "--gap": r },
		className: q("quill-toggle-group group/toggle-group flex w-fit flex-row items-center gap-[--spacing(var(--gap))] data-[orientation=vertical]:flex-col data-[orientation=vertical]:items-stretch", e),
		...o,
		children: /* @__PURE__ */ N(Rl.Provider, {
			value: {
				variant: t,
				size: n,
				spacing: r,
				orientation: i
			},
			children: a
		})
	});
}
function Bl({ className: e, children: t, variant: n = "default", size: r = "default", ...i }) {
	let a = w.useContext(Rl);
	return /* @__PURE__ */ N(H, {
		"data-slot": "toggle-group-item",
		"data-variant": a.variant || n,
		"data-size": a.size || r,
		"data-spacing": a.spacing,
		className: q("quill-toggle-group__item", Il({
			variant: a.variant || n,
			size: a.size || r
		}), e),
		...i,
		render: (e) => /* @__PURE__ */ N(J, {
			variant: "outline",
			size: r,
			...e
		}),
		children: t
	});
}
var Vl = "(prefers-color-scheme: dark)", Hl = [
	"dark",
	"light",
	"system"
], Ul = w.createContext(void 0);
function Wl(e) {
	return e === null ? !1 : Hl.includes(e);
}
function Gl() {
	return typeof window < "u" && window.matchMedia(Vl).matches ? "dark" : "light";
}
function Kl() {
	let e = document.createElement("style");
	return e.appendChild(document.createTextNode("*,*::before,*::after{-webkit-transition:none!important;transition:none!important}")), document.head.appendChild(e), () => {
		window.getComputedStyle(document.body), requestAnimationFrame(() => {
			requestAnimationFrame(() => {
				e.remove();
			});
		});
	};
}
function ql(e) {
	return e instanceof HTMLElement ? !!(e.isContentEditable || e.closest("input, textarea, select, [contenteditable='true']")) : !1;
}
function Jl({ children: e, defaultTheme: t = "system", storageKey: n = "theme", disableTransitionOnChange: r = !0, ...i }) {
	let [a, o] = w.useState(() => {
		if (typeof window < "u") {
			let e = localStorage.getItem(n);
			if (Wl(e)) return e;
		}
		return t;
	}), s = w.useCallback((e) => {
		typeof window < "u" && localStorage.setItem(n, e), o(e);
	}, [n]), c = w.useCallback((e) => {
		let t = document.documentElement, n = e === "system" ? Gl() : e, i = r ? Kl() : null;
		t.classList.remove("light", "dark"), t.classList.add(n), i && i();
	}, [r]);
	w.useEffect(() => {
		if (c(a), a !== "system") return;
		let e = window.matchMedia(Vl), t = () => {
			c("system");
		};
		return e.addEventListener("change", t), () => {
			e.removeEventListener("change", t);
		};
	}, [a, c]), w.useEffect(() => {
		let e = (e) => {
			e.repeat || e.metaKey || e.ctrlKey || e.altKey || ql(e.target) || e.key.toLowerCase() === "d" && o((e) => {
				let t = e === "dark" ? "light" : e === "light" ? "dark" : Gl() === "dark" ? "light" : "dark";
				return localStorage.setItem(n, t), t;
			});
		};
		return window.addEventListener("keydown", e), () => {
			window.removeEventListener("keydown", e);
		};
	}, [n]), w.useEffect(() => {
		let e = (e) => {
			if (e.storageArea === localStorage && e.key === n) {
				if (Wl(e.newValue)) {
					o(e.newValue);
					return;
				}
				o(t);
			}
		};
		return window.addEventListener("storage", e), () => {
			window.removeEventListener("storage", e);
		};
	}, [t, n]);
	let l = w.useMemo(() => ({
		theme: a,
		setTheme: s
	}), [a, s]);
	return /* @__PURE__ */ N(Ul.Provider, {
		...i,
		value: l,
		children: e
	});
}
var Yl = () => {
	let e = w.useContext(Ul);
	if (e === void 0) throw Error("useTheme must be used within a ThemeProvider");
	return e;
}, Xl = (...e) => e.filter((e, t, n) => !!e && e.trim() !== "" && n.indexOf(e) === t).join(" ").trim(), Zl = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), Ql = (e) => e.replace(/^([A-Z])|[\s-_]+(\w)/g, (e, t, n) => n ? n.toUpperCase() : t.toLowerCase()), $l = (e) => {
	let t = Ql(e);
	return t.charAt(0).toUpperCase() + t.slice(1);
}, eu = {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}, tu = (e) => {
	for (let t in e) if (t.startsWith("aria-") || t === "role" || t === "title") return !0;
	return !1;
}, nu = E(({ color: e = "currentColor", size: t = 24, strokeWidth: n = 2, absoluteStrokeWidth: r, className: i = "", children: a, iconNode: o, ...s }, c) => T("svg", {
	ref: c,
	...eu,
	width: t,
	height: t,
	stroke: e,
	strokeWidth: r ? Number(n) * 24 / Number(t) : n,
	className: Xl("lucide", i),
	...!a && !tu(s) && { "aria-hidden": "true" },
	...s
}, [...o.map(([e, t]) => T(e, t)), ...Array.isArray(a) ? a : [a]])), ru = (e, t) => {
	let n = E(({ className: n, ...r }, i) => T(nu, {
		ref: i,
		iconNode: t,
		className: Xl(`lucide-${Zl($l(e))}`, `lucide-${e}`, n),
		...r
	}));
	return n.displayName = $l(e), n;
};
//#endregion
//#region ../components/dist/index.js
function iu(e, t) {
	return typeof e == "function" ? e(t) : e;
}
function au(e, t) {
	return (n) => {
		t.setState((t) => ({
			...t,
			[e]: iu(n, t[e])
		}));
	};
}
function ou(e) {
	return e instanceof Function;
}
function su(e) {
	return Array.isArray(e) && e.every((e) => typeof e == "number");
}
function cu(e, t) {
	let n = [], r = (e) => {
		e.forEach((e) => {
			n.push(e);
			let i = t(e);
			i != null && i.length && r(i);
		});
	};
	return r(e), n;
}
function Y(e, t, n) {
	let r = [], i;
	return (a) => {
		let o;
		n.key && n.debug && (o = Date.now());
		let s = e(a);
		if (!(s.length !== r.length || s.some((e, t) => r[t] !== e))) return i;
		r = s;
		let c;
		if (n.key && n.debug && (c = Date.now()), i = t(...s), n == null || n.onChange == null || n.onChange(i), n.key && n.debug && n != null && n.debug()) {
			let e = Math.round((Date.now() - o) * 100) / 100, t = Math.round((Date.now() - c) * 100) / 100, r = t / 16, i = (e, t) => {
				for (e = String(e); e.length < t;) e = " " + e;
				return e;
			};
			console.info(`%c⏱ ${i(t, 5)} /${i(e, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * r, 120))}deg 100% 31%);`, n?.key);
		}
		return i;
	};
}
function X(e, t, n, r) {
	return {
		debug: () => e?.debugAll ?? e[t],
		key: process.env.NODE_ENV === "development" && n,
		onChange: r
	};
}
function lu(e, t, n, r) {
	let i = {
		id: `${t.id}_${n.id}`,
		row: t,
		column: n,
		getValue: () => t.getValue(r),
		renderValue: () => i.getValue() ?? e.options.renderFallbackValue,
		getContext: Y(() => [
			e,
			n,
			t,
			i
		], (e, t, n, r) => ({
			table: e,
			column: t,
			row: n,
			cell: r,
			getValue: r.getValue,
			renderValue: r.renderValue
		}), X(e.options, "debugCells", "cell.getContext"))
	};
	return e._features.forEach((r) => {
		r.createCell == null || r.createCell(i, n, t, e);
	}, {}), i;
}
function uu(e, t, n, r) {
	let i = {
		...e._getDefaultColumnDef(),
		...t
	}, a = i.accessorKey, o = i.id ?? (a ? typeof String.prototype.replaceAll == "function" ? a.replaceAll(".", "_") : a.replace(/\./g, "_") : void 0) ?? (typeof i.header == "string" ? i.header : void 0), s;
	if (i.accessorFn ? s = i.accessorFn : a && (s = a.includes(".") ? (e) => {
		let t = e;
		for (let e of a.split(".")) t = t?.[e], process.env.NODE_ENV !== "production" && t === void 0 && console.warn(`"${e}" in deeply nested key "${a}" returned undefined.`);
		return t;
	} : (e) => e[i.accessorKey]), !o) throw process.env.NODE_ENV === "production" ? Error() : Error(i.accessorFn ? "Columns require an id when using an accessorFn" : "Columns require an id when using a non-string header");
	let c = {
		id: `${String(o)}`,
		accessorFn: s,
		parent: r,
		depth: n,
		columnDef: i,
		columns: [],
		getFlatColumns: Y(() => [!0], () => [c, ...c.columns?.flatMap((e) => e.getFlatColumns())], X(e.options, "debugColumns", "column.getFlatColumns")),
		getLeafColumns: Y(() => [e._getOrderColumnsFn()], (e) => {
			var t;
			return (t = c.columns) != null && t.length ? e(c.columns.flatMap((e) => e.getLeafColumns())) : [c];
		}, X(e.options, "debugColumns", "column.getLeafColumns"))
	};
	for (let t of e._features) t.createColumn == null || t.createColumn(c, e);
	return c;
}
var du = "debugHeaders";
function fu(e, t, n) {
	let r = {
		id: n.id ?? t.id,
		column: t,
		index: n.index,
		isPlaceholder: !!n.isPlaceholder,
		placeholderId: n.placeholderId,
		depth: n.depth,
		subHeaders: [],
		colSpan: 0,
		rowSpan: 0,
		headerGroup: null,
		getLeafHeaders: () => {
			let e = [], t = (n) => {
				n.subHeaders && n.subHeaders.length && n.subHeaders.map(t), e.push(n);
			};
			return t(r), e;
		},
		getContext: () => ({
			table: e,
			header: r,
			column: t
		})
	};
	return e._features.forEach((t) => {
		t.createHeader == null || t.createHeader(r, e);
	}), r;
}
var pu = { createTable: (e) => {
	e.getHeaderGroups = Y(() => [
		e.getAllColumns(),
		e.getVisibleLeafColumns(),
		e.getState().columnPinning.left,
		e.getState().columnPinning.right
	], (t, n, r, i) => {
		let a = r?.map((e) => n.find((t) => t.id === e)).filter(Boolean) ?? [], o = i?.map((e) => n.find((t) => t.id === e)).filter(Boolean) ?? [], s = n.filter((e) => !(r != null && r.includes(e.id)) && !(i != null && i.includes(e.id)));
		return mu(t, [
			...a,
			...s,
			...o
		], e);
	}, X(e.options, du, "getHeaderGroups")), e.getCenterHeaderGroups = Y(() => [
		e.getAllColumns(),
		e.getVisibleLeafColumns(),
		e.getState().columnPinning.left,
		e.getState().columnPinning.right
	], (t, n, r, i) => (n = n.filter((e) => !(r != null && r.includes(e.id)) && !(i != null && i.includes(e.id))), mu(t, n, e, "center")), X(e.options, du, "getCenterHeaderGroups")), e.getLeftHeaderGroups = Y(() => [
		e.getAllColumns(),
		e.getVisibleLeafColumns(),
		e.getState().columnPinning.left
	], (t, n, r) => mu(t, r?.map((e) => n.find((t) => t.id === e)).filter(Boolean) ?? [], e, "left"), X(e.options, du, "getLeftHeaderGroups")), e.getRightHeaderGroups = Y(() => [
		e.getAllColumns(),
		e.getVisibleLeafColumns(),
		e.getState().columnPinning.right
	], (t, n, r) => mu(t, r?.map((e) => n.find((t) => t.id === e)).filter(Boolean) ?? [], e, "right"), X(e.options, du, "getRightHeaderGroups")), e.getFooterGroups = Y(() => [e.getHeaderGroups()], (e) => [...e].reverse(), X(e.options, du, "getFooterGroups")), e.getLeftFooterGroups = Y(() => [e.getLeftHeaderGroups()], (e) => [...e].reverse(), X(e.options, du, "getLeftFooterGroups")), e.getCenterFooterGroups = Y(() => [e.getCenterHeaderGroups()], (e) => [...e].reverse(), X(e.options, du, "getCenterFooterGroups")), e.getRightFooterGroups = Y(() => [e.getRightHeaderGroups()], (e) => [...e].reverse(), X(e.options, du, "getRightFooterGroups")), e.getFlatHeaders = Y(() => [e.getHeaderGroups()], (e) => e.map((e) => e.headers).flat(), X(e.options, du, "getFlatHeaders")), e.getLeftFlatHeaders = Y(() => [e.getLeftHeaderGroups()], (e) => e.map((e) => e.headers).flat(), X(e.options, du, "getLeftFlatHeaders")), e.getCenterFlatHeaders = Y(() => [e.getCenterHeaderGroups()], (e) => e.map((e) => e.headers).flat(), X(e.options, du, "getCenterFlatHeaders")), e.getRightFlatHeaders = Y(() => [e.getRightHeaderGroups()], (e) => e.map((e) => e.headers).flat(), X(e.options, du, "getRightFlatHeaders")), e.getCenterLeafHeaders = Y(() => [e.getCenterFlatHeaders()], (e) => e.filter((e) => {
		var t;
		return !((t = e.subHeaders) != null && t.length);
	}), X(e.options, du, "getCenterLeafHeaders")), e.getLeftLeafHeaders = Y(() => [e.getLeftFlatHeaders()], (e) => e.filter((e) => {
		var t;
		return !((t = e.subHeaders) != null && t.length);
	}), X(e.options, du, "getLeftLeafHeaders")), e.getRightLeafHeaders = Y(() => [e.getRightFlatHeaders()], (e) => e.filter((e) => {
		var t;
		return !((t = e.subHeaders) != null && t.length);
	}), X(e.options, du, "getRightLeafHeaders")), e.getLeafHeaders = Y(() => [
		e.getLeftHeaderGroups(),
		e.getCenterHeaderGroups(),
		e.getRightHeaderGroups()
	], (e, t, n) => [
		...e[0]?.headers ?? [],
		...t[0]?.headers ?? [],
		...n[0]?.headers ?? []
	].map((e) => e.getLeafHeaders()).flat(), X(e.options, du, "getLeafHeaders"));
} };
function mu(e, t, n, r) {
	let i = 0, a = function(e, t) {
		t === void 0 && (t = 1), i = Math.max(i, t), e.filter((e) => e.getIsVisible()).forEach((e) => {
			var n;
			(n = e.columns) != null && n.length && a(e.columns, t + 1);
		}, 0);
	};
	a(e);
	let o = [], s = (e, t) => {
		let i = {
			depth: t,
			id: [r, `${t}`].filter(Boolean).join("_"),
			headers: []
		}, a = [];
		e.forEach((e) => {
			let o = [...a].reverse()[0], s = e.column.depth === i.depth, c, l = !1;
			if (s && e.column.parent ? c = e.column.parent : (c = e.column, l = !0), o && o?.column === c) o.subHeaders.push(e);
			else {
				let i = fu(n, c, {
					id: [
						r,
						t,
						c.id,
						e?.id
					].filter(Boolean).join("_"),
					isPlaceholder: l,
					placeholderId: l ? `${a.filter((e) => e.column === c).length}` : void 0,
					depth: t,
					index: a.length
				});
				i.subHeaders.push(e), a.push(i);
			}
			i.headers.push(e), e.headerGroup = i;
		}), o.push(i), t > 0 && s(a, t - 1);
	};
	s(t.map((e, t) => fu(n, e, {
		depth: i,
		index: t
	})), i - 1), o.reverse();
	let c = (e) => e.filter((e) => e.column.getIsVisible()).map((e) => {
		let t = 0, n = 0, r = [0];
		e.subHeaders && e.subHeaders.length ? (r = [], c(e.subHeaders).forEach((e) => {
			let { colSpan: n, rowSpan: i } = e;
			t += n, r.push(i);
		})) : t = 1;
		let i = Math.min(...r);
		return n += i, e.colSpan = t, e.rowSpan = n, {
			colSpan: t,
			rowSpan: n
		};
	});
	return c(o[0]?.headers ?? []), o;
}
var hu = (e, t, n, r, i, a, o) => {
	let s = {
		id: t,
		index: r,
		original: n,
		depth: i,
		parentId: o,
		_valuesCache: {},
		_uniqueValuesCache: {},
		getValue: (t) => {
			if (s._valuesCache.hasOwnProperty(t)) return s._valuesCache[t];
			let n = e.getColumn(t);
			if (n != null && n.accessorFn) return s._valuesCache[t] = n.accessorFn(s.original, r), s._valuesCache[t];
		},
		getUniqueValues: (t) => {
			if (s._uniqueValuesCache.hasOwnProperty(t)) return s._uniqueValuesCache[t];
			let n = e.getColumn(t);
			if (n != null && n.accessorFn) return n.columnDef.getUniqueValues ? (s._uniqueValuesCache[t] = n.columnDef.getUniqueValues(s.original, r), s._uniqueValuesCache[t]) : (s._uniqueValuesCache[t] = [s.getValue(t)], s._uniqueValuesCache[t]);
		},
		renderValue: (t) => s.getValue(t) ?? e.options.renderFallbackValue,
		subRows: a ?? [],
		getLeafRows: () => cu(s.subRows, (e) => e.subRows),
		getParentRow: () => s.parentId ? e.getRow(s.parentId, !0) : void 0,
		getParentRows: () => {
			let e = [], t = s;
			for (;;) {
				let n = t.getParentRow();
				if (!n) break;
				e.push(n), t = n;
			}
			return e.reverse();
		},
		getAllCells: Y(() => [e.getAllLeafColumns()], (t) => t.map((t) => lu(e, s, t, t.id)), X(e.options, "debugRows", "getAllCells")),
		_getAllCellsByColumnId: Y(() => [s.getAllCells()], (e) => e.reduce((e, t) => (e[t.column.id] = t, e), {}), X(e.options, "debugRows", "getAllCellsByColumnId"))
	};
	for (let t = 0; t < e._features.length; t++) {
		let n = e._features[t];
		n == null || n.createRow == null || n.createRow(s, e);
	}
	return s;
}, gu = { createColumn: (e, t) => {
	e._getFacetedRowModel = t.options.getFacetedRowModel && t.options.getFacetedRowModel(t, e.id), e.getFacetedRowModel = () => e._getFacetedRowModel ? e._getFacetedRowModel() : t.getPreFilteredRowModel(), e._getFacetedUniqueValues = t.options.getFacetedUniqueValues && t.options.getFacetedUniqueValues(t, e.id), e.getFacetedUniqueValues = () => e._getFacetedUniqueValues ? e._getFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getFacetedMinMaxValues = t.options.getFacetedMinMaxValues && t.options.getFacetedMinMaxValues(t, e.id), e.getFacetedMinMaxValues = () => {
		if (e._getFacetedMinMaxValues) return e._getFacetedMinMaxValues();
	};
} }, _u = (e, t, n) => {
	var r, i;
	let a = n == null || (r = n.toString()) == null ? void 0 : r.toLowerCase();
	return !!(!((i = e.getValue(t)) == null || (i = i.toString()) == null || (i = i.toLowerCase()) == null) && i.includes(a));
};
_u.autoRemove = (e) => Du(e);
var vu = (e, t, n) => {
	var r;
	return !!(!((r = e.getValue(t)) == null || (r = r.toString()) == null) && r.includes(n));
};
vu.autoRemove = (e) => Du(e);
var yu = (e, t, n) => {
	var r;
	return ((r = e.getValue(t)) == null || (r = r.toString()) == null ? void 0 : r.toLowerCase()) === n?.toLowerCase();
};
yu.autoRemove = (e) => Du(e);
var bu = (e, t, n) => e.getValue(t)?.includes(n);
bu.autoRemove = (e) => Du(e);
var xu = (e, t, n) => !n.some((n) => {
	var r;
	return !((r = e.getValue(t)) != null && r.includes(n));
});
xu.autoRemove = (e) => Du(e) || !(e != null && e.length);
var Su = (e, t, n) => n.some((n) => e.getValue(t)?.includes(n));
Su.autoRemove = (e) => Du(e) || !(e != null && e.length);
var Cu = (e, t, n) => e.getValue(t) === n;
Cu.autoRemove = (e) => Du(e);
var wu = (e, t, n) => e.getValue(t) == n;
wu.autoRemove = (e) => Du(e);
var Tu = (e, t, n) => {
	let [r, i] = n, a = e.getValue(t);
	return a >= r && a <= i;
};
Tu.resolveFilterValue = (e) => {
	let [t, n] = e, r = typeof t == "number" ? t : parseFloat(t), i = typeof n == "number" ? n : parseFloat(n), a = t === null || Number.isNaN(r) ? -Infinity : r, o = n === null || Number.isNaN(i) ? Infinity : i;
	if (a > o) {
		let e = a;
		a = o, o = e;
	}
	return [a, o];
}, Tu.autoRemove = (e) => Du(e) || Du(e[0]) && Du(e[1]);
var Eu = {
	includesString: _u,
	includesStringSensitive: vu,
	equalsString: yu,
	arrIncludes: bu,
	arrIncludesAll: xu,
	arrIncludesSome: Su,
	equals: Cu,
	weakEquals: wu,
	inNumberRange: Tu
};
function Du(e) {
	return e == null || e === "";
}
var Ou = {
	getDefaultColumnDef: () => ({ filterFn: "auto" }),
	getInitialState: (e) => ({
		columnFilters: [],
		...e
	}),
	getDefaultOptions: (e) => ({
		onColumnFiltersChange: au("columnFilters", e),
		filterFromLeafRows: !1,
		maxLeafRowFilterDepth: 100
	}),
	createColumn: (e, t) => {
		e.getAutoFilterFn = () => {
			let n = t.getCoreRowModel().flatRows[0]?.getValue(e.id);
			return typeof n == "string" ? Eu.includesString : typeof n == "number" ? Eu.inNumberRange : typeof n == "boolean" || typeof n == "object" && n ? Eu.equals : Array.isArray(n) ? Eu.arrIncludes : Eu.weakEquals;
		}, e.getFilterFn = () => ou(e.columnDef.filterFn) ? e.columnDef.filterFn : e.columnDef.filterFn === "auto" ? e.getAutoFilterFn() : t.options.filterFns?.[e.columnDef.filterFn] ?? Eu[e.columnDef.filterFn], e.getCanFilter = () => (e.columnDef.enableColumnFilter ?? !0) && (t.options.enableColumnFilters ?? !0) && (t.options.enableFilters ?? !0) && !!e.accessorFn, e.getIsFiltered = () => e.getFilterIndex() > -1, e.getFilterValue = () => {
			var n;
			return (n = t.getState().columnFilters) == null || (n = n.find((t) => t.id === e.id)) == null ? void 0 : n.value;
		}, e.getFilterIndex = () => t.getState().columnFilters?.findIndex((t) => t.id === e.id) ?? -1, e.setFilterValue = (n) => {
			t.setColumnFilters((t) => {
				let r = e.getFilterFn(), i = t?.find((t) => t.id === e.id), a = iu(n, i ? i.value : void 0);
				if (ku(r, a, e)) return t?.filter((t) => t.id !== e.id) ?? [];
				let o = {
					id: e.id,
					value: a
				};
				return i ? t?.map((t) => t.id === e.id ? o : t) ?? [] : t != null && t.length ? [...t, o] : [o];
			});
		};
	},
	createRow: (e, t) => {
		e.columnFilters = {}, e.columnFiltersMeta = {};
	},
	createTable: (e) => {
		e.setColumnFilters = (t) => {
			let n = e.getAllLeafColumns();
			e.options.onColumnFiltersChange == null || e.options.onColumnFiltersChange((e) => iu(t, e)?.filter((e) => {
				let t = n.find((t) => t.id === e.id);
				return !(t && ku(t.getFilterFn(), e.value, t));
			}));
		}, e.resetColumnFilters = (t) => {
			e.setColumnFilters(t ? [] : e.initialState?.columnFilters ?? []);
		}, e.getPreFilteredRowModel = () => e.getCoreRowModel(), e.getFilteredRowModel = () => (!e._getFilteredRowModel && e.options.getFilteredRowModel && (e._getFilteredRowModel = e.options.getFilteredRowModel(e)), e.options.manualFiltering || !e._getFilteredRowModel ? e.getPreFilteredRowModel() : e._getFilteredRowModel());
	}
};
function ku(e, t, n) {
	return (e && e.autoRemove ? e.autoRemove(t, n) : !1) || t === void 0 || typeof t == "string" && !t;
}
var Au = {
	sum: (e, t, n) => n.reduce((t, n) => {
		let r = n.getValue(e);
		return t + (typeof r == "number" ? r : 0);
	}, 0),
	min: (e, t, n) => {
		let r;
		return n.forEach((t) => {
			let n = t.getValue(e);
			n != null && (r > n || r === void 0 && n >= n) && (r = n);
		}), r;
	},
	max: (e, t, n) => {
		let r;
		return n.forEach((t) => {
			let n = t.getValue(e);
			n != null && (r < n || r === void 0 && n >= n) && (r = n);
		}), r;
	},
	extent: (e, t, n) => {
		let r, i;
		return n.forEach((t) => {
			let n = t.getValue(e);
			n != null && (r === void 0 ? n >= n && (r = i = n) : (r > n && (r = n), i < n && (i = n)));
		}), [r, i];
	},
	mean: (e, t) => {
		let n = 0, r = 0;
		if (t.forEach((t) => {
			let i = t.getValue(e);
			i != null && (i = +i) >= i && (++n, r += i);
		}), n) return r / n;
	},
	median: (e, t) => {
		if (!t.length) return;
		let n = t.map((t) => t.getValue(e));
		if (!su(n)) return;
		if (n.length === 1) return n[0];
		let r = Math.floor(n.length / 2), i = n.sort((e, t) => e - t);
		return n.length % 2 == 0 ? (i[r - 1] + i[r]) / 2 : i[r];
	},
	unique: (e, t) => Array.from(new Set(t.map((t) => t.getValue(e))).values()),
	uniqueCount: (e, t) => new Set(t.map((t) => t.getValue(e))).size,
	count: (e, t) => t.length
}, ju = {
	getDefaultColumnDef: () => ({
		aggregatedCell: (e) => {
			var t;
			return ((t = e.getValue()) == null || t.toString == null ? void 0 : t.toString()) ?? null;
		},
		aggregationFn: "auto"
	}),
	getInitialState: (e) => ({
		grouping: [],
		...e
	}),
	getDefaultOptions: (e) => ({
		onGroupingChange: au("grouping", e),
		groupedColumnMode: "reorder"
	}),
	createColumn: (e, t) => {
		e.toggleGrouping = () => {
			t.setGrouping((t) => t != null && t.includes(e.id) ? t.filter((t) => t !== e.id) : [...t ?? [], e.id]);
		}, e.getCanGroup = () => (e.columnDef.enableGrouping ?? !0) && (t.options.enableGrouping ?? !0) && (!!e.accessorFn || !!e.columnDef.getGroupingValue), e.getIsGrouped = () => t.getState().grouping?.includes(e.id), e.getGroupedIndex = () => t.getState().grouping?.indexOf(e.id), e.getToggleGroupingHandler = () => {
			let t = e.getCanGroup();
			return () => {
				t && e.toggleGrouping();
			};
		}, e.getAutoAggregationFn = () => {
			let n = t.getCoreRowModel().flatRows[0]?.getValue(e.id);
			if (typeof n == "number") return Au.sum;
			if (Object.prototype.toString.call(n) === "[object Date]") return Au.extent;
		}, e.getAggregationFn = () => {
			if (!e) throw Error();
			return ou(e.columnDef.aggregationFn) ? e.columnDef.aggregationFn : e.columnDef.aggregationFn === "auto" ? e.getAutoAggregationFn() : t.options.aggregationFns?.[e.columnDef.aggregationFn] ?? Au[e.columnDef.aggregationFn];
		};
	},
	createTable: (e) => {
		e.setGrouping = (t) => e.options.onGroupingChange == null ? void 0 : e.options.onGroupingChange(t), e.resetGrouping = (t) => {
			e.setGrouping(t ? [] : e.initialState?.grouping ?? []);
		}, e.getPreGroupedRowModel = () => e.getFilteredRowModel(), e.getGroupedRowModel = () => (!e._getGroupedRowModel && e.options.getGroupedRowModel && (e._getGroupedRowModel = e.options.getGroupedRowModel(e)), e.options.manualGrouping || !e._getGroupedRowModel ? e.getPreGroupedRowModel() : e._getGroupedRowModel());
	},
	createRow: (e, t) => {
		e.getIsGrouped = () => !!e.groupingColumnId, e.getGroupingValue = (n) => {
			if (e._groupingValuesCache.hasOwnProperty(n)) return e._groupingValuesCache[n];
			let r = t.getColumn(n);
			return r != null && r.columnDef.getGroupingValue ? (e._groupingValuesCache[n] = r.columnDef.getGroupingValue(e.original), e._groupingValuesCache[n]) : e.getValue(n);
		}, e._groupingValuesCache = {};
	},
	createCell: (e, t, n, r) => {
		e.getIsGrouped = () => t.getIsGrouped() && t.id === n.groupingColumnId, e.getIsPlaceholder = () => !e.getIsGrouped() && t.getIsGrouped(), e.getIsAggregated = () => {
			var t;
			return !e.getIsGrouped() && !e.getIsPlaceholder() && !!((t = n.subRows) != null && t.length);
		};
	}
};
function Mu(e, t, n) {
	if (!(t != null && t.length) || !n) return e;
	let r = e.filter((e) => !t.includes(e.id));
	return n === "remove" ? r : [...t.map((t) => e.find((e) => e.id === t)).filter(Boolean), ...r];
}
var Nu = {
	getInitialState: (e) => ({
		columnOrder: [],
		...e
	}),
	getDefaultOptions: (e) => ({ onColumnOrderChange: au("columnOrder", e) }),
	createColumn: (e, t) => {
		e.getIndex = Y((e) => [Wu(t, e)], (t) => t.findIndex((t) => t.id === e.id), X(t.options, "debugColumns", "getIndex")), e.getIsFirstColumn = (n) => Wu(t, n)[0]?.id === e.id, e.getIsLastColumn = (n) => {
			let r = Wu(t, n);
			return r[r.length - 1]?.id === e.id;
		};
	},
	createTable: (e) => {
		e.setColumnOrder = (t) => e.options.onColumnOrderChange == null ? void 0 : e.options.onColumnOrderChange(t), e.resetColumnOrder = (t) => {
			e.setColumnOrder(t ? [] : e.initialState.columnOrder ?? []);
		}, e._getOrderColumnsFn = Y(() => [
			e.getState().columnOrder,
			e.getState().grouping,
			e.options.groupedColumnMode
		], (e, t, n) => (r) => {
			let i = [];
			if (!(e != null && e.length)) i = r;
			else {
				let t = [...e], n = [...r];
				for (; n.length && t.length;) {
					let e = t.shift(), r = n.findIndex((t) => t.id === e);
					r > -1 && i.push(n.splice(r, 1)[0]);
				}
				i = [...i, ...n];
			}
			return Mu(i, t, n);
		}, X(e.options, "debugTable", "_getOrderColumnsFn"));
	}
}, Pu = () => ({
	left: [],
	right: []
}), Fu = {
	getInitialState: (e) => ({
		columnPinning: Pu(),
		...e
	}),
	getDefaultOptions: (e) => ({ onColumnPinningChange: au("columnPinning", e) }),
	createColumn: (e, t) => {
		e.pin = (n) => {
			let r = e.getLeafColumns().map((e) => e.id).filter(Boolean);
			t.setColumnPinning((e) => n === "right" ? {
				left: (e?.left ?? []).filter((e) => !(r != null && r.includes(e))),
				right: [...(e?.right ?? []).filter((e) => !(r != null && r.includes(e))), ...r]
			} : n === "left" ? {
				left: [...(e?.left ?? []).filter((e) => !(r != null && r.includes(e))), ...r],
				right: (e?.right ?? []).filter((e) => !(r != null && r.includes(e)))
			} : {
				left: (e?.left ?? []).filter((e) => !(r != null && r.includes(e))),
				right: (e?.right ?? []).filter((e) => !(r != null && r.includes(e)))
			});
		}, e.getCanPin = () => e.getLeafColumns().some((e) => (e.columnDef.enablePinning ?? !0) && (t.options.enableColumnPinning ?? t.options.enablePinning ?? !0)), e.getIsPinned = () => {
			let n = e.getLeafColumns().map((e) => e.id), { left: r, right: i } = t.getState().columnPinning, a = n.some((e) => r?.includes(e)), o = n.some((e) => i?.includes(e));
			return a ? "left" : o ? "right" : !1;
		}, e.getPinnedIndex = () => {
			var n;
			let r = e.getIsPinned();
			return r ? ((n = t.getState().columnPinning) == null || (n = n[r]) == null ? void 0 : n.indexOf(e.id)) ?? -1 : 0;
		};
	},
	createRow: (e, t) => {
		e.getCenterVisibleCells = Y(() => [
			e._getAllVisibleCells(),
			t.getState().columnPinning.left,
			t.getState().columnPinning.right
		], (e, t, n) => {
			let r = [...t ?? [], ...n ?? []];
			return e.filter((e) => !r.includes(e.column.id));
		}, X(t.options, "debugRows", "getCenterVisibleCells")), e.getLeftVisibleCells = Y(() => [e._getAllVisibleCells(), t.getState().columnPinning.left], (e, t) => (t ?? []).map((t) => e.find((e) => e.column.id === t)).filter(Boolean).map((e) => ({
			...e,
			position: "left"
		})), X(t.options, "debugRows", "getLeftVisibleCells")), e.getRightVisibleCells = Y(() => [e._getAllVisibleCells(), t.getState().columnPinning.right], (e, t) => (t ?? []).map((t) => e.find((e) => e.column.id === t)).filter(Boolean).map((e) => ({
			...e,
			position: "right"
		})), X(t.options, "debugRows", "getRightVisibleCells"));
	},
	createTable: (e) => {
		e.setColumnPinning = (t) => e.options.onColumnPinningChange == null ? void 0 : e.options.onColumnPinningChange(t), e.resetColumnPinning = (t) => e.setColumnPinning(t ? Pu() : e.initialState?.columnPinning ?? Pu()), e.getIsSomeColumnsPinned = (t) => {
			let n = e.getState().columnPinning;
			return t ? !!n[t]?.length : !!(n.left?.length || n.right?.length);
		}, e.getLeftLeafColumns = Y(() => [e.getAllLeafColumns(), e.getState().columnPinning.left], (e, t) => (t ?? []).map((t) => e.find((e) => e.id === t)).filter(Boolean), X(e.options, "debugColumns", "getLeftLeafColumns")), e.getRightLeafColumns = Y(() => [e.getAllLeafColumns(), e.getState().columnPinning.right], (e, t) => (t ?? []).map((t) => e.find((e) => e.id === t)).filter(Boolean), X(e.options, "debugColumns", "getRightLeafColumns")), e.getCenterLeafColumns = Y(() => [
			e.getAllLeafColumns(),
			e.getState().columnPinning.left,
			e.getState().columnPinning.right
		], (e, t, n) => {
			let r = [...t ?? [], ...n ?? []];
			return e.filter((e) => !r.includes(e.id));
		}, X(e.options, "debugColumns", "getCenterLeafColumns"));
	}
};
function Iu(e) {
	return e || (typeof document < "u" ? document : null);
}
var Lu = {
	size: 150,
	minSize: 20,
	maxSize: 2 ** 53 - 1
}, Ru = () => ({
	startOffset: null,
	startSize: null,
	deltaOffset: null,
	deltaPercentage: null,
	isResizingColumn: !1,
	columnSizingStart: []
}), zu = {
	getDefaultColumnDef: () => Lu,
	getInitialState: (e) => ({
		columnSizing: {},
		columnSizingInfo: Ru(),
		...e
	}),
	getDefaultOptions: (e) => ({
		columnResizeMode: "onEnd",
		columnResizeDirection: "ltr",
		onColumnSizingChange: au("columnSizing", e),
		onColumnSizingInfoChange: au("columnSizingInfo", e)
	}),
	createColumn: (e, t) => {
		e.getSize = () => {
			let n = t.getState().columnSizing[e.id];
			return Math.min(Math.max(e.columnDef.minSize ?? Lu.minSize, n ?? e.columnDef.size ?? Lu.size), e.columnDef.maxSize ?? Lu.maxSize);
		}, e.getStart = Y((e) => [
			e,
			Wu(t, e),
			t.getState().columnSizing
		], (t, n) => n.slice(0, e.getIndex(t)).reduce((e, t) => e + t.getSize(), 0), X(t.options, "debugColumns", "getStart")), e.getAfter = Y((e) => [
			e,
			Wu(t, e),
			t.getState().columnSizing
		], (t, n) => n.slice(e.getIndex(t) + 1).reduce((e, t) => e + t.getSize(), 0), X(t.options, "debugColumns", "getAfter")), e.resetSize = () => {
			t.setColumnSizing((t) => {
				let { [e.id]: n, ...r } = t;
				return r;
			});
		}, e.getCanResize = () => (e.columnDef.enableResizing ?? !0) && (t.options.enableColumnResizing ?? !0), e.getIsResizing = () => t.getState().columnSizingInfo.isResizingColumn === e.id;
	},
	createHeader: (e, t) => {
		e.getSize = () => {
			let t = 0, n = (e) => {
				e.subHeaders.length ? e.subHeaders.forEach(n) : t += e.column.getSize() ?? 0;
			};
			return n(e), t;
		}, e.getStart = () => {
			if (e.index > 0) {
				let t = e.headerGroup.headers[e.index - 1];
				return t.getStart() + t.getSize();
			}
			return 0;
		}, e.getResizeHandler = (n) => {
			let r = t.getColumn(e.column.id), i = r?.getCanResize();
			return (a) => {
				if (!r || !i || (a.persist == null || a.persist(), Hu(a) && a.touches && a.touches.length > 1)) return;
				let o = e.getSize(), s = e ? e.getLeafHeaders().map((e) => [e.column.id, e.column.getSize()]) : [[r.id, r.getSize()]], c = Hu(a) ? Math.round(a.touches[0].clientX) : a.clientX, l = {}, u = (e, n) => {
					typeof n == "number" && (t.setColumnSizingInfo((e) => {
						let r = t.options.columnResizeDirection === "rtl" ? -1 : 1, i = (n - (e?.startOffset ?? 0)) * r, a = Math.max(i / (e?.startSize ?? 0), -.999999);
						return e.columnSizingStart.forEach((e) => {
							let [t, n] = e;
							l[t] = Math.round(Math.max(n + n * a, 0) * 100) / 100;
						}), {
							...e,
							deltaOffset: i,
							deltaPercentage: a
						};
					}), (t.options.columnResizeMode === "onChange" || e === "end") && t.setColumnSizing((e) => ({
						...e,
						...l
					})));
				}, d = (e) => u("move", e), f = (e) => {
					u("end", e), t.setColumnSizingInfo((e) => ({
						...e,
						isResizingColumn: !1,
						startOffset: null,
						startSize: null,
						deltaOffset: null,
						deltaPercentage: null,
						columnSizingStart: []
					}));
				}, p = Iu(n), m = {
					moveHandler: (e) => d(e.clientX),
					upHandler: (e) => {
						p?.removeEventListener("mousemove", m.moveHandler), p?.removeEventListener("mouseup", m.upHandler), f(e.clientX);
					}
				}, h = {
					moveHandler: (e) => (e.cancelable && (e.preventDefault(), e.stopPropagation()), d(e.touches[0].clientX), !1),
					upHandler: (e) => {
						p?.removeEventListener("touchmove", h.moveHandler), p?.removeEventListener("touchend", h.upHandler), e.cancelable && (e.preventDefault(), e.stopPropagation()), f(e.touches[0]?.clientX);
					}
				}, g = Vu() ? { passive: !1 } : !1;
				Hu(a) ? (p?.addEventListener("touchmove", h.moveHandler, g), p?.addEventListener("touchend", h.upHandler, g)) : (p?.addEventListener("mousemove", m.moveHandler, g), p?.addEventListener("mouseup", m.upHandler, g)), t.setColumnSizingInfo((e) => ({
					...e,
					startOffset: c,
					startSize: o,
					deltaOffset: 0,
					deltaPercentage: 0,
					columnSizingStart: s,
					isResizingColumn: r.id
				}));
			};
		};
	},
	createTable: (e) => {
		e.setColumnSizing = (t) => e.options.onColumnSizingChange == null ? void 0 : e.options.onColumnSizingChange(t), e.setColumnSizingInfo = (t) => e.options.onColumnSizingInfoChange == null ? void 0 : e.options.onColumnSizingInfoChange(t), e.resetColumnSizing = (t) => {
			e.setColumnSizing(t ? {} : e.initialState.columnSizing ?? {});
		}, e.resetHeaderSizeInfo = (t) => {
			e.setColumnSizingInfo(t ? Ru() : e.initialState.columnSizingInfo ?? Ru());
		}, e.getTotalSize = () => e.getHeaderGroups()[0]?.headers.reduce((e, t) => e + t.getSize(), 0) ?? 0, e.getLeftTotalSize = () => e.getLeftHeaderGroups()[0]?.headers.reduce((e, t) => e + t.getSize(), 0) ?? 0, e.getCenterTotalSize = () => e.getCenterHeaderGroups()[0]?.headers.reduce((e, t) => e + t.getSize(), 0) ?? 0, e.getRightTotalSize = () => e.getRightHeaderGroups()[0]?.headers.reduce((e, t) => e + t.getSize(), 0) ?? 0;
	}
}, Bu = null;
function Vu() {
	if (typeof Bu == "boolean") return Bu;
	let e = !1;
	try {
		let t = { get passive() {
			return e = !0, !1;
		} }, n = () => {};
		window.addEventListener("test", n, t), window.removeEventListener("test", n);
	} catch {
		e = !1;
	}
	return Bu = e, Bu;
}
function Hu(e) {
	return e.type === "touchstart";
}
var Uu = {
	getInitialState: (e) => ({
		columnVisibility: {},
		...e
	}),
	getDefaultOptions: (e) => ({ onColumnVisibilityChange: au("columnVisibility", e) }),
	createColumn: (e, t) => {
		e.toggleVisibility = (n) => {
			e.getCanHide() && t.setColumnVisibility((t) => ({
				...t,
				[e.id]: n ?? !e.getIsVisible()
			}));
		}, e.getIsVisible = () => {
			let n = e.columns;
			return (n.length ? n.some((e) => e.getIsVisible()) : t.getState().columnVisibility?.[e.id]) ?? !0;
		}, e.getCanHide = () => (e.columnDef.enableHiding ?? !0) && (t.options.enableHiding ?? !0), e.getToggleVisibilityHandler = () => (t) => {
			e.toggleVisibility == null || e.toggleVisibility(t.target.checked);
		};
	},
	createRow: (e, t) => {
		e._getAllVisibleCells = Y(() => [e.getAllCells(), t.getState().columnVisibility], (e) => e.filter((e) => e.column.getIsVisible()), X(t.options, "debugRows", "_getAllVisibleCells")), e.getVisibleCells = Y(() => [
			e.getLeftVisibleCells(),
			e.getCenterVisibleCells(),
			e.getRightVisibleCells()
		], (e, t, n) => [
			...e,
			...t,
			...n
		], X(t.options, "debugRows", "getVisibleCells"));
	},
	createTable: (e) => {
		let t = (t, n) => Y(() => [n(), n().filter((e) => e.getIsVisible()).map((e) => e.id).join("_")], (e) => e.filter((e) => e.getIsVisible == null ? void 0 : e.getIsVisible()), X(e.options, "debugColumns", t));
		e.getVisibleFlatColumns = t("getVisibleFlatColumns", () => e.getAllFlatColumns()), e.getVisibleLeafColumns = t("getVisibleLeafColumns", () => e.getAllLeafColumns()), e.getLeftVisibleLeafColumns = t("getLeftVisibleLeafColumns", () => e.getLeftLeafColumns()), e.getRightVisibleLeafColumns = t("getRightVisibleLeafColumns", () => e.getRightLeafColumns()), e.getCenterVisibleLeafColumns = t("getCenterVisibleLeafColumns", () => e.getCenterLeafColumns()), e.setColumnVisibility = (t) => e.options.onColumnVisibilityChange == null ? void 0 : e.options.onColumnVisibilityChange(t), e.resetColumnVisibility = (t) => {
			e.setColumnVisibility(t ? {} : e.initialState.columnVisibility ?? {});
		}, e.toggleAllColumnsVisible = (t) => {
			t ??= !e.getIsAllColumnsVisible(), e.setColumnVisibility(e.getAllLeafColumns().reduce((e, n) => ({
				...e,
				[n.id]: t || !(n.getCanHide != null && n.getCanHide())
			}), {}));
		}, e.getIsAllColumnsVisible = () => !e.getAllLeafColumns().some((e) => !(e.getIsVisible != null && e.getIsVisible())), e.getIsSomeColumnsVisible = () => e.getAllLeafColumns().some((e) => e.getIsVisible == null ? void 0 : e.getIsVisible()), e.getToggleAllColumnsVisibilityHandler = () => (t) => {
			e.toggleAllColumnsVisible(t.target?.checked);
		};
	}
};
function Wu(e, t) {
	return t ? t === "center" ? e.getCenterVisibleLeafColumns() : t === "left" ? e.getLeftVisibleLeafColumns() : e.getRightVisibleLeafColumns() : e.getVisibleLeafColumns();
}
var Gu = { createTable: (e) => {
	e._getGlobalFacetedRowModel = e.options.getFacetedRowModel && e.options.getFacetedRowModel(e, "__global__"), e.getGlobalFacetedRowModel = () => e.options.manualFiltering || !e._getGlobalFacetedRowModel ? e.getPreFilteredRowModel() : e._getGlobalFacetedRowModel(), e._getGlobalFacetedUniqueValues = e.options.getFacetedUniqueValues && e.options.getFacetedUniqueValues(e, "__global__"), e.getGlobalFacetedUniqueValues = () => e._getGlobalFacetedUniqueValues ? e._getGlobalFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getGlobalFacetedMinMaxValues = e.options.getFacetedMinMaxValues && e.options.getFacetedMinMaxValues(e, "__global__"), e.getGlobalFacetedMinMaxValues = () => {
		if (e._getGlobalFacetedMinMaxValues) return e._getGlobalFacetedMinMaxValues();
	};
} }, Ku = {
	getInitialState: (e) => ({
		globalFilter: void 0,
		...e
	}),
	getDefaultOptions: (e) => ({
		onGlobalFilterChange: au("globalFilter", e),
		globalFilterFn: "auto",
		getColumnCanGlobalFilter: (t) => {
			var n;
			let r = (n = e.getCoreRowModel().flatRows[0]) == null || (n = n._getAllCellsByColumnId()[t.id]) == null ? void 0 : n.getValue();
			return typeof r == "string" || typeof r == "number";
		}
	}),
	createColumn: (e, t) => {
		e.getCanGlobalFilter = () => (e.columnDef.enableGlobalFilter ?? !0) && (t.options.enableGlobalFilter ?? !0) && (t.options.enableFilters ?? !0) && ((t.options.getColumnCanGlobalFilter == null ? void 0 : t.options.getColumnCanGlobalFilter(e)) ?? !0) && !!e.accessorFn;
	},
	createTable: (e) => {
		e.getGlobalAutoFilterFn = () => Eu.includesString, e.getGlobalFilterFn = () => {
			let { globalFilterFn: t } = e.options;
			return ou(t) ? t : t === "auto" ? e.getGlobalAutoFilterFn() : e.options.filterFns?.[t] ?? Eu[t];
		}, e.setGlobalFilter = (t) => {
			e.options.onGlobalFilterChange == null || e.options.onGlobalFilterChange(t);
		}, e.resetGlobalFilter = (t) => {
			e.setGlobalFilter(t ? void 0 : e.initialState.globalFilter);
		};
	}
}, qu = {
	getInitialState: (e) => ({
		expanded: {},
		...e
	}),
	getDefaultOptions: (e) => ({
		onExpandedChange: au("expanded", e),
		paginateExpandedRows: !0
	}),
	createTable: (e) => {
		let t = !1, n = !1;
		e._autoResetExpanded = () => {
			if (!t) {
				e._queue(() => {
					t = !0;
				});
				return;
			}
			if (e.options.autoResetAll ?? e.options.autoResetExpanded ?? !e.options.manualExpanding) {
				if (n) return;
				n = !0, e._queue(() => {
					e.resetExpanded(), n = !1;
				});
			}
		}, e.setExpanded = (t) => e.options.onExpandedChange == null ? void 0 : e.options.onExpandedChange(t), e.toggleAllRowsExpanded = (t) => {
			t ?? !e.getIsAllRowsExpanded() ? e.setExpanded(!0) : e.setExpanded({});
		}, e.resetExpanded = (t) => {
			e.setExpanded(t ? {} : e.initialState?.expanded ?? {});
		}, e.getCanSomeRowsExpand = () => e.getPrePaginationRowModel().flatRows.some((e) => e.getCanExpand()), e.getToggleAllRowsExpandedHandler = () => (t) => {
			t.persist == null || t.persist(), e.toggleAllRowsExpanded();
		}, e.getIsSomeRowsExpanded = () => {
			let t = e.getState().expanded;
			return t === !0 || Object.values(t).some(Boolean);
		}, e.getIsAllRowsExpanded = () => {
			let t = e.getState().expanded;
			return typeof t == "boolean" ? t === !0 : !(!Object.keys(t).length || e.getRowModel().flatRows.some((e) => !e.getIsExpanded()));
		}, e.getExpandedDepth = () => {
			let t = 0;
			return (e.getState().expanded === !0 ? Object.keys(e.getRowModel().rowsById) : Object.keys(e.getState().expanded)).forEach((e) => {
				let n = e.split(".");
				t = Math.max(t, n.length);
			}), t;
		}, e.getPreExpandedRowModel = () => e.getSortedRowModel(), e.getExpandedRowModel = () => (!e._getExpandedRowModel && e.options.getExpandedRowModel && (e._getExpandedRowModel = e.options.getExpandedRowModel(e)), e.options.manualExpanding || !e._getExpandedRowModel ? e.getPreExpandedRowModel() : e._getExpandedRowModel());
	},
	createRow: (e, t) => {
		e.toggleExpanded = (n) => {
			t.setExpanded((r) => {
				let i = r === !0 ? !0 : !!(r != null && r[e.id]), a = {};
				if (r === !0 ? Object.keys(t.getRowModel().rowsById).forEach((e) => {
					a[e] = !0;
				}) : a = r, n ??= !i, !i && n) return {
					...a,
					[e.id]: !0
				};
				if (i && !n) {
					let { [e.id]: t, ...n } = a;
					return n;
				}
				return r;
			});
		}, e.getIsExpanded = () => {
			let n = t.getState().expanded;
			return !!((t.options.getIsRowExpanded == null ? void 0 : t.options.getIsRowExpanded(e)) ?? (n === !0 || n?.[e.id]));
		}, e.getCanExpand = () => {
			var n;
			return (t.options.getRowCanExpand == null ? void 0 : t.options.getRowCanExpand(e)) ?? ((t.options.enableExpanding ?? !0) && !!((n = e.subRows) != null && n.length));
		}, e.getIsAllParentsExpanded = () => {
			let n = !0, r = e;
			for (; n && r.parentId;) r = t.getRow(r.parentId, !0), n = r.getIsExpanded();
			return n;
		}, e.getToggleExpandedHandler = () => {
			let t = e.getCanExpand();
			return () => {
				t && e.toggleExpanded();
			};
		};
	}
}, Ju = 0, Yu = 10, Xu = () => ({
	pageIndex: Ju,
	pageSize: Yu
}), Zu = {
	getInitialState: (e) => ({
		...e,
		pagination: {
			...Xu(),
			...e?.pagination
		}
	}),
	getDefaultOptions: (e) => ({ onPaginationChange: au("pagination", e) }),
	createTable: (e) => {
		let t = !1, n = !1;
		e._autoResetPageIndex = () => {
			if (!t) {
				e._queue(() => {
					t = !0;
				});
				return;
			}
			if (e.options.autoResetAll ?? e.options.autoResetPageIndex ?? !e.options.manualPagination) {
				if (n) return;
				n = !0, e._queue(() => {
					e.resetPageIndex(), n = !1;
				});
			}
		}, e.setPagination = (t) => e.options.onPaginationChange == null ? void 0 : e.options.onPaginationChange((e) => iu(t, e)), e.resetPagination = (t) => {
			e.setPagination(t ? Xu() : e.initialState.pagination ?? Xu());
		}, e.setPageIndex = (t) => {
			e.setPagination((n) => {
				let r = iu(t, n.pageIndex), i = e.options.pageCount === void 0 || e.options.pageCount === -1 ? 2 ** 53 - 1 : e.options.pageCount - 1;
				return r = Math.max(0, Math.min(r, i)), {
					...n,
					pageIndex: r
				};
			});
		}, e.resetPageIndex = (t) => {
			var n;
			e.setPageIndex(t ? Ju : ((n = e.initialState) == null || (n = n.pagination) == null ? void 0 : n.pageIndex) ?? Ju);
		}, e.resetPageSize = (t) => {
			var n;
			e.setPageSize(t ? Yu : ((n = e.initialState) == null || (n = n.pagination) == null ? void 0 : n.pageSize) ?? Yu);
		}, e.setPageSize = (t) => {
			e.setPagination((e) => {
				let n = Math.max(1, iu(t, e.pageSize)), r = e.pageSize * e.pageIndex, i = Math.floor(r / n);
				return {
					...e,
					pageIndex: i,
					pageSize: n
				};
			});
		}, e.setPageCount = (t) => e.setPagination((n) => {
			let r = iu(t, e.options.pageCount ?? -1);
			return typeof r == "number" && (r = Math.max(-1, r)), {
				...n,
				pageCount: r
			};
		}), e.getPageOptions = Y(() => [e.getPageCount()], (e) => {
			let t = [];
			return e && e > 0 && (t = [...Array(e)].fill(null).map((e, t) => t)), t;
		}, X(e.options, "debugTable", "getPageOptions")), e.getCanPreviousPage = () => e.getState().pagination.pageIndex > 0, e.getCanNextPage = () => {
			let { pageIndex: t } = e.getState().pagination, n = e.getPageCount();
			return n === -1 ? !0 : n === 0 ? !1 : t < n - 1;
		}, e.previousPage = () => e.setPageIndex((e) => e - 1), e.nextPage = () => e.setPageIndex((e) => e + 1), e.firstPage = () => e.setPageIndex(0), e.lastPage = () => e.setPageIndex(e.getPageCount() - 1), e.getPrePaginationRowModel = () => e.getExpandedRowModel(), e.getPaginationRowModel = () => (!e._getPaginationRowModel && e.options.getPaginationRowModel && (e._getPaginationRowModel = e.options.getPaginationRowModel(e)), e.options.manualPagination || !e._getPaginationRowModel ? e.getPrePaginationRowModel() : e._getPaginationRowModel()), e.getPageCount = () => e.options.pageCount ?? Math.ceil(e.getRowCount() / e.getState().pagination.pageSize), e.getRowCount = () => e.options.rowCount ?? e.getPrePaginationRowModel().rows.length;
	}
}, Qu = () => ({
	top: [],
	bottom: []
}), $u = {
	getInitialState: (e) => ({
		rowPinning: Qu(),
		...e
	}),
	getDefaultOptions: (e) => ({ onRowPinningChange: au("rowPinning", e) }),
	createRow: (e, t) => {
		e.pin = (n, r, i) => {
			let a = r ? e.getLeafRows().map((e) => {
				let { id: t } = e;
				return t;
			}) : [], o = i ? e.getParentRows().map((e) => {
				let { id: t } = e;
				return t;
			}) : [], s = /* @__PURE__ */ new Set([
				...o,
				e.id,
				...a
			]);
			t.setRowPinning((e) => n === "bottom" ? {
				top: (e?.top ?? []).filter((e) => !(s != null && s.has(e))),
				bottom: [...(e?.bottom ?? []).filter((e) => !(s != null && s.has(e))), ...Array.from(s)]
			} : n === "top" ? {
				top: [...(e?.top ?? []).filter((e) => !(s != null && s.has(e))), ...Array.from(s)],
				bottom: (e?.bottom ?? []).filter((e) => !(s != null && s.has(e)))
			} : {
				top: (e?.top ?? []).filter((e) => !(s != null && s.has(e))),
				bottom: (e?.bottom ?? []).filter((e) => !(s != null && s.has(e)))
			});
		}, e.getCanPin = () => {
			let { enableRowPinning: n, enablePinning: r } = t.options;
			return typeof n == "function" ? n(e) : n ?? r ?? !0;
		}, e.getIsPinned = () => {
			let n = [e.id], { top: r, bottom: i } = t.getState().rowPinning, a = n.some((e) => r?.includes(e)), o = n.some((e) => i?.includes(e));
			return a ? "top" : o ? "bottom" : !1;
		}, e.getPinnedIndex = () => {
			let n = e.getIsPinned();
			return n ? ((n === "top" ? t.getTopRows() : t.getBottomRows())?.map((e) => {
				let { id: t } = e;
				return t;
			}))?.indexOf(e.id) ?? -1 : -1;
		};
	},
	createTable: (e) => {
		e.setRowPinning = (t) => e.options.onRowPinningChange == null ? void 0 : e.options.onRowPinningChange(t), e.resetRowPinning = (t) => e.setRowPinning(t ? Qu() : e.initialState?.rowPinning ?? Qu()), e.getIsSomeRowsPinned = (t) => {
			let n = e.getState().rowPinning;
			return t ? !!n[t]?.length : !!(n.top?.length || n.bottom?.length);
		}, e._getPinnedRows = (t, n, r) => (e.options.keepPinnedRows ?? !0 ? (n ?? []).map((t) => {
			let n = e.getRow(t, !0);
			return n.getIsAllParentsExpanded() ? n : null;
		}) : (n ?? []).map((e) => t.find((t) => t.id === e))).filter(Boolean).map((e) => ({
			...e,
			position: r
		})), e.getTopRows = Y(() => [e.getRowModel().rows, e.getState().rowPinning.top], (t, n) => e._getPinnedRows(t, n, "top"), X(e.options, "debugRows", "getTopRows")), e.getBottomRows = Y(() => [e.getRowModel().rows, e.getState().rowPinning.bottom], (t, n) => e._getPinnedRows(t, n, "bottom"), X(e.options, "debugRows", "getBottomRows")), e.getCenterRows = Y(() => [
			e.getRowModel().rows,
			e.getState().rowPinning.top,
			e.getState().rowPinning.bottom
		], (e, t, n) => {
			let r = /* @__PURE__ */ new Set([...t ?? [], ...n ?? []]);
			return e.filter((e) => !r.has(e.id));
		}, X(e.options, "debugRows", "getCenterRows"));
	}
}, ed = {
	getInitialState: (e) => ({
		rowSelection: {},
		...e
	}),
	getDefaultOptions: (e) => ({
		onRowSelectionChange: au("rowSelection", e),
		enableRowSelection: !0,
		enableMultiRowSelection: !0,
		enableSubRowSelection: !0
	}),
	createTable: (e) => {
		e.setRowSelection = (t) => e.options.onRowSelectionChange == null ? void 0 : e.options.onRowSelectionChange(t), e.resetRowSelection = (t) => e.setRowSelection(t ? {} : e.initialState.rowSelection ?? {}), e.toggleAllRowsSelected = (t) => {
			e.setRowSelection((n) => {
				t = t === void 0 ? !e.getIsAllRowsSelected() : t;
				let r = { ...n }, i = e.getPreGroupedRowModel().flatRows;
				return t ? i.forEach((e) => {
					e.getCanSelect() && (r[e.id] = !0);
				}) : i.forEach((e) => {
					delete r[e.id];
				}), r;
			});
		}, e.toggleAllPageRowsSelected = (t) => e.setRowSelection((n) => {
			let r = t === void 0 ? !e.getIsAllPageRowsSelected() : t, i = { ...n };
			return e.getRowModel().rows.forEach((t) => {
				td(i, t.id, r, !0, e);
			}), i;
		}), e.getPreSelectedRowModel = () => e.getCoreRowModel(), e.getSelectedRowModel = Y(() => [e.getState().rowSelection, e.getCoreRowModel()], (t, n) => Object.keys(t).length ? nd(e, n) : {
			rows: [],
			flatRows: [],
			rowsById: {}
		}, X(e.options, "debugTable", "getSelectedRowModel")), e.getFilteredSelectedRowModel = Y(() => [e.getState().rowSelection, e.getFilteredRowModel()], (t, n) => Object.keys(t).length ? nd(e, n) : {
			rows: [],
			flatRows: [],
			rowsById: {}
		}, X(e.options, "debugTable", "getFilteredSelectedRowModel")), e.getGroupedSelectedRowModel = Y(() => [e.getState().rowSelection, e.getSortedRowModel()], (t, n) => Object.keys(t).length ? nd(e, n) : {
			rows: [],
			flatRows: [],
			rowsById: {}
		}, X(e.options, "debugTable", "getGroupedSelectedRowModel")), e.getIsAllRowsSelected = () => {
			let t = e.getFilteredRowModel().flatRows, { rowSelection: n } = e.getState(), r = !!(t.length && Object.keys(n).length);
			return r && t.some((e) => e.getCanSelect() && !n[e.id]) && (r = !1), r;
		}, e.getIsAllPageRowsSelected = () => {
			let t = e.getPaginationRowModel().flatRows.filter((e) => e.getCanSelect()), { rowSelection: n } = e.getState(), r = !!t.length;
			return r && t.some((e) => !n[e.id]) && (r = !1), r;
		}, e.getIsSomeRowsSelected = () => {
			let t = Object.keys(e.getState().rowSelection ?? {}).length;
			return t > 0 && t < e.getFilteredRowModel().flatRows.length;
		}, e.getIsSomePageRowsSelected = () => {
			let t = e.getPaginationRowModel().flatRows;
			return e.getIsAllPageRowsSelected() ? !1 : t.filter((e) => e.getCanSelect()).some((e) => e.getIsSelected() || e.getIsSomeSelected());
		}, e.getToggleAllRowsSelectedHandler = () => (t) => {
			e.toggleAllRowsSelected(t.target.checked);
		}, e.getToggleAllPageRowsSelectedHandler = () => (t) => {
			e.toggleAllPageRowsSelected(t.target.checked);
		};
	},
	createRow: (e, t) => {
		e.toggleSelected = (n, r) => {
			let i = e.getIsSelected();
			t.setRowSelection((a) => {
				if (n = n === void 0 ? !i : n, e.getCanSelect() && i === n) return a;
				let o = { ...a };
				return td(o, e.id, n, r?.selectChildren ?? !0, t), o;
			});
		}, e.getIsSelected = () => {
			let { rowSelection: n } = t.getState();
			return rd(e, n);
		}, e.getIsSomeSelected = () => {
			let { rowSelection: n } = t.getState();
			return id(e, n) === "some";
		}, e.getIsAllSubRowsSelected = () => {
			let { rowSelection: n } = t.getState();
			return id(e, n) === "all";
		}, e.getCanSelect = () => typeof t.options.enableRowSelection == "function" ? t.options.enableRowSelection(e) : t.options.enableRowSelection ?? !0, e.getCanSelectSubRows = () => typeof t.options.enableSubRowSelection == "function" ? t.options.enableSubRowSelection(e) : t.options.enableSubRowSelection ?? !0, e.getCanMultiSelect = () => typeof t.options.enableMultiRowSelection == "function" ? t.options.enableMultiRowSelection(e) : t.options.enableMultiRowSelection ?? !0, e.getToggleSelectedHandler = () => {
			let t = e.getCanSelect();
			return (n) => {
				t && e.toggleSelected(n.target?.checked);
			};
		};
	}
}, td = (e, t, n, r, i) => {
	var a;
	let o = i.getRow(t, !0);
	n ? (o.getCanMultiSelect() || Object.keys(e).forEach((t) => delete e[t]), o.getCanSelect() && (e[t] = !0)) : delete e[t], r && (a = o.subRows) != null && a.length && o.getCanSelectSubRows() && o.subRows.forEach((t) => td(e, t.id, n, r, i));
};
function nd(e, t) {
	let n = e.getState().rowSelection, r = [], i = {}, a = function(e, t) {
		return e.map((e) => {
			var t;
			let o = rd(e, n);
			if (o && (r.push(e), i[e.id] = e), (t = e.subRows) != null && t.length && (e = {
				...e,
				subRows: a(e.subRows)
			}), o) return e;
		}).filter(Boolean);
	};
	return {
		rows: a(t.rows),
		flatRows: r,
		rowsById: i
	};
}
function rd(e, t) {
	return t[e.id] ?? !1;
}
function id(e, t, n) {
	var r;
	if (!((r = e.subRows) != null && r.length)) return !1;
	let i = !0, a = !1;
	return e.subRows.forEach((e) => {
		if (!(a && !i) && (e.getCanSelect() && (rd(e, t) ? a = !0 : i = !1), e.subRows && e.subRows.length)) {
			let n = id(e, t);
			n === "all" ? a = !0 : (n === "some" && (a = !0), i = !1);
		}
	}), i ? "all" : a ? "some" : !1;
}
var ad = /([0-9]+)/gm, od = (e, t, n) => md(pd(e.getValue(n)).toLowerCase(), pd(t.getValue(n)).toLowerCase()), sd = (e, t, n) => md(pd(e.getValue(n)), pd(t.getValue(n))), cd = (e, t, n) => fd(pd(e.getValue(n)).toLowerCase(), pd(t.getValue(n)).toLowerCase()), ld = (e, t, n) => fd(pd(e.getValue(n)), pd(t.getValue(n))), ud = (e, t, n) => {
	let r = e.getValue(n), i = t.getValue(n);
	return r > i ? 1 : r < i ? -1 : 0;
}, dd = (e, t, n) => fd(e.getValue(n), t.getValue(n));
function fd(e, t) {
	return e === t ? 0 : e > t ? 1 : -1;
}
function pd(e) {
	return typeof e == "number" ? isNaN(e) || e === Infinity || e === -Infinity ? "" : String(e) : typeof e == "string" ? e : "";
}
function md(e, t) {
	let n = e.split(ad).filter(Boolean), r = t.split(ad).filter(Boolean);
	for (; n.length && r.length;) {
		let e = n.shift(), t = r.shift(), i = parseInt(e, 10), a = parseInt(t, 10), o = [i, a].sort();
		if (isNaN(o[0])) {
			if (e > t) return 1;
			if (t > e) return -1;
			continue;
		}
		if (isNaN(o[1])) return isNaN(i) ? -1 : 1;
		if (i > a) return 1;
		if (a > i) return -1;
	}
	return n.length - r.length;
}
var hd = {
	alphanumeric: od,
	alphanumericCaseSensitive: sd,
	text: cd,
	textCaseSensitive: ld,
	datetime: ud,
	basic: dd
}, gd = [
	pu,
	Uu,
	Nu,
	Fu,
	gu,
	Ou,
	Gu,
	Ku,
	{
		getInitialState: (e) => ({
			sorting: [],
			...e
		}),
		getDefaultColumnDef: () => ({
			sortingFn: "auto",
			sortUndefined: 1
		}),
		getDefaultOptions: (e) => ({
			onSortingChange: au("sorting", e),
			isMultiSortEvent: (e) => e.shiftKey
		}),
		createColumn: (e, t) => {
			e.getAutoSortingFn = () => {
				let n = t.getFilteredRowModel().flatRows.slice(10), r = !1;
				for (let t of n) {
					let n = t?.getValue(e.id);
					if (Object.prototype.toString.call(n) === "[object Date]") return hd.datetime;
					if (typeof n == "string" && (r = !0, n.split(ad).length > 1)) return hd.alphanumeric;
				}
				return r ? hd.text : hd.basic;
			}, e.getAutoSortDir = () => typeof t.getFilteredRowModel().flatRows[0]?.getValue(e.id) == "string" ? "asc" : "desc", e.getSortingFn = () => {
				if (!e) throw Error();
				return ou(e.columnDef.sortingFn) ? e.columnDef.sortingFn : e.columnDef.sortingFn === "auto" ? e.getAutoSortingFn() : t.options.sortingFns?.[e.columnDef.sortingFn] ?? hd[e.columnDef.sortingFn];
			}, e.toggleSorting = (n, r) => {
				let i = e.getNextSortingOrder(), a = n != null;
				t.setSorting((o) => {
					let s = o?.find((t) => t.id === e.id), c = o?.findIndex((t) => t.id === e.id), l = [], u, d = a ? n : i === "desc";
					return u = o != null && o.length && e.getCanMultiSort() && r ? s ? "toggle" : "add" : o != null && o.length && c !== o.length - 1 ? "replace" : s ? "toggle" : "replace", u === "toggle" && (a || i || (u = "remove")), u === "add" ? (l = [...o, {
						id: e.id,
						desc: d
					}], l.splice(0, l.length - (t.options.maxMultiSortColCount ?? 2 ** 53 - 1))) : l = u === "toggle" ? o.map((t) => t.id === e.id ? {
						...t,
						desc: d
					} : t) : u === "remove" ? o.filter((t) => t.id !== e.id) : [{
						id: e.id,
						desc: d
					}], l;
				});
			}, e.getFirstSortDir = () => e.columnDef.sortDescFirst ?? t.options.sortDescFirst ?? e.getAutoSortDir() === "desc" ? "desc" : "asc", e.getNextSortingOrder = (n) => {
				let r = e.getFirstSortDir(), i = e.getIsSorted();
				return i ? i !== r && (t.options.enableSortingRemoval ?? !0) && (!n || (t.options.enableMultiRemove ?? !0)) ? !1 : i === "desc" ? "asc" : "desc" : r;
			}, e.getCanSort = () => (e.columnDef.enableSorting ?? !0) && (t.options.enableSorting ?? !0) && !!e.accessorFn, e.getCanMultiSort = () => e.columnDef.enableMultiSort ?? t.options.enableMultiSort ?? !!e.accessorFn, e.getIsSorted = () => {
				let n = t.getState().sorting?.find((t) => t.id === e.id);
				return n ? n.desc ? "desc" : "asc" : !1;
			}, e.getSortIndex = () => t.getState().sorting?.findIndex((t) => t.id === e.id) ?? -1, e.clearSorting = () => {
				t.setSorting((t) => t != null && t.length ? t.filter((t) => t.id !== e.id) : []);
			}, e.getToggleSortingHandler = () => {
				let n = e.getCanSort();
				return (r) => {
					n && (r.persist == null || r.persist(), e.toggleSorting == null || e.toggleSorting(void 0, e.getCanMultiSort() ? t.options.isMultiSortEvent == null ? void 0 : t.options.isMultiSortEvent(r) : !1));
				};
			};
		},
		createTable: (e) => {
			e.setSorting = (t) => e.options.onSortingChange == null ? void 0 : e.options.onSortingChange(t), e.resetSorting = (t) => {
				e.setSorting(t ? [] : e.initialState?.sorting ?? []);
			}, e.getPreSortedRowModel = () => e.getGroupedRowModel(), e.getSortedRowModel = () => (!e._getSortedRowModel && e.options.getSortedRowModel && (e._getSortedRowModel = e.options.getSortedRowModel(e)), e.options.manualSorting || !e._getSortedRowModel ? e.getPreSortedRowModel() : e._getSortedRowModel());
		}
	},
	ju,
	qu,
	Zu,
	$u,
	ed,
	zu
];
function _d(e) {
	process.env.NODE_ENV !== "production" && (e.debugAll || e.debugTable) && console.info("Creating Table Instance...");
	let t = [...gd, ...e._features ?? []], n = { _features: t }, r = n._features.reduce((e, t) => Object.assign(e, t.getDefaultOptions == null ? void 0 : t.getDefaultOptions(n)), {}), i = (e) => n.options.mergeOptions ? n.options.mergeOptions(r, e) : {
		...r,
		...e
	}, a = { ...e.initialState ?? {} };
	n._features.forEach((e) => {
		a = (e.getInitialState == null ? void 0 : e.getInitialState(a)) ?? a;
	});
	let o = [], s = !1, c = {
		_features: t,
		options: {
			...r,
			...e
		},
		initialState: a,
		_queue: (e) => {
			o.push(e), s || (s = !0, Promise.resolve().then(() => {
				for (; o.length;) o.shift()();
				s = !1;
			}).catch((e) => setTimeout(() => {
				throw e;
			})));
		},
		reset: () => {
			n.setState(n.initialState);
		},
		setOptions: (e) => {
			let t = iu(e, n.options);
			n.options = i(t);
		},
		getState: () => n.options.state,
		setState: (e) => {
			n.options.onStateChange == null || n.options.onStateChange(e);
		},
		_getRowId: (e, t, r) => (n.options.getRowId == null ? void 0 : n.options.getRowId(e, t, r)) ?? `${r ? [r.id, t].join(".") : t}`,
		getCoreRowModel: () => (n._getCoreRowModel ||= n.options.getCoreRowModel(n), n._getCoreRowModel()),
		getRowModel: () => n.getPaginationRowModel(),
		getRow: (e, t) => {
			let r = (t ? n.getPrePaginationRowModel() : n.getRowModel()).rowsById[e];
			if (!r && (r = n.getCoreRowModel().rowsById[e], !r)) throw process.env.NODE_ENV === "production" ? Error() : Error(`getRow could not find row with ID: ${e}`);
			return r;
		},
		_getDefaultColumnDef: Y(() => [n.options.defaultColumn], (e) => (e ??= {}, {
			header: (e) => {
				let t = e.header.column.columnDef;
				return t.accessorKey ? t.accessorKey : t.accessorFn ? t.id : null;
			},
			cell: (e) => {
				var t;
				return ((t = e.renderValue()) == null || t.toString == null ? void 0 : t.toString()) ?? null;
			},
			...n._features.reduce((e, t) => Object.assign(e, t.getDefaultColumnDef == null ? void 0 : t.getDefaultColumnDef()), {}),
			...e
		}), X(e, "debugColumns", "_getDefaultColumnDef")),
		_getColumnDefs: () => n.options.columns,
		getAllColumns: Y(() => [n._getColumnDefs()], (e) => {
			let t = function(e, r, i) {
				return i === void 0 && (i = 0), e.map((e) => {
					let a = uu(n, e, i, r), o = e;
					return a.columns = o.columns ? t(o.columns, a, i + 1) : [], a;
				});
			};
			return t(e);
		}, X(e, "debugColumns", "getAllColumns")),
		getAllFlatColumns: Y(() => [n.getAllColumns()], (e) => e.flatMap((e) => e.getFlatColumns()), X(e, "debugColumns", "getAllFlatColumns")),
		_getAllFlatColumnsById: Y(() => [n.getAllFlatColumns()], (e) => e.reduce((e, t) => (e[t.id] = t, e), {}), X(e, "debugColumns", "getAllFlatColumnsById")),
		getAllLeafColumns: Y(() => [n.getAllColumns(), n._getOrderColumnsFn()], (e, t) => t(e.flatMap((e) => e.getLeafColumns())), X(e, "debugColumns", "getAllLeafColumns")),
		getColumn: (e) => {
			let t = n._getAllFlatColumnsById()[e];
			return process.env.NODE_ENV !== "production" && !t && console.error(`[Table] Column with id '${e}' does not exist.`), t;
		}
	};
	Object.assign(n, c);
	for (let e = 0; e < n._features.length; e++) {
		let t = n._features[e];
		t == null || t.createTable == null || t.createTable(n);
	}
	return n;
}
function vd() {
	return (e) => Y(() => [e.options.data], (t) => {
		let n = {
			rows: [],
			flatRows: [],
			rowsById: {}
		}, r = function(t, i, a) {
			i === void 0 && (i = 0);
			let o = [];
			for (let c = 0; c < t.length; c++) {
				let l = hu(e, e._getRowId(t[c], c, a), t[c], c, i, void 0, a?.id);
				if (n.flatRows.push(l), n.rowsById[l.id] = l, o.push(l), e.options.getSubRows) {
					var s;
					l.originalSubRows = e.options.getSubRows(t[c], c), (s = l.originalSubRows) != null && s.length && (l.subRows = r(l.originalSubRows, i + 1, l));
				}
			}
			return o;
		};
		return n.rows = r(t), n;
	}, X(e.options, "debugTable", "getRowModel", () => e._autoResetPageIndex()));
}
function yd(e) {
	let t = [], n = (e) => {
		var r;
		t.push(e), (r = e.subRows) != null && r.length && e.getIsExpanded() && e.subRows.forEach(n);
	};
	return e.rows.forEach(n), {
		rows: t,
		flatRows: e.flatRows,
		rowsById: e.rowsById
	};
}
function bd(e) {
	return (e) => Y(() => [
		e.getState().pagination,
		e.getPrePaginationRowModel(),
		e.options.paginateExpandedRows ? void 0 : e.getState().expanded
	], (t, n) => {
		if (!n.rows.length) return n;
		let { pageSize: r, pageIndex: i } = t, { rows: a, flatRows: o, rowsById: s } = n, c = r * i, l = c + r;
		a = a.slice(c, l);
		let u;
		u = e.options.paginateExpandedRows ? {
			rows: a,
			flatRows: o,
			rowsById: s
		} : yd({
			rows: a,
			flatRows: o,
			rowsById: s
		}), u.flatRows = [];
		let d = (e) => {
			u.flatRows.push(e), e.subRows.length && e.subRows.forEach(d);
		};
		return u.rows.forEach(d), u;
	}, X(e.options, "debugTable", "getPaginationRowModel"));
}
function xd() {
	return (e) => Y(() => [e.getState().sorting, e.getPreSortedRowModel()], (t, n) => {
		if (!n.rows.length || !(t != null && t.length)) return n;
		let r = e.getState().sorting, i = [], a = r.filter((t) => e.getColumn(t.id)?.getCanSort()), o = {};
		a.forEach((t) => {
			let n = e.getColumn(t.id);
			n && (o[t.id] = {
				sortUndefined: n.columnDef.sortUndefined,
				invertSorting: n.columnDef.invertSorting,
				sortingFn: n.getSortingFn()
			});
		});
		let s = (e) => {
			let t = e.map((e) => ({ ...e }));
			return t.sort((e, t) => {
				for (let n = 0; n < a.length; n += 1) {
					let r = a[n], i = o[r.id], s = i.sortUndefined, c = r?.desc ?? !1, l = 0;
					if (s) {
						let n = e.getValue(r.id), i = t.getValue(r.id), a = n === void 0, o = i === void 0;
						if (a || o) {
							if (s === "first") return a ? -1 : 1;
							if (s === "last") return a ? 1 : -1;
							l = a && o ? 0 : a ? s : -s;
						}
					}
					if (l === 0 && (l = i.sortingFn(e, t, r.id)), l !== 0) return c && (l *= -1), i.invertSorting && (l *= -1), l;
				}
				return e.index - t.index;
			}), t.forEach((e) => {
				var t;
				i.push(e), (t = e.subRows) != null && t.length && (e.subRows = s(e.subRows));
			}), t;
		};
		return {
			rows: s(n.rows),
			flatRows: i,
			rowsById: n.rowsById
		};
	}, X(e.options, "debugTable", "getSortedRowModel", () => e._autoResetPageIndex()));
}
function Sd(e, t) {
	return e ? Cd(e) ? /*#__PURE__*/ w.createElement(e, t) : e : null;
}
function Cd(e) {
	return wd(e) || typeof e == "function" || Td(e);
}
function wd(e) {
	return typeof e == "function" && (() => {
		let t = Object.getPrototypeOf(e);
		return t.prototype && t.prototype.isReactComponent;
	})();
}
function Td(e) {
	return typeof e == "object" && typeof e.$$typeof == "symbol" && ["react.memo", "react.forward_ref"].includes(e.$$typeof.description);
}
function Ed(e) {
	let t = {
		state: {},
		onStateChange: () => {},
		renderFallbackValue: null,
		...e
	}, [n] = w.useState(() => ({ current: _d(t) })), [r, i] = w.useState(() => n.current.initialState);
	return n.current.setOptions((t) => ({
		...t,
		...e,
		state: {
			...r,
			...e.state
		},
		onStateChange: (t) => {
			i(t), e.onStateChange == null || e.onStateChange(t);
		}
	})), n.current;
}
var Dd = ru("arrow-down", [["path", {
	d: "M12 5v14",
	key: "s699le"
}], ["path", {
	d: "m19 12-7 7-7-7",
	key: "1idqje"
}]]), Od = ru("arrow-right", [["path", {
	d: "M5 12h14",
	key: "1ays0h"
}], ["path", {
	d: "m12 5 7 7-7 7",
	key: "xquz4c"
}]]), kd = ru("arrow-up", [["path", {
	d: "m5 12 7-7 7 7",
	key: "hav0vg"
}], ["path", {
	d: "M12 19V5",
	key: "x0mq9r"
}]]), Ad = ru("chevron-left", [["path", {
	d: "m15 18-6-6 6-6",
	key: "1wnfg3"
}]]), jd = ru("chevron-right", [["path", {
	d: "m9 18 6-6-6-6",
	key: "mthhwq"
}]]), Md = ru("chevrons-up-down", [["path", {
	d: "m7 15 5 5 5-5",
	key: "1hf1tw"
}], ["path", {
	d: "m7 9 5-5 5 5",
	key: "sgt6xg"
}]]), Nd = ru("inbox", [["polyline", {
	points: "22 12 16 12 14 15 10 15 8 12 2 12",
	key: "o97t9d"
}], ["path", {
	d: "M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z",
	key: "oot6mr"
}]]), Pd = ru("settings", [["path", {
	d: "M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915",
	key: "1i5ecw"
}], ["circle", {
	cx: "12",
	cy: "12",
	r: "3",
	key: "1v7zrd"
}]]), Fd = {
	asc: "ascending",
	desc: "descending"
}, Id = /* @__PURE__ */ N(mo, { children: /* @__PURE__ */ P(ho, { children: [/* @__PURE__ */ N(_o, {
	variant: "icon",
	children: /* @__PURE__ */ N(Nd, {})
}), /* @__PURE__ */ N(vo, { children: "No results" })] }) });
function Ld({ table: e, pageSizeOptions: t }) {
	let { pageIndex: n, pageSize: r } = e.getState().pagination, i = e.getPageCount(), a = e.getFilteredRowModel().rows.length, o = a === 0 ? 0 : n * r + 1, s = Math.min((n + 1) * r, a), c = Ds(i, n);
	return /* @__PURE__ */ P("div", {
		className: "flex flex-wrap items-center justify-between gap-2 px-3",
		children: [/* @__PURE__ */ P("div", {
			className: "flex items-center gap-2 text-xs text-muted-foreground",
			children: [/* @__PURE__ */ P("span", {
				className: "tabular-nums",
				children: [
					o,
					"–",
					s,
					" of ",
					a
				]
			}), t?.length ? /* @__PURE__ */ P(Gc, {
				value: String(r),
				onValueChange: (t) => e.setPageSize(Number(t)),
				children: [/* @__PURE__ */ N(Yc, {
					size: "sm",
					className: "w-auto gap-1",
					"aria-label": "Rows per page",
					children: /* @__PURE__ */ N(qc, {})
				}), /* @__PURE__ */ N(Xc, { children: /* @__PURE__ */ N(Kc, { children: t.map((e) => /* @__PURE__ */ P(Qc, {
					value: String(e),
					children: [e, " / page"]
				}, e)) }) })]
			}) : null]
		}), /* @__PURE__ */ N(bs, {
			className: "w-auto",
			children: /* @__PURE__ */ P(xs, { children: [
				/* @__PURE__ */ N(Ss, { children: /* @__PURE__ */ N(ws, {
					disabled: !e.getCanPreviousPage(),
					onClick: () => e.previousPage(),
					children: /* @__PURE__ */ N("span", {
						className: "sr-only",
						children: "Previous"
					})
				}) }),
				c.map((t, r) => t === "ellipsis" ? /* @__PURE__ */ N(Ss, { children: /* @__PURE__ */ N(Es, {}) }, `ellipsis-${r}`) : /* @__PURE__ */ N(Ss, { children: /* @__PURE__ */ N(Cs, {
					isActive: t === n,
					"aria-label": `Go to page ${t + 1}`,
					onClick: () => e.setPageIndex(t),
					children: t + 1
				}) }, t)),
				/* @__PURE__ */ N(Ss, { children: /* @__PURE__ */ N(Ts, {
					disabled: !e.getCanNextPage(),
					onClick: () => e.nextPage(),
					children: /* @__PURE__ */ N("span", {
						className: "sr-only",
						children: "Next"
					})
				}) })
			] })
		})]
	});
}
function Rd({ columns: e, data: t, className: n, stickyHeader: r, fullWidth: i, size: a, empty: o = Id, pageSize: s, pageSizeOptions: c }) {
	let l = s != null, [u, d] = w.useState([]), [f, p] = w.useState({
		pageIndex: 0,
		pageSize: s ?? 10
	});
	w.useEffect(() => {
		s != null && p((e) => ({
			...e,
			pageIndex: 0,
			pageSize: s
		}));
	}, [s]);
	let m = Ed({
		data: t,
		columns: e,
		state: {
			sorting: u,
			...l ? { pagination: f } : {}
		},
		onSortingChange: d,
		...l ? { onPaginationChange: p } : {},
		getCoreRowModel: vd(),
		getSortedRowModel: xd(),
		...l ? { getPaginationRowModel: bd() } : {}
	}), h = m.getRowModel().rows, g = /* @__PURE__ */ P(yl, {
		className: n,
		stickyHeader: r,
		fullWidth: i,
		size: a,
		children: [/* @__PURE__ */ N(bl, { children: m.getHeaderGroups().map((e) => /* @__PURE__ */ N(Cl, { children: e.headers.map((e) => {
			let t = e.column.getIsSorted(), { align: n, expand: r } = e.column.columnDef.meta ?? {}, i = e.isPlaceholder ? null : Sd(e.column.columnDef.header, e.getContext());
			return /* @__PURE__ */ N(wl, {
				colSpan: e.colSpan,
				align: n,
				expand: r,
				"aria-sort": t ? Fd[t] : void 0,
				children: e.column.getCanSort() && !e.isPlaceholder ? /* @__PURE__ */ P(J, {
					size: "sm",
					"aria-selected": t ? !0 : void 0,
					className: q("gap-1.5", t && "text-foreground", !t && "hover:bg-fill-hover/50"),
					onClick: e.column.getToggleSortingHandler(),
					children: [i, t === "asc" ? /* @__PURE__ */ N(kd, { className: "size-3" }) : t === "desc" ? /* @__PURE__ */ N(Dd, { className: "size-3" }) : /* @__PURE__ */ N(Md, { className: "size-3 opacity-50" })]
				}) : i
			}, e.id);
		}) }, e.id)) }), /* @__PURE__ */ N(xl, { children: h.length ? h.map((e) => /* @__PURE__ */ N(Cl, {
			"data-state": e.getIsSelected() ? "selected" : void 0,
			children: e.getVisibleCells().map((e) => /* @__PURE__ */ N(Tl, {
				align: e.column.columnDef.meta?.align,
				expand: e.column.columnDef.meta?.expand,
				children: Sd(e.column.columnDef.cell, e.getContext())
			}, e.id))
		}, e.id)) : /* @__PURE__ */ N(Cl, { children: /* @__PURE__ */ N(Tl, {
			colSpan: e.length,
			className: "p-2 hover:bg-transparent",
			children: o
		}) }) })]
	});
	return !l || m.getFilteredRowModel().rows.length === 0 ? g : /* @__PURE__ */ P("div", {
		className: "flex flex-col gap-2",
		children: [g, /* @__PURE__ */ N(Ld, {
			table: m,
			pageSizeOptions: c
		})]
	});
}
var zd = 365.2425, Bd = 6048e5, Vd = 864e5, Hd = 6e4, Ud = 36e5, Wd = 3600 * 24;
Wd * 7, Wd * zd / 12 * 3;
var Gd = Symbol.for("constructDateFrom");
function Z(e, t) {
	return typeof e == "function" ? e(t) : e && typeof e == "object" && Gd in e ? e[Gd](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
}
function Q(e, t) {
	return Z(t || e, e);
}
function Kd(e, t, n) {
	let r = Q(e, n?.in);
	return isNaN(t) ? Z(n?.in || e, NaN) : (t && r.setDate(r.getDate() + t), r);
}
function qd(e, t, n) {
	let r = Q(e, n?.in);
	if (isNaN(t)) return Z(n?.in || e, NaN);
	if (!t) return r;
	let i = r.getDate(), a = Z(n?.in || e, r.getTime());
	return a.setMonth(r.getMonth() + t + 1, 0), i >= a.getDate() ? a : (r.setFullYear(a.getFullYear(), a.getMonth(), i), r);
}
function Jd(e, t, n) {
	return Z(n?.in || e, +Q(e) + t);
}
function Yd(e, t, n) {
	return Jd(e, t * Ud, n);
}
var Xd = {};
function Zd() {
	return Xd;
}
function Qd(e, t) {
	let n = Zd(), r = t?.weekStartsOn ?? t?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, i = Q(e, t?.in), a = i.getDay(), o = (a < r ? 7 : 0) + a - r;
	return i.setDate(i.getDate() - o), i.setHours(0, 0, 0, 0), i;
}
function $d(e, t) {
	return Qd(e, {
		...t,
		weekStartsOn: 1
	});
}
function ef(e, t) {
	let n = Q(e, t?.in), r = n.getFullYear(), i = Z(n, 0);
	i.setFullYear(r + 1, 0, 4), i.setHours(0, 0, 0, 0);
	let a = $d(i), o = Z(n, 0);
	o.setFullYear(r, 0, 4), o.setHours(0, 0, 0, 0);
	let s = $d(o);
	return n.getTime() >= a.getTime() ? r + 1 : n.getTime() >= s.getTime() ? r : r - 1;
}
function tf(e) {
	let t = Q(e), n = new Date(Date.UTC(t.getFullYear(), t.getMonth(), t.getDate(), t.getHours(), t.getMinutes(), t.getSeconds(), t.getMilliseconds()));
	return n.setUTCFullYear(t.getFullYear()), e - +n;
}
function nf(e, ...t) {
	let n = Z.bind(null, e || t.find((e) => typeof e == "object"));
	return t.map(n);
}
function rf(e, t) {
	let n = Q(e, t?.in);
	return n.setHours(0, 0, 0, 0), n;
}
function af(e, t, n) {
	let [r, i] = nf(n?.in, e, t), a = rf(r), o = rf(i), s = +a - tf(a), c = +o - tf(o);
	return Math.round((s - c) / Vd);
}
function of(e, t) {
	let n = ef(e, t), r = Z(t?.in || e, 0);
	return r.setFullYear(n, 0, 4), r.setHours(0, 0, 0, 0), $d(r);
}
function sf(e, t, n) {
	let r = Q(e, n?.in);
	return r.setTime(r.getTime() + t * Hd), r;
}
function cf(e, t, n) {
	return Kd(e, t * 7, n);
}
function lf(e, t, n) {
	return qd(e, t * 12, n);
}
function uf(e) {
	return Z(e, Date.now());
}
function df(e, t, n) {
	let [r, i] = nf(n?.in, e, t);
	return +rf(r) == +rf(i);
}
function ff(e) {
	return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function pf(e) {
	return !(!ff(e) && typeof e != "number" || isNaN(+Q(e)));
}
function mf(e, t) {
	let n = Q(e, t?.in);
	return n.setHours(23, 59, 59, 999), n;
}
function hf(e, t) {
	let n = Q(e, t?.in), r = n.getMonth();
	return n.setFullYear(n.getFullYear(), r + 1, 0), n.setHours(23, 59, 59, 999), n;
}
function gf(e, t) {
	let [n, r] = nf(e, t.start, t.end);
	return {
		start: n,
		end: r
	};
}
function _f(e, t) {
	let { start: n, end: r } = gf(t?.in, e), i = +n > +r, a = i ? +n : +r, o = i ? r : n;
	o.setHours(0, 0, 0, 0);
	let s = t?.step ?? 1;
	if (!s) return [];
	s < 0 && (s = -s, i = !i);
	let c = [];
	for (; +o <= a;) c.push(Z(n, o)), o.setDate(o.getDate() + s), o.setHours(0, 0, 0, 0);
	return i ? c.reverse() : c;
}
function vf(e, t) {
	let { start: n, end: r } = gf(t?.in, e), i = +n > +r, a = i ? +n : +r, o = i ? r : n;
	o.setHours(0, 0, 0, 0), o.setDate(1);
	let s = t?.step ?? 1;
	if (!s) return [];
	s < 0 && (s = -s, i = !i);
	let c = [];
	for (; +o <= a;) c.push(Z(n, o)), o.setMonth(o.getMonth() + s);
	return i ? c.reverse() : c;
}
function yf(e, t) {
	let { start: n, end: r } = gf(t?.in, e), i = +n > +r, a = Qd(i ? r : n, t), o = Qd(i ? n : r, t);
	a.setHours(15), o.setHours(15);
	let s = +o.getTime(), c = a, l = t?.step ?? 1;
	if (!l) return [];
	l < 0 && (l = -l, i = !i);
	let u = [];
	for (; +c <= s;) c.setHours(0), u.push(Z(n, c)), c = cf(c, l), c.setHours(15);
	return i ? u.reverse() : u;
}
function bf(e, t) {
	let n = Q(e, t?.in);
	return n.setDate(1), n.setHours(0, 0, 0, 0), n;
}
function xf(e, t) {
	let n = Q(e, t?.in);
	return n.setFullYear(n.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function Sf(e, t) {
	let n = Zd(), r = t?.weekStartsOn ?? t?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, i = Q(e, t?.in), a = i.getDay(), o = (a < r ? -7 : 0) + 6 - (a - r);
	return i.setDate(i.getDate() + o), i.setHours(23, 59, 59, 999), i;
}
var Cf = {
	lessThanXSeconds: {
		one: "less than a second",
		other: "less than {{count}} seconds"
	},
	xSeconds: {
		one: "1 second",
		other: "{{count}} seconds"
	},
	halfAMinute: "half a minute",
	lessThanXMinutes: {
		one: "less than a minute",
		other: "less than {{count}} minutes"
	},
	xMinutes: {
		one: "1 minute",
		other: "{{count}} minutes"
	},
	aboutXHours: {
		one: "about 1 hour",
		other: "about {{count}} hours"
	},
	xHours: {
		one: "1 hour",
		other: "{{count}} hours"
	},
	xDays: {
		one: "1 day",
		other: "{{count}} days"
	},
	aboutXWeeks: {
		one: "about 1 week",
		other: "about {{count}} weeks"
	},
	xWeeks: {
		one: "1 week",
		other: "{{count}} weeks"
	},
	aboutXMonths: {
		one: "about 1 month",
		other: "about {{count}} months"
	},
	xMonths: {
		one: "1 month",
		other: "{{count}} months"
	},
	aboutXYears: {
		one: "about 1 year",
		other: "about {{count}} years"
	},
	xYears: {
		one: "1 year",
		other: "{{count}} years"
	},
	overXYears: {
		one: "over 1 year",
		other: "over {{count}} years"
	},
	almostXYears: {
		one: "almost 1 year",
		other: "almost {{count}} years"
	}
}, wf = (e, t, n) => {
	let r, i = Cf[e];
	return r = typeof i == "string" ? i : t === 1 ? i.one : i.other.replace("{{count}}", t.toString()), n?.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function Tf(e) {
	return (t = {}) => {
		let n = t.width ? String(t.width) : e.defaultWidth;
		return e.formats[n] || e.formats[e.defaultWidth];
	};
}
var Ef = {
	date: Tf({
		formats: {
			full: "EEEE, MMMM do, y",
			long: "MMMM do, y",
			medium: "MMM d, y",
			short: "MM/dd/yyyy"
		},
		defaultWidth: "full"
	}),
	time: Tf({
		formats: {
			full: "h:mm:ss a zzzz",
			long: "h:mm:ss a z",
			medium: "h:mm:ss a",
			short: "h:mm a"
		},
		defaultWidth: "full"
	}),
	dateTime: Tf({
		formats: {
			full: "{{date}} 'at' {{time}}",
			long: "{{date}} 'at' {{time}}",
			medium: "{{date}}, {{time}}",
			short: "{{date}}, {{time}}"
		},
		defaultWidth: "full"
	})
}, Df = {
	lastWeek: "'last' eeee 'at' p",
	yesterday: "'yesterday at' p",
	today: "'today at' p",
	tomorrow: "'tomorrow at' p",
	nextWeek: "eeee 'at' p",
	other: "P"
}, Of = (e, t, n, r) => Df[e];
function kf(e) {
	return (t, n) => {
		let r = n?.context ? String(n.context) : "standalone", i;
		if (r === "formatting" && e.formattingValues) {
			let t = e.defaultFormattingWidth || e.defaultWidth, r = n?.width ? String(n.width) : t;
			i = e.formattingValues[r] || e.formattingValues[t];
		} else {
			let t = e.defaultWidth, r = n?.width ? String(n.width) : e.defaultWidth;
			i = e.values[r] || e.values[t];
		}
		let a = e.argumentCallback ? e.argumentCallback(t) : t;
		return i[a];
	};
}
var Af = {
	ordinalNumber: (e, t) => {
		let n = Number(e), r = n % 100;
		if (r > 20 || r < 10) switch (r % 10) {
			case 1: return n + "st";
			case 2: return n + "nd";
			case 3: return n + "rd";
		}
		return n + "th";
	},
	era: kf({
		values: {
			narrow: ["B", "A"],
			abbreviated: ["BC", "AD"],
			wide: ["Before Christ", "Anno Domini"]
		},
		defaultWidth: "wide"
	}),
	quarter: kf({
		values: {
			narrow: [
				"1",
				"2",
				"3",
				"4"
			],
			abbreviated: [
				"Q1",
				"Q2",
				"Q3",
				"Q4"
			],
			wide: [
				"1st quarter",
				"2nd quarter",
				"3rd quarter",
				"4th quarter"
			]
		},
		defaultWidth: "wide",
		argumentCallback: (e) => e - 1
	}),
	month: kf({
		values: {
			narrow: [
				"J",
				"F",
				"M",
				"A",
				"M",
				"J",
				"J",
				"A",
				"S",
				"O",
				"N",
				"D"
			],
			abbreviated: [
				"Jan",
				"Feb",
				"Mar",
				"Apr",
				"May",
				"Jun",
				"Jul",
				"Aug",
				"Sep",
				"Oct",
				"Nov",
				"Dec"
			],
			wide: [
				"January",
				"February",
				"March",
				"April",
				"May",
				"June",
				"July",
				"August",
				"September",
				"October",
				"November",
				"December"
			]
		},
		defaultWidth: "wide"
	}),
	day: kf({
		values: {
			narrow: [
				"S",
				"M",
				"T",
				"W",
				"T",
				"F",
				"S"
			],
			short: [
				"Su",
				"Mo",
				"Tu",
				"We",
				"Th",
				"Fr",
				"Sa"
			],
			abbreviated: [
				"Sun",
				"Mon",
				"Tue",
				"Wed",
				"Thu",
				"Fri",
				"Sat"
			],
			wide: [
				"Sunday",
				"Monday",
				"Tuesday",
				"Wednesday",
				"Thursday",
				"Friday",
				"Saturday"
			]
		},
		defaultWidth: "wide"
	}),
	dayPeriod: kf({
		values: {
			narrow: {
				am: "a",
				pm: "p",
				midnight: "mi",
				noon: "n",
				morning: "morning",
				afternoon: "afternoon",
				evening: "evening",
				night: "night"
			},
			abbreviated: {
				am: "AM",
				pm: "PM",
				midnight: "midnight",
				noon: "noon",
				morning: "morning",
				afternoon: "afternoon",
				evening: "evening",
				night: "night"
			},
			wide: {
				am: "a.m.",
				pm: "p.m.",
				midnight: "midnight",
				noon: "noon",
				morning: "morning",
				afternoon: "afternoon",
				evening: "evening",
				night: "night"
			}
		},
		defaultWidth: "wide",
		formattingValues: {
			narrow: {
				am: "a",
				pm: "p",
				midnight: "mi",
				noon: "n",
				morning: "in the morning",
				afternoon: "in the afternoon",
				evening: "in the evening",
				night: "at night"
			},
			abbreviated: {
				am: "AM",
				pm: "PM",
				midnight: "midnight",
				noon: "noon",
				morning: "in the morning",
				afternoon: "in the afternoon",
				evening: "in the evening",
				night: "at night"
			},
			wide: {
				am: "a.m.",
				pm: "p.m.",
				midnight: "midnight",
				noon: "noon",
				morning: "in the morning",
				afternoon: "in the afternoon",
				evening: "in the evening",
				night: "at night"
			}
		},
		defaultFormattingWidth: "wide"
	})
};
function jf(e) {
	return (t, n = {}) => {
		let r = n.width, i = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], a = t.match(i);
		if (!a) return null;
		let o = a[0], s = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], c = Array.isArray(s) ? Nf(s, (e) => e.test(o)) : Mf(s, (e) => e.test(o)), l;
		l = e.valueCallback ? e.valueCallback(c) : c, l = n.valueCallback ? n.valueCallback(l) : l;
		let u = t.slice(o.length);
		return {
			value: l,
			rest: u
		};
	};
}
function Mf(e, t) {
	for (let n in e) if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n])) return n;
}
function Nf(e, t) {
	for (let n = 0; n < e.length; n++) if (t(e[n])) return n;
}
function Pf(e) {
	return (t, n = {}) => {
		let r = t.match(e.matchPattern);
		if (!r) return null;
		let i = r[0], a = t.match(e.parsePattern);
		if (!a) return null;
		let o = e.valueCallback ? e.valueCallback(a[0]) : a[0];
		o = n.valueCallback ? n.valueCallback(o) : o;
		let s = t.slice(i.length);
		return {
			value: o,
			rest: s
		};
	};
}
var Ff = {
	code: "en-US",
	formatDistance: wf,
	formatLong: Ef,
	formatRelative: Of,
	localize: Af,
	match: {
		ordinalNumber: Pf({
			matchPattern: /^(\d+)(th|st|nd|rd)?/i,
			parsePattern: /\d+/i,
			valueCallback: (e) => parseInt(e, 10)
		}),
		era: jf({
			matchPatterns: {
				narrow: /^(b|a)/i,
				abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
				wide: /^(before christ|before common era|anno domini|common era)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: { any: [/^b/i, /^(a|c)/i] },
			defaultParseWidth: "any"
		}),
		quarter: jf({
			matchPatterns: {
				narrow: /^[1234]/i,
				abbreviated: /^q[1234]/i,
				wide: /^[1234](th|st|nd|rd)? quarter/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: { any: [
				/1/i,
				/2/i,
				/3/i,
				/4/i
			] },
			defaultParseWidth: "any",
			valueCallback: (e) => e + 1
		}),
		month: jf({
			matchPatterns: {
				narrow: /^[jfmasond]/i,
				abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
				wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: {
				narrow: [
					/^j/i,
					/^f/i,
					/^m/i,
					/^a/i,
					/^m/i,
					/^j/i,
					/^j/i,
					/^a/i,
					/^s/i,
					/^o/i,
					/^n/i,
					/^d/i
				],
				any: [
					/^ja/i,
					/^f/i,
					/^mar/i,
					/^ap/i,
					/^may/i,
					/^jun/i,
					/^jul/i,
					/^au/i,
					/^s/i,
					/^o/i,
					/^n/i,
					/^d/i
				]
			},
			defaultParseWidth: "any"
		}),
		day: jf({
			matchPatterns: {
				narrow: /^[smtwf]/i,
				short: /^(su|mo|tu|we|th|fr|sa)/i,
				abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
				wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: {
				narrow: [
					/^s/i,
					/^m/i,
					/^t/i,
					/^w/i,
					/^t/i,
					/^f/i,
					/^s/i
				],
				any: [
					/^su/i,
					/^m/i,
					/^tu/i,
					/^w/i,
					/^th/i,
					/^f/i,
					/^sa/i
				]
			},
			defaultParseWidth: "any"
		}),
		dayPeriod: jf({
			matchPatterns: {
				narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
				any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
			},
			defaultMatchWidth: "any",
			parsePatterns: { any: {
				am: /^a/i,
				pm: /^p/i,
				midnight: /^mi/i,
				noon: /^no/i,
				morning: /morning/i,
				afternoon: /afternoon/i,
				evening: /evening/i,
				night: /night/i
			} },
			defaultParseWidth: "any"
		})
	},
	options: {
		weekStartsOn: 0,
		firstWeekContainsDate: 1
	}
};
function If(e, t) {
	let n = Q(e, t?.in);
	return af(n, xf(n)) + 1;
}
function Lf(e, t) {
	let n = Q(e, t?.in), r = $d(n) - +of(n);
	return Math.round(r / Bd) + 1;
}
function Rf(e, t) {
	let n = Q(e, t?.in), r = n.getFullYear(), i = Zd(), a = t?.firstWeekContainsDate ?? t?.locale?.options?.firstWeekContainsDate ?? i.firstWeekContainsDate ?? i.locale?.options?.firstWeekContainsDate ?? 1, o = Z(t?.in || e, 0);
	o.setFullYear(r + 1, 0, a), o.setHours(0, 0, 0, 0);
	let s = Qd(o, t), c = Z(t?.in || e, 0);
	c.setFullYear(r, 0, a), c.setHours(0, 0, 0, 0);
	let l = Qd(c, t);
	return +n >= +s ? r + 1 : +n >= +l ? r : r - 1;
}
function zf(e, t) {
	let n = Zd(), r = t?.firstWeekContainsDate ?? t?.locale?.options?.firstWeekContainsDate ?? n.firstWeekContainsDate ?? n.locale?.options?.firstWeekContainsDate ?? 1, i = Rf(e, t), a = Z(t?.in || e, 0);
	return a.setFullYear(i, 0, r), a.setHours(0, 0, 0, 0), Qd(a, t);
}
function Bf(e, t) {
	let n = Q(e, t?.in), r = Qd(n, t) - +zf(n, t);
	return Math.round(r / Bd) + 1;
}
function $(e, t) {
	return (e < 0 ? "-" : "") + Math.abs(e).toString().padStart(t, "0");
}
var Vf = {
	y(e, t) {
		let n = e.getFullYear(), r = n > 0 ? n : 1 - n;
		return $(t === "yy" ? r % 100 : r, t.length);
	},
	M(e, t) {
		let n = e.getMonth();
		return t === "M" ? String(n + 1) : $(n + 1, 2);
	},
	d(e, t) {
		return $(e.getDate(), t.length);
	},
	a(e, t) {
		let n = e.getHours() / 12 >= 1 ? "pm" : "am";
		switch (t) {
			case "a":
			case "aa": return n.toUpperCase();
			case "aaa": return n;
			case "aaaaa": return n[0];
			default: return n === "am" ? "a.m." : "p.m.";
		}
	},
	h(e, t) {
		return $(e.getHours() % 12 || 12, t.length);
	},
	H(e, t) {
		return $(e.getHours(), t.length);
	},
	m(e, t) {
		return $(e.getMinutes(), t.length);
	},
	s(e, t) {
		return $(e.getSeconds(), t.length);
	},
	S(e, t) {
		let n = t.length, r = e.getMilliseconds();
		return $(Math.trunc(r * 10 ** (n - 3)), t.length);
	}
}, Hf = {
	am: "am",
	pm: "pm",
	midnight: "midnight",
	noon: "noon",
	morning: "morning",
	afternoon: "afternoon",
	evening: "evening",
	night: "night"
}, Uf = {
	G: function(e, t, n) {
		let r = +(e.getFullYear() > 0);
		switch (t) {
			case "G":
			case "GG":
			case "GGG": return n.era(r, { width: "abbreviated" });
			case "GGGGG": return n.era(r, { width: "narrow" });
			default: return n.era(r, { width: "wide" });
		}
	},
	y: function(e, t, n) {
		if (t === "yo") {
			let t = e.getFullYear(), r = t > 0 ? t : 1 - t;
			return n.ordinalNumber(r, { unit: "year" });
		}
		return Vf.y(e, t);
	},
	Y: function(e, t, n, r) {
		let i = Rf(e, r), a = i > 0 ? i : 1 - i;
		return t === "YY" ? $(a % 100, 2) : t === "Yo" ? n.ordinalNumber(a, { unit: "year" }) : $(a, t.length);
	},
	R: function(e, t) {
		return $(ef(e), t.length);
	},
	u: function(e, t) {
		return $(e.getFullYear(), t.length);
	},
	Q: function(e, t, n) {
		let r = Math.ceil((e.getMonth() + 1) / 3);
		switch (t) {
			case "Q": return String(r);
			case "QQ": return $(r, 2);
			case "Qo": return n.ordinalNumber(r, { unit: "quarter" });
			case "QQQ": return n.quarter(r, {
				width: "abbreviated",
				context: "formatting"
			});
			case "QQQQQ": return n.quarter(r, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.quarter(r, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	q: function(e, t, n) {
		let r = Math.ceil((e.getMonth() + 1) / 3);
		switch (t) {
			case "q": return String(r);
			case "qq": return $(r, 2);
			case "qo": return n.ordinalNumber(r, { unit: "quarter" });
			case "qqq": return n.quarter(r, {
				width: "abbreviated",
				context: "standalone"
			});
			case "qqqqq": return n.quarter(r, {
				width: "narrow",
				context: "standalone"
			});
			default: return n.quarter(r, {
				width: "wide",
				context: "standalone"
			});
		}
	},
	M: function(e, t, n) {
		let r = e.getMonth();
		switch (t) {
			case "M":
			case "MM": return Vf.M(e, t);
			case "Mo": return n.ordinalNumber(r + 1, { unit: "month" });
			case "MMM": return n.month(r, {
				width: "abbreviated",
				context: "formatting"
			});
			case "MMMMM": return n.month(r, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.month(r, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	L: function(e, t, n) {
		let r = e.getMonth();
		switch (t) {
			case "L": return String(r + 1);
			case "LL": return $(r + 1, 2);
			case "Lo": return n.ordinalNumber(r + 1, { unit: "month" });
			case "LLL": return n.month(r, {
				width: "abbreviated",
				context: "standalone"
			});
			case "LLLLL": return n.month(r, {
				width: "narrow",
				context: "standalone"
			});
			default: return n.month(r, {
				width: "wide",
				context: "standalone"
			});
		}
	},
	w: function(e, t, n, r) {
		let i = Bf(e, r);
		return t === "wo" ? n.ordinalNumber(i, { unit: "week" }) : $(i, t.length);
	},
	I: function(e, t, n) {
		let r = Lf(e);
		return t === "Io" ? n.ordinalNumber(r, { unit: "week" }) : $(r, t.length);
	},
	d: function(e, t, n) {
		return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : Vf.d(e, t);
	},
	D: function(e, t, n) {
		let r = If(e);
		return t === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : $(r, t.length);
	},
	E: function(e, t, n) {
		let r = e.getDay();
		switch (t) {
			case "E":
			case "EE":
			case "EEE": return n.day(r, {
				width: "abbreviated",
				context: "formatting"
			});
			case "EEEEE": return n.day(r, {
				width: "narrow",
				context: "formatting"
			});
			case "EEEEEE": return n.day(r, {
				width: "short",
				context: "formatting"
			});
			default: return n.day(r, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	e: function(e, t, n, r) {
		let i = e.getDay(), a = (i - r.weekStartsOn + 8) % 7 || 7;
		switch (t) {
			case "e": return String(a);
			case "ee": return $(a, 2);
			case "eo": return n.ordinalNumber(a, { unit: "day" });
			case "eee": return n.day(i, {
				width: "abbreviated",
				context: "formatting"
			});
			case "eeeee": return n.day(i, {
				width: "narrow",
				context: "formatting"
			});
			case "eeeeee": return n.day(i, {
				width: "short",
				context: "formatting"
			});
			default: return n.day(i, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	c: function(e, t, n, r) {
		let i = e.getDay(), a = (i - r.weekStartsOn + 8) % 7 || 7;
		switch (t) {
			case "c": return String(a);
			case "cc": return $(a, t.length);
			case "co": return n.ordinalNumber(a, { unit: "day" });
			case "ccc": return n.day(i, {
				width: "abbreviated",
				context: "standalone"
			});
			case "ccccc": return n.day(i, {
				width: "narrow",
				context: "standalone"
			});
			case "cccccc": return n.day(i, {
				width: "short",
				context: "standalone"
			});
			default: return n.day(i, {
				width: "wide",
				context: "standalone"
			});
		}
	},
	i: function(e, t, n) {
		let r = e.getDay(), i = r === 0 ? 7 : r;
		switch (t) {
			case "i": return String(i);
			case "ii": return $(i, t.length);
			case "io": return n.ordinalNumber(i, { unit: "day" });
			case "iii": return n.day(r, {
				width: "abbreviated",
				context: "formatting"
			});
			case "iiiii": return n.day(r, {
				width: "narrow",
				context: "formatting"
			});
			case "iiiiii": return n.day(r, {
				width: "short",
				context: "formatting"
			});
			default: return n.day(r, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	a: function(e, t, n) {
		let r = e.getHours() / 12 >= 1 ? "pm" : "am";
		switch (t) {
			case "a":
			case "aa": return n.dayPeriod(r, {
				width: "abbreviated",
				context: "formatting"
			});
			case "aaa": return n.dayPeriod(r, {
				width: "abbreviated",
				context: "formatting"
			}).toLowerCase();
			case "aaaaa": return n.dayPeriod(r, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.dayPeriod(r, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	b: function(e, t, n) {
		let r = e.getHours(), i;
		switch (i = r === 12 ? Hf.noon : r === 0 ? Hf.midnight : r / 12 >= 1 ? "pm" : "am", t) {
			case "b":
			case "bb": return n.dayPeriod(i, {
				width: "abbreviated",
				context: "formatting"
			});
			case "bbb": return n.dayPeriod(i, {
				width: "abbreviated",
				context: "formatting"
			}).toLowerCase();
			case "bbbbb": return n.dayPeriod(i, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.dayPeriod(i, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	B: function(e, t, n) {
		let r = e.getHours(), i;
		switch (i = r >= 17 ? Hf.evening : r >= 12 ? Hf.afternoon : r >= 4 ? Hf.morning : Hf.night, t) {
			case "B":
			case "BB":
			case "BBB": return n.dayPeriod(i, {
				width: "abbreviated",
				context: "formatting"
			});
			case "BBBBB": return n.dayPeriod(i, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.dayPeriod(i, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	h: function(e, t, n) {
		if (t === "ho") {
			let t = e.getHours() % 12;
			return t === 0 && (t = 12), n.ordinalNumber(t, { unit: "hour" });
		}
		return Vf.h(e, t);
	},
	H: function(e, t, n) {
		return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : Vf.H(e, t);
	},
	K: function(e, t, n) {
		let r = e.getHours() % 12;
		return t === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : $(r, t.length);
	},
	k: function(e, t, n) {
		let r = e.getHours();
		return r === 0 && (r = 24), t === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : $(r, t.length);
	},
	m: function(e, t, n) {
		return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : Vf.m(e, t);
	},
	s: function(e, t, n) {
		return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : Vf.s(e, t);
	},
	S: function(e, t) {
		return Vf.S(e, t);
	},
	X: function(e, t, n) {
		let r = e.getTimezoneOffset();
		if (r === 0) return "Z";
		switch (t) {
			case "X": return Gf(r);
			case "XXXX":
			case "XX": return Kf(r);
			default: return Kf(r, ":");
		}
	},
	x: function(e, t, n) {
		let r = e.getTimezoneOffset();
		switch (t) {
			case "x": return Gf(r);
			case "xxxx":
			case "xx": return Kf(r);
			default: return Kf(r, ":");
		}
	},
	O: function(e, t, n) {
		let r = e.getTimezoneOffset();
		switch (t) {
			case "O":
			case "OO":
			case "OOO": return "GMT" + Wf(r, ":");
			default: return "GMT" + Kf(r, ":");
		}
	},
	z: function(e, t, n) {
		let r = e.getTimezoneOffset();
		switch (t) {
			case "z":
			case "zz":
			case "zzz": return "GMT" + Wf(r, ":");
			default: return "GMT" + Kf(r, ":");
		}
	},
	t: function(e, t, n) {
		return $(Math.trunc(e / 1e3), t.length);
	},
	T: function(e, t, n) {
		return $(+e, t.length);
	}
};
function Wf(e, t = "") {
	let n = e > 0 ? "-" : "+", r = Math.abs(e), i = Math.trunc(r / 60), a = r % 60;
	return a === 0 ? n + String(i) : n + String(i) + t + $(a, 2);
}
function Gf(e, t) {
	return e % 60 == 0 ? (e > 0 ? "-" : "+") + $(Math.abs(e) / 60, 2) : Kf(e, t);
}
function Kf(e, t = "") {
	let n = e > 0 ? "-" : "+", r = Math.abs(e), i = $(Math.trunc(r / 60), 2), a = $(r % 60, 2);
	return n + i + t + a;
}
var qf = (e, t) => {
	switch (e) {
		case "P": return t.date({ width: "short" });
		case "PP": return t.date({ width: "medium" });
		case "PPP": return t.date({ width: "long" });
		default: return t.date({ width: "full" });
	}
}, Jf = (e, t) => {
	switch (e) {
		case "p": return t.time({ width: "short" });
		case "pp": return t.time({ width: "medium" });
		case "ppp": return t.time({ width: "long" });
		default: return t.time({ width: "full" });
	}
}, Yf = {
	p: Jf,
	P: (e, t) => {
		let n = e.match(/(P+)(p+)?/) || [], r = n[1], i = n[2];
		if (!i) return qf(e, t);
		let a;
		switch (r) {
			case "P":
				a = t.dateTime({ width: "short" });
				break;
			case "PP":
				a = t.dateTime({ width: "medium" });
				break;
			case "PPP":
				a = t.dateTime({ width: "long" });
				break;
			default:
				a = t.dateTime({ width: "full" });
				break;
		}
		return a.replace("{{date}}", qf(r, t)).replace("{{time}}", Jf(i, t));
	}
}, Xf = /^D+$/, Zf = /^Y+$/, Qf = [
	"D",
	"DD",
	"YY",
	"YYYY"
];
function $f(e) {
	return Xf.test(e);
}
function ep(e) {
	return Zf.test(e);
}
function tp(e, t, n) {
	let r = np(e, t, n);
	if (console.warn(r), Qf.includes(e)) throw RangeError(r);
}
function np(e, t, n) {
	let r = e[0] === "Y" ? "years" : "days of the month";
	return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
var rp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, ip = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, ap = /^'([^]*?)'?$/, op = /''/g, sp = /[a-zA-Z]/;
function cp(e, t, n) {
	let r = Zd(), i = n?.locale ?? r.locale ?? Ff, a = n?.firstWeekContainsDate ?? n?.locale?.options?.firstWeekContainsDate ?? r.firstWeekContainsDate ?? r.locale?.options?.firstWeekContainsDate ?? 1, o = n?.weekStartsOn ?? n?.locale?.options?.weekStartsOn ?? r.weekStartsOn ?? r.locale?.options?.weekStartsOn ?? 0, s = Q(e, n?.in);
	if (!pf(s)) throw RangeError("Invalid time value");
	let c = t.match(ip).map((e) => {
		let t = e[0];
		if (t === "p" || t === "P") {
			let n = Yf[t];
			return n(e, i.formatLong);
		}
		return e;
	}).join("").match(rp).map((e) => {
		if (e === "''") return {
			isToken: !1,
			value: "'"
		};
		let t = e[0];
		if (t === "'") return {
			isToken: !1,
			value: lp(e)
		};
		if (Uf[t]) return {
			isToken: !0,
			value: e
		};
		if (t.match(sp)) throw RangeError("Format string contains an unescaped latin alphabet character `" + t + "`");
		return {
			isToken: !1,
			value: e
		};
	});
	i.localize.preprocessor && (c = i.localize.preprocessor(s, c));
	let l = {
		firstWeekContainsDate: a,
		weekStartsOn: o,
		locale: i
	};
	return c.map((r) => {
		if (!r.isToken) return r.value;
		let a = r.value;
		(!n?.useAdditionalWeekYearTokens && ep(a) || !n?.useAdditionalDayOfYearTokens && $f(a)) && tp(a, t, String(e));
		let o = Uf[a[0]];
		return o(s, a, i.localize, l);
	}).join("");
}
function lp(e) {
	let t = e.match(ap);
	return t ? t[1].replace(op, "'") : e;
}
function up(e, t) {
	return Q(e, t?.in).getDate();
}
function dp(e, t) {
	return Q(e, t?.in).getDay();
}
function fp(e, t) {
	let n = Q(e, t?.in), r = n.getFullYear(), i = n.getMonth(), a = Z(n, 0);
	return a.setFullYear(r, i + 1, 0), a.setHours(0, 0, 0, 0), a.getDate();
}
function pp(e, t) {
	return Q(e, t?.in).getHours();
}
function mp(e, t) {
	return Q(e, t?.in).getMinutes();
}
function hp(e, t) {
	return Q(e, t?.in).getMonth();
}
function gp(e, t) {
	return Q(e, t?.in).getFullYear();
}
function _p(e, t) {
	return +Q(e) > +Q(t);
}
function vp(e, t) {
	return +Q(e) < +Q(t);
}
function yp(e, t) {
	return +Q(e) == +Q(t);
}
function bp(e, t, n) {
	let [r, i] = nf(n?.in, e, t);
	return r.getFullYear() === i.getFullYear() && r.getMonth() === i.getMonth();
}
function xp(e, t) {
	return df(Z(t?.in || e, e), uf(t?.in || e));
}
function Sp(e, t, n) {
	return Kd(e, -t, n);
}
function Cp(e, t, n) {
	let r = Q(e, n?.in), i = r.getFullYear(), a = r.getDate(), o = Z(n?.in || e, 0);
	o.setFullYear(i, t, 15), o.setHours(0, 0, 0, 0);
	let s = fp(o);
	return r.setMonth(t, Math.min(a, s)), r;
}
function wp(e, t, n) {
	let r = Q(e, n?.in);
	return isNaN(+r) ? Z(n?.in || e, NaN) : (t.year != null && r.setFullYear(t.year), t.month != null && (r = Cp(r, t.month)), t.date != null && r.setDate(t.date), t.hours != null && r.setHours(t.hours), t.minutes != null && r.setMinutes(t.minutes), t.seconds != null && r.setSeconds(t.seconds), t.milliseconds != null && r.setMilliseconds(t.milliseconds), r);
}
function Tp(e, t, n) {
	let r = Q(e, n?.in);
	return isNaN(+r) ? Z(n?.in || e, NaN) : (r.setFullYear(t), r);
}
function Ep(e) {
	return rf(Date.now(), e);
}
function Dp(e, t, n) {
	return qd(e, -t, n);
}
function Op(e, t, n) {
	return Yd(e, -t, n);
}
function kp(e, t, n) {
	return sf(e, -t, n);
}
function Ap(e, t, n) {
	return lf(e, -t, n);
}
var jp = {
	JANUARY: 0,
	FEBRUARY: 1,
	MARCH: 2,
	APRIL: 3,
	MAY: 4,
	JUNE: 5,
	JULY: 6,
	AUGUST: 7,
	SEPTEMBER: 8,
	OCTOBER: 9,
	NOVEMBER: 10,
	DECEMBER: 11
}, Mp = {
	SUNDAY: 0,
	MONDAY: 1,
	TUESDAY: 2,
	WEDNESDAY: 3,
	THURSDAY: 4,
	FRIDAY: 5,
	SATURDAY: 6
}, Np = (e, t, n) => (yp(e, t) || _p(e, t)) && (yp(e, n) || vp(e, n)), Pp = (e) => wp(e, {
	hours: 0,
	minutes: 0,
	seconds: 0,
	milliseconds: 0
}), Fp = ({ weekStartsOn: e = Mp.SUNDAY, viewing: t = /* @__PURE__ */ new Date(), selected: n = [], numberOfMonths: r = 1 } = {}) => {
	let [i, a] = k(t), o = D(() => a(Ep()), []), s = D((e) => a((t) => Cp(t, e)), []), c = D(() => a((e) => Dp(e, 1)), []), l = D(() => a((e) => qd(e, 1)), []), u = D((e) => a((t) => Tp(t, e)), []), d = D(() => a((e) => Ap(e, 1)), []), f = D(() => a((e) => lf(e, 1)), []), [p, m] = k(n.map(Pp)), h = D(() => m([]), []), g = D((e) => p.findIndex((t) => yp(t, e)) > -1, [p]), _ = D((e, t) => {
		m(t ? Array.isArray(e) ? e : [e] : (t) => t.concat(Array.isArray(e) ? e : [e]));
	}, []), v = D((e) => m((t) => Array.isArray(e) ? t.filter((t) => !e.map((e) => e.getTime()).includes(t.getTime())) : t.filter((t) => !yp(t, e))), []);
	return {
		clearTime: Pp,
		inRange: Np,
		viewing: i,
		setViewing: a,
		viewToday: o,
		viewMonth: s,
		viewPreviousMonth: c,
		viewNextMonth: l,
		viewYear: u,
		viewPreviousYear: d,
		viewNextYear: f,
		selected: p,
		setSelected: m,
		clearSelected: h,
		isSelected: g,
		select: _,
		deselect: v,
		toggle: D((e, t) => g(e) ? v(e) : _(e, t), [
			v,
			g,
			_
		]),
		selectRange: D((e, t, n) => {
			m(n ? _f({
				start: e,
				end: t
			}) : (n) => n.concat(_f({
				start: e,
				end: t
			})));
		}, []),
		deselectRange: D((e, t) => {
			m((n) => n.filter((n) => !_f({
				start: e,
				end: t
			}).map((e) => e.getTime()).includes(n.getTime())));
		}, []),
		calendar: O(() => vf({
			start: bf(i),
			end: hf(qd(i, r - 1))
		}).map((t) => yf({
			start: bf(t),
			end: hf(t)
		}, { weekStartsOn: e }).map((t) => _f({
			start: Qd(t, { weekStartsOn: e }),
			end: Sf(t, { weekStartsOn: e })
		}))), [
			i,
			e,
			r
		])
	};
}, Ip = new Date(2020, 0, 23), Lp = [
	"Su",
	"Mo",
	"Tu",
	"We",
	"Th",
	"Fr",
	"Sa"
], Rp = [
	"January",
	"February",
	"March",
	"April",
	"May",
	"June",
	"July",
	"August",
	"September",
	"October",
	"November",
	"December"
];
function zp(e) {
	return new Date(e.getFullYear(), e.getMonth(), e.getDate());
}
function Bp({ day: e, startDate: t, endDate: n, viewing: r, minDate: i, maxDate: a, onClick: o }) {
	let s = !bp(e, r), c = zp(e), l = c.getTime() > zp(a).getTime(), u = i ? c.getTime() < zp(i).getTime() : !1, d = s || l || u, f = !d && df(t, e), p = !d && df(n, e), m = df(t, n), h = !d && !f && !p && _p(e, t) && !_p(e, n), g = xp(e), _ = cp(e, "dd");
	return /* @__PURE__ */ N("div", {
		"data-is-between": h,
		"data-is-start": f,
		"data-is-end": p,
		"data-is-today": g,
		"data-is-same-day": m,
		className: q("w-8 h-8 flex items-center justify-center", h && "bg-fill-selected", f && !m && "bg-fill-selected rounded-l-full", p && !m && "bg-fill-selected rounded-r-full"),
		children: /* @__PURE__ */ N(J, {
			variant: f || p ? "primary" : "default",
			size: "icon-sm",
			disabled: d,
			"aria-label": `Select ${cp(e, "PP")}`,
			title: d ? void 0 : `Select ${cp(e, "PP")}`,
			onClick: () => o(e),
			className: q("w-full h-full !rounded-full p-0 text-[11px] tabular-nums", g && !f && !p && "border border-primary", d && "opacity-20"),
			children: _
		})
	});
}
function Vp({ defaultViewing: e, startDate: t, endDate: n, minDate: r, maxDate: i, onSelect: a, onViewChange: o, siblingViewing: s, weekStartsOn: c }) {
	let { calendar: l, viewing: u, setViewing: d, viewPreviousMonth: f, viewNextMonth: p } = Fp({
		viewing: e,
		weekStartsOn: c
	}), m = w.useRef(e);
	w.useEffect(() => {
		bp(m.current, e) || (d(e), m.current = e);
	}, [e, d]);
	let h = () => {
		f(), o(Dp(u, 1));
	}, g = () => {
		p(), o(qd(u, 1));
	}, _ = r && r.getTime() > Ip.getTime() ? r : Ip, v = gp(_), y = hp(_), b = v * 12 + y, x = gp(i) * 12 + hp(i), S = gp(u) * 12 + hp(u), C = S >= x || !!s && hp(s) === hp(qd(u, 1)) && gp(s) === gp(qd(u, 1)), T = S <= b || !!s && hp(s) === hp(Dp(u, 1)) && gp(s) === gp(Dp(u, 1)), E = gp(i), D = hp(i), O = gp(u), k = hp(u), A = (e, t) => e * 12 + t, j = A(O, k), M = s ? A(gp(s), hp(s)) : null, F = [];
	for (let e = v; e <= E; e++) {
		let t = e === v ? y : 0, n = e === E ? D : 11;
		for (let r = t; r <= n; r++) F.push({
			key: A(e, r),
			year: e,
			month: r
		});
	}
	let I = (e) => {
		let t = Math.floor(e / 12), n = e % 12, r = new Date(t, n, 1);
		d(r), o(r);
	};
	return /* @__PURE__ */ P("div", { children: [
		/* @__PURE__ */ P("div", {
			className: "flex justify-center items-center py-1 gap-1",
			children: [
				/* @__PURE__ */ N(J, {
					variant: "default",
					size: "icon-sm",
					onClick: h,
					disabled: T,
					"aria-label": "Previous month",
					title: T ? "Disabled" : "Previous month",
					className: "disabled:cursor-not-allowed",
					children: /* @__PURE__ */ N(Ad, {})
				}),
				/* @__PURE__ */ P(Gc, {
					value: j,
					onValueChange: (e) => {
						e !== null && I(e);
					},
					children: [/* @__PURE__ */ N(Yc, {
						size: "sm",
						"aria-label": "Month and year",
						className: "h-6 px-2 text-xs",
						children: /* @__PURE__ */ N(qc, { children: (e) => `${Rp[e % 12]} ${Math.floor(e / 12)}` })
					}), /* @__PURE__ */ N(Xc, { children: /* @__PURE__ */ N(Kc, { children: F.map(({ key: e, year: t, month: n }) => /* @__PURE__ */ P(Qc, {
						value: e,
						disabled: e === M,
						children: [
							Rp[n],
							" ",
							t
						]
					}, e)) }) })]
				}),
				/* @__PURE__ */ N(J, {
					variant: "default",
					size: "icon-sm",
					onClick: g,
					disabled: C,
					"aria-label": "Next month",
					title: C ? "Disabled" : "Next month",
					className: "disabled:cursor-not-allowed",
					children: /* @__PURE__ */ N(jd, {})
				})
			]
		}),
		/* @__PURE__ */ N("div", {
			className: "grid grid-cols-7",
			children: l[0][0].map((e) => /* @__PURE__ */ N("div", {
				className: "w-8 h-6 flex items-center justify-center text-[10px] text-muted-foreground uppercase",
				children: Lp[dp(e)]
			}, `h-${dp(e)}`))
		}),
		/* @__PURE__ */ N("div", {
			className: "flex flex-col",
			children: l[0].map((e, o) => /* @__PURE__ */ N("div", {
				className: "grid grid-cols-7",
				children: e.map((e) => /* @__PURE__ */ N(Bp, {
					day: e,
					startDate: t,
					endDate: n,
					viewing: u,
					minDate: r,
					maxDate: i,
					onClick: a
				}, e.toISOString()))
			}, `w-${o}`))
		})
	] });
}
var Hp = {
	id: 0,
	name: "Custom",
	rangeSetter: (e) => e
}, Up = [
	Hp,
	{
		id: 1,
		name: "Last 5 minutes",
		rangeSetter: (e) => kp(e, 5)
	},
	{
		id: 2,
		name: "Last 15 minutes",
		rangeSetter: (e) => kp(e, 15)
	},
	{
		id: 3,
		name: "Last 30 minutes",
		rangeSetter: (e) => kp(e, 30)
	},
	{
		id: 4,
		name: "Last 1 hour",
		rangeSetter: (e) => Op(e, 1)
	},
	{
		id: 5,
		name: "Last 3 hours",
		rangeSetter: (e) => Op(e, 3)
	},
	{
		id: 6,
		name: "Last 6 hours",
		rangeSetter: (e) => Op(e, 6)
	},
	{
		id: 7,
		name: "Last 12 hours",
		rangeSetter: (e) => Op(e, 12)
	},
	{
		id: 8,
		name: "Last 24 hours",
		rangeSetter: (e) => Sp(e, 1)
	},
	{
		id: 9,
		name: "Last 2 days",
		rangeSetter: (e) => Sp(e, 2)
	},
	{
		id: 10,
		name: "Last 7 days",
		rangeSetter: (e) => Sp(e, 7)
	},
	{
		id: 11,
		name: "Last 30 days",
		rangeSetter: (e) => Sp(e, 30)
	},
	{
		id: 12,
		name: "Last 90 days",
		rangeSetter: (e) => Sp(e, 90)
	},
	{
		id: 13,
		name: "Last 6 months",
		rangeSetter: (e) => Dp(e, 6)
	},
	{
		id: 14,
		name: "Last 1 year",
		rangeSetter: (e) => Ap(e, 1)
	},
	{
		id: 15,
		name: "Last 2 years",
		rangeSetter: (e) => Ap(e, 2)
	}
], Wp = {
	MDY: "MM/DD/YY",
	DMY: "DD/MM/YY",
	YMD: "YY-MM-DD"
}, Gp = { minimumIntegerDigits: 2 };
function Kp({ date: e, maxDate: t, onChange: n, dateFormat: r, showTime: i }) {
	let [a, o] = w.useState(hp(e) + 1), [s, c] = w.useState(up(e)), [l, u] = w.useState(gp(e) % 100), [d, f] = w.useState(pp(e)), [p, m] = w.useState(mp(e)), h = w.useRef(n);
	w.useEffect(() => {
		h.current = n;
	}, [n]), w.useEffect(() => {
		o(hp(e) + 1), c(up(e)), u(gp(e) % 100), f(pp(e)), m(mp(e));
	}, [e]);
	let g = w.useRef(!1);
	w.useEffect(() => {
		if (!g.current) return;
		let e = setTimeout(() => {
			h.current(new Date(2e3 + l, a - 1, s, d, p)), g.current = !1;
		}, 400);
		return () => clearTimeout(e);
	}, [
		a,
		s,
		l,
		d,
		p
	]);
	let _ = (e) => (t) => {
		t !== null && (g.current = !0, e(t));
	}, v = "w-7 flex-none text-center tabular-nums p-0", y = "text-xs text-muted-foreground select-none", b = r === "YMD" ? "-" : "/", x = gp(t) % 100, S = l === x, C = S ? hp(t) + 1 : 12, T = S && a === C ? up(t) : fp(new Date(2e3 + l, a - 1)), E = /* @__PURE__ */ N(Xe, {
		"aria-label": "Month",
		value: a,
		onValueChange: _(o),
		min: 1,
		max: C,
		format: Gp,
		className: v
	}, "month"), D = /* @__PURE__ */ N(Xe, {
		"aria-label": "Day",
		value: s,
		onValueChange: _(c),
		min: 1,
		max: T,
		format: Gp,
		className: v
	}, "day"), O = /* @__PURE__ */ N(Xe, {
		"aria-label": "Year",
		value: l,
		onValueChange: _(u),
		min: 0,
		max: x,
		format: Gp,
		className: v
	}, "year");
	return /* @__PURE__ */ N(jr, { children: /* @__PURE__ */ P("div", {
		className: "flex items-center gap-2",
		children: [/* @__PURE__ */ P(Mr, { children: [/* @__PURE__ */ N(Nr, { render: /* @__PURE__ */ N(He, {
			className: "w-auto px-1.5",
			children: (r === "DMY" ? [
				D,
				E,
				O
			] : r === "YMD" ? [
				O,
				E,
				D
			] : [
				E,
				D,
				O
			]).map((e, t) => /* @__PURE__ */ P(w.Fragment, { children: [t > 0 && /* @__PURE__ */ N("span", {
				className: y,
				children: b
			}), e] }, t))
		}) }), /* @__PURE__ */ N(Pr, { children: Wp[r] })] }), i && /* @__PURE__ */ P(He, {
			className: "w-auto px-1.5",
			children: [
				/* @__PURE__ */ N(Xe, {
					"aria-label": "Hour",
					value: d,
					onValueChange: _(f),
					min: 0,
					max: 23,
					format: Gp,
					className: v
				}),
				/* @__PURE__ */ N("span", {
					className: y,
					children: ":"
				}),
				/* @__PURE__ */ N(Xe, {
					"aria-label": "Minute",
					value: p,
					onValueChange: _(m),
					min: 0,
					max: 59,
					format: Gp,
					className: v
				})
			]
		})]
	}) });
}
var qp = {
	MDY: "MM/dd/yy HH:mm:ss",
	DMY: "dd/MM/yy HH:mm:ss",
	YMD: "yy-MM-dd HH:mm:ss"
}, Jp = {
	MDY: "MM/dd/yy",
	DMY: "dd/MM/yy",
	YMD: "yy-MM-dd"
}, Yp = "(min-width: 64rem)";
function Xp(e) {
	let [t, n] = w.useState(!1);
	return w.useEffect(() => {
		let t = window.matchMedia(e), r = () => n(t.matches);
		return r(), t.addEventListener("change", r), () => t.removeEventListener("change", r);
	}, [e]), t;
}
function Zp({ value: e, onApply: t, onCancel: n, minDate: r, maxDate: i, dateFormat: a = "MDY", weekStartsOn: o, onDateTimeSettings: s, compact: c = !1, ranges: l = Up, showHeader: u = !0, showTime: d = !0, className: f }) {
	let p = l.filter((e) => e.id !== Hp.id), m = p.length > 0, h = i ?? /* @__PURE__ */ new Date(), g = i !== void 0, _ = Xp(Yp), v = !c && _, [y, b] = w.useState(e.start), [x, S] = w.useState(e.end), [C, T] = w.useState(e.range), [E, D] = w.useState(null), [O, k] = w.useState(e.end), [A, j] = w.useState(Dp(e.end, 1)), F = (e) => {
		let t = rf(e), n = mf(e);
		t.getTime() < y.getTime() ? (b(t), D("start")) : n.getTime() > x.getTime() || E === "start" ? (S(n), D("end")) : E === "end" ? (b(t), D("start")) : (b(t), S(n)), T(Hp);
	}, I = (e) => {
		let t = new Date(gp(e), hp(e), 1);
		v ? j(t) : k(t);
	}, ee = (e) => {
		k(new Date(gp(e), hp(e), 1));
	}, L = (e) => {
		y.getTime() !== e.getTime() && (T(Hp), D("start"), e.getTime() > x.getTime() ? (b(x), S(e), ee(e)) : (b(e), I(e)));
	}, R = (e) => {
		x.getTime() !== e.getTime() && (T(Hp), D("end"), e.getTime() < y.getTime() ? (S(y), b(e), I(e)) : (S(e), ee(e)));
	}, te = () => {
		let e = /* @__PURE__ */ new Date();
		y.getTime() > e.getTime() && b(e), S(e), D("end"), ee(e);
	}, z = (e) => {
		let t = /* @__PURE__ */ new Date(), n = e.rangeSetter(t), r = e.endSetter?.(t) ?? t;
		b(n), S(r), T(e), D(null), k(r), j(Dp(r, 1));
	}, B = d ? qp[a] : Jp[a], ne = cp(y, B), re = cp(x, B);
	return /* @__PURE__ */ P("div", {
		className: q("bg-card text-foreground rounded-lg shadow-md ring-1 ring-foreground/10 overflow-hidden", c ? "w-[15rem]" : "w-[15rem] lg:w-full max-w-[42rem]", f),
		children: [
			!c && u && /* @__PURE__ */ P("div", {
				className: m ? "hidden lg:grid lg:grid-cols-[minmax(0,1fr)_9rem]" : "hidden lg:grid",
				children: [/* @__PURE__ */ P("div", {
					className: "flex items-center gap-2 px-2 py-1 bg-muted/30 border-b border-border rounded-tl-lg",
					children: [/* @__PURE__ */ N("span", {
						className: "text-[10px] text-muted-foreground uppercase tracking-wide",
						children: "Choose date range"
					}), (r || g) && /* @__PURE__ */ P("div", {
						className: "flex items-center gap-1 ml-auto",
						children: [
							r && /* @__PURE__ */ P(Ct, {
								variant: "default",
								className: "text-[10px] px-1.5 py-0",
								children: ["Min: ", cp(r, "MMM d, yy")]
							}),
							r && g && /* @__PURE__ */ N("span", {
								className: "text-[10px] text-muted-foreground",
								children: /* @__PURE__ */ N(Od, { className: "size-3" })
							}),
							g && /* @__PURE__ */ P(Ct, {
								variant: "default",
								className: "text-[10px] px-1.5 py-0",
								children: ["Max: ", cp(h, "MMM d, yy")]
							})
						]
					})]
				}), m && /* @__PURE__ */ N("div", {
					className: "flex justify-start px-2 py-1 bg-muted/30 border-b border-l border-border rounded-tr-lg",
					children: /* @__PURE__ */ N("span", {
						className: "text-[10px] text-muted-foreground uppercase tracking-wide",
						children: "Quick ranges"
					})
				})]
			}),
			/* @__PURE__ */ P("div", {
				className: c || !m ? "flex flex-col" : "flex flex-col lg:grid lg:grid-cols-[minmax(0,1fr)_9rem]",
				children: [/* @__PURE__ */ P("div", {
					className: c ? "order-1" : "order-1 lg:order-none",
					children: [!c && /* @__PURE__ */ N("div", {
						className: "hidden lg:flex justify-center items-center px-3 pt-3 pb-1",
						children: /* @__PURE__ */ P("div", {
							className: "flex items-center gap-1.5",
							children: [
								s && /* @__PURE__ */ N(J, {
									size: "icon-xs",
									onClick: s,
									"aria-label": "Date and time settings",
									title: "Date and time settings",
									className: "text-muted-foreground hover:text-foreground",
									children: /* @__PURE__ */ N(Pd, {})
								}),
								/* @__PURE__ */ N(Kp, {
									date: y,
									maxDate: h,
									onChange: L,
									dateFormat: a,
									showTime: d
								}),
								/* @__PURE__ */ N("span", {
									className: "text-xs text-muted-foreground",
									children: "to"
								}),
								/* @__PURE__ */ N(Kp, {
									date: x,
									maxDate: h,
									onChange: R,
									dateFormat: a,
									showTime: d
								}),
								d && /* @__PURE__ */ N(J, {
									variant: "link",
									size: "xs",
									onClick: te,
									"aria-label": "Set end to now",
									title: "Set end to now",
									children: "Now"
								})
							]
						})
					}), /* @__PURE__ */ P("div", {
						className: c ? "flex flex-col justify-between" : "flex flex-col lg:flex-row justify-between",
						children: [!c && /* @__PURE__ */ N("div", {
							className: "p-2 hidden lg:block",
							children: /* @__PURE__ */ N(Vp, {
								defaultViewing: A,
								startDate: y,
								endDate: x,
								minDate: r,
								maxDate: h,
								onSelect: F,
								onViewChange: j,
								siblingViewing: O,
								weekStartsOn: o
							})
						}), /* @__PURE__ */ N("div", {
							className: "p-2",
							children: /* @__PURE__ */ N(Vp, {
								defaultViewing: O,
								startDate: y,
								endDate: x,
								minDate: r,
								maxDate: h,
								onSelect: F,
								onViewChange: k,
								siblingViewing: v ? A : void 0,
								weekStartsOn: o
							})
						})]
					})]
				}), m && /* @__PURE__ */ N("div", {
					className: c ? "order-0 border-b border-border" : "order-0 lg:order-none lg:relative lg:border-l lg:border-border border-b border-border lg:border-b-0",
					children: /* @__PURE__ */ N(wa, {
						className: c ? "w-full" : "w-full lg:absolute lg:inset-0",
						children: /* @__PURE__ */ N("ul", {
							className: c ? "flex flex-row p-2 gap-px max-h-[320px]" : "flex flex-row lg:flex-col p-2 gap-px max-h-[320px]",
							children: p.map((e) => /* @__PURE__ */ N("li", {
								className: c ? void 0 : "lg:w-full",
								children: /* @__PURE__ */ N(J, {
									variant: "default",
									size: "sm",
									left: !0,
									className: c ? "whitespace-nowrap" : "whitespace-nowrap lg:w-full lg:justify-start",
									"aria-selected": C.id === e.id,
									"aria-label": `Choose ${e.name.toLowerCase()}`,
									title: e.name,
									onClick: () => z(e),
									"data-attr": `date-time-picker-quick-range-${e.name.toLowerCase().replace(/\s+/g, "-")}`,
									children: e.name
								})
							}, e.id))
						})
					})
				})]
			}),
			/* @__PURE__ */ N($e, {}),
			/* @__PURE__ */ P("div", {
				className: "flex justify-end px-3 py-2 items-center gap-2 bg-muted/30",
				children: [
					/* @__PURE__ */ N("span", {
						className: "text-[10px] text-muted-foreground flex items-center gap-1 tabular-nums mr-auto",
						children: C.id === Hp.id ? /* @__PURE__ */ P(M, { children: [
							ne,
							" ",
							/* @__PURE__ */ N(Od, { className: "size-3" }),
							" ",
							re
						] }) : C.name
					}),
					n ? /* @__PURE__ */ N(J, {
						variant: "outline",
						size: "sm",
						onClick: n,
						"aria-label": "Cancel",
						"data-attr": "date-time-picker-cancel",
						children: "Cancel"
					}) : null,
					/* @__PURE__ */ N(J, {
						variant: "primary",
						size: "sm",
						"aria-label": "Apply date range",
						title: "Apply date range",
						onClick: () => t({
							start: y,
							end: x,
							range: C
						}),
						"data-attr": "date-time-picker-apply-date-range",
						children: "Apply"
					})
				]
			})
		]
	});
}
var Qp = {
	MDY: "MM/dd/yy HH:mm",
	DMY: "dd/MM/yy HH:mm",
	YMD: "yy-MM-dd HH:mm"
}, $p = {
	MDY: "MM/dd/yy",
	DMY: "dd/MM/yy",
	YMD: "yy-MM-dd"
};
function em({ value: e, onApply: t, onCancel: n, minDate: r, maxDate: i, dateFormat: a = "MDY", weekStartsOn: o, onDateTimeSettings: s, showTime: c = !1, showTimeToggle: l = c, onIncludeTimeChange: u, className: d }) {
	let f = i ?? /* @__PURE__ */ new Date(), p = i !== void 0, [m, h] = w.useState(e), [g, _] = w.useState(c), [v, y] = w.useState(new Date(gp(e), hp(e), 1)), b = w.useId(), x = (e) => {
		let t = new Date(e.getFullYear(), e.getMonth(), e.getDate(), g ? pp(m) : 0, g ? mp(m) : 0);
		h(t);
	}, S = (e) => {
		let t = r && e.getTime() < r.getTime() ? r : e;
		t.getTime() !== m.getTime() && (h(t), y(new Date(gp(t), hp(t), 1)));
	}, C = (e) => {
		_(e), u?.(e);
	}, T = () => {
		t(g ? m : rf(m));
	}, E = cp(m, g ? Qp[a] : $p[a]);
	return /* @__PURE__ */ P("div", {
		className: q("bg-card text-foreground rounded-lg shadow-md ring-1 ring-foreground/10 overflow-hidden w-[15rem]", d),
		children: [
			/* @__PURE__ */ P("div", {
				className: "flex items-center gap-2 px-2 py-1 bg-muted/30 border-b border-border rounded-t-lg",
				children: [/* @__PURE__ */ N("span", {
					className: "text-[10px] text-muted-foreground uppercase tracking-wide",
					children: "Choose date"
				}), (r || p) && /* @__PURE__ */ P("div", {
					className: "flex items-center gap-1 ml-auto",
					children: [r && /* @__PURE__ */ P(Ct, {
						variant: "default",
						className: "text-[10px] px-1.5 py-0",
						children: ["Min: ", cp(r, "MMM d, yy")]
					}), p && /* @__PURE__ */ P(Ct, {
						variant: "default",
						className: "text-[10px] px-1.5 py-0",
						children: ["Max: ", cp(f, "MMM d, yy")]
					})]
				})]
			}),
			/* @__PURE__ */ N("div", {
				className: "flex justify-center items-center px-3 pt-3 pb-1",
				children: /* @__PURE__ */ P("div", {
					className: "flex items-center gap-1.5",
					children: [s && /* @__PURE__ */ N(J, {
						size: "icon-xs",
						onClick: s,
						"aria-label": "Date and time settings",
						title: "Date and time settings",
						className: "text-muted-foreground hover:text-foreground",
						children: /* @__PURE__ */ N(Pd, {})
					}), /* @__PURE__ */ N(Kp, {
						date: m,
						maxDate: f,
						onChange: S,
						dateFormat: a,
						showTime: g
					})]
				})
			}),
			/* @__PURE__ */ N("div", {
				className: "p-2 flex justify-center",
				children: /* @__PURE__ */ N(Vp, {
					defaultViewing: v,
					startDate: m,
					endDate: m,
					minDate: r,
					maxDate: f,
					onSelect: x,
					onViewChange: y,
					weekStartsOn: o
				})
			}),
			l && /* @__PURE__ */ P("div", {
				className: "flex items-center gap-2 px-3 py-1.5 border-t border-border",
				children: [/* @__PURE__ */ N(gl, {
					checked: g,
					onCheckedChange: C,
					"aria-label": "Include time",
					id: b,
					"data-attr": "date-picker-include-time"
				}), /* @__PURE__ */ N("label", {
					htmlFor: b,
					className: "text-xs text-muted-foreground select-none",
					children: "Include time"
				})]
			}),
			/* @__PURE__ */ N($e, {}),
			/* @__PURE__ */ P("div", {
				className: "flex justify-end px-3 py-2 items-center gap-2 bg-muted/30",
				children: [
					/* @__PURE__ */ N("span", {
						className: "text-[10px] text-muted-foreground tabular-nums mr-auto",
						children: E
					}),
					n ? /* @__PURE__ */ N(J, {
						variant: "outline",
						size: "sm",
						onClick: n,
						"aria-label": "Cancel",
						"data-attr": "date-picker-cancel",
						children: "Cancel"
					}) : null,
					/* @__PURE__ */ N(J, {
						variant: "primary",
						size: "sm",
						"aria-label": "Apply date",
						title: "Apply date",
						onClick: T,
						"data-attr": "date-picker-apply",
						children: "Apply"
					})
				]
			})
		]
	});
}
//#endregion
export { we as Accordion, De as AccordionContent, Te as AccordionItem, Ee as AccordionTrigger, Oe as AlertDialog, je as AlertDialogClose, Ne as AlertDialogContent, Fe as AlertDialogDescription, Le as AlertDialogFooter, Ie as AlertDialogHeader, Me as AlertDialogOverlay, Ae as AlertDialogPortal, Pe as AlertDialogTitle, ke as AlertDialogTrigger, nt as Autocomplete, at as AutocompleteClear, ft as AutocompleteCollection, st as AutocompleteContent, pt as AutocompleteEmpty, ut as AutocompleteGroup, ot as AutocompleteInput, lt as AutocompleteItem, dt as AutocompleteLabel, ct as AutocompleteList, mt as AutocompleteSeparator, gt as AutocompleteStatus, it as AutocompleteTrigger, rt as AutocompleteValue, vt as Avatar, bt as AvatarFallback, xt as AvatarGroup, yt as AvatarImage, Ct as Badge, J as Button, ai as ButtonGroup, si as ButtonGroupSeparator, oi as ButtonGroupText, Hp as CUSTOM_RANGE, ci as Card, fi as CardContent, di as CardDescription, pi as CardFooter, mi as CardGroup, li as CardHeader, ui as CardTitle, Et as ChatBubble, Dt as ChatBubbleContent, wt as ChatBubbleGroup, Ot as ChatBubbleReactions, Bt as ChatGlobe, Ut as ChatMarker, qt as ChatMarkerContent, Kt as ChatMarkerIcon, Jt as ChatMarkerValue, Xt as ChatMessage, Zt as ChatMessageAvatar, Qt as ChatMessageContent, en as ChatMessageFooter, Yt as ChatMessageGroup, $t as ChatMessageHeader, ar as ChatMessageScroller, lr as ChatMessageScrollerButton, sr as ChatMessageScrollerContent, cr as ChatMessageScrollerItem, ir as ChatMessageScrollerProvider, or as ChatMessageScrollerViewport, fr as ChatSource, dr as ChatSourceList, pr as ChatSourceTitle, mr as ChatSourceUrl, hr as ChatStream, gr as ChatStreamLine, kr as ChatTask, Ar as ChatTaskDetail, br as ChatTaskList, Or as ChatTaskListContent, Tr as ChatTaskListCount, wr as ChatTaskListLabel, Sr as ChatTaskListProgress, xr as ChatTaskListTrigger, yi as Checkbox, _i as CheckboxIndicator, bi as Chip, xi as ChipClose, Si as ChipGroup, wi as Collapsible, Di as CollapsibleContent, Ti as CollapsibleHeader, Ei as CollapsibleTrigger, ki as Combobox, Ui as ComboboxChip, Hi as ComboboxChips, Wi as ComboboxChipsInput, zi as ComboboxCollection, Pi as ComboboxContent, Bi as ComboboxEmpty, Li as ComboboxGroup, Ni as ComboboxInput, Ii as ComboboxItem, Ri as ComboboxLabel, Fi as ComboboxList, Gi as ComboboxListFooter, Vi as ComboboxSeparator, ji as ComboboxTrigger, Ai as ComboboxValue, ra as ContextMenu, pa as ContextMenuCheckboxItem, oa as ContextMenuContent, sa as ContextMenuGroup, la as ContextMenuItem, ca as ContextMenuLabel, ia as ContextMenuPortal, ma as ContextMenuRadioGroup, ha as ContextMenuRadioItem, ga as ContextMenuSeparator, _a as ContextMenuShortcut, ua as ContextMenuSub, fa as ContextMenuSubContent, da as ContextMenuSubTrigger, aa as ContextMenuTrigger, Rd as DataTable, em as DatePicker, Zp as DateTimePicker, Mp as Day, Ea as Dialog, Pa as DialogBody, ka as DialogClose, ja as DialogContent, Ia as DialogDescription, Na as DialogFooter, Ma as DialogHeader, Aa as DialogOverlay, Oa as DialogPortal, Fa as DialogTitle, Da as DialogTrigger, ue as DirectionProvider, Ra as Dot, za as Drawer, Ua as DrawerBackdrop, Ha as DrawerClose, Wa as DrawerContent, Ya as DrawerDescription, qa as DrawerFooter, Ga as DrawerHandle, Ka as DrawerHeader, Va as DrawerPortal, Ja as DrawerTitle, Ba as DrawerTrigger, Xa as DropdownMenu, oo as DropdownMenuCheckboxItem, $a as DropdownMenuContent, eo as DropdownMenuGroup, no as DropdownMenuItem, to as DropdownMenuLabel, Za as DropdownMenuPortal, so as DropdownMenuRadioGroup, co as DropdownMenuRadioItem, fo as DropdownMenuSelectAll, lo as DropdownMenuSeparator, po as DropdownMenuShortcut, ro as DropdownMenuSub, ao as DropdownMenuSubContent, io as DropdownMenuSubTrigger, Qa as DropdownMenuTrigger, mo as Empty, bo as EmptyContent, yo as EmptyDescription, ho as EmptyHeader, _o as EmptyMedia, vo as EmptyTitle, Eo as Field, Do as FieldContent, Ao as FieldDescription, Mo as FieldError, wo as FieldGroup, Oo as FieldLabel, Co as FieldLegend, jo as FieldSeparator, So as FieldSet, ko as FieldTitle, Po as Heading, Be as Input, He as InputGroup, We as InputGroupAddon, Ke as InputGroupButton, Je as InputGroupInput, Xe as InputGroupNumberInput, qe as InputGroupText, Ye as InputGroupTextarea, Go as Item, ts as ItemActions, qo as ItemCheckbox, Qo as ItemContent, es as ItemDescription, rs as ItemFooter, Ho as ItemGroup, ns as ItemHeader, Xo as ItemMedia, Ko as ItemMenuItem, Jo as ItemRadio, Uo as ItemSeparator, $o as ItemTitle, qi as Kbd, Yi as KbdGroup, Ji as KbdText, xo as Label, Qe as MenuLabel, is as Menubar, ds as MenubarCheckboxItem, ls as MenubarContent, os as MenubarGroup, us as MenubarItem, ms as MenubarLabel, as as MenubarMenu, ss as MenubarPortal, fs as MenubarRadioGroup, ps as MenubarRadioItem, hs as MenubarSeparator, gs as MenubarShortcut, _s as MenubarSub, ys as MenubarSubContent, vs as MenubarSubTrigger, cs as MenubarTrigger, jp as Month, zo as NumberFieldDecrement, Io as NumberFieldGroup, Ro as NumberFieldIncrement, Lo as NumberFieldInput, Fo as NumberFieldRoot, Bo as NumberFieldScrubArea, Vo as NumberFieldScrubAreaCursor, bs as Pagination, Cs as PaginationButton, xs as PaginationContent, Es as PaginationEllipsis, Ss as PaginationItem, Ts as PaginationNext, ws as PaginationPrevious, Os as Popover, As as PopoverArrow, js as PopoverContent, ks as PopoverTrigger, Ns as Progress, Fs as ProgressIndicator, Is as ProgressLabel, Ps as ProgressTrack, Ls as ProgressValue, Dc as Questionnaire, Lc as QuestionnaireActions, Nc as QuestionnaireChoice, Pc as QuestionnaireChoiceDescription, Mc as QuestionnaireChoices, jc as QuestionnaireDescription, Ic as QuestionnaireError, Fc as QuestionnaireInput, kc as QuestionnaireItem, Bc as QuestionnaireNext, Rc as QuestionnairePrevious, Oc as QuestionnaireProgress, zc as QuestionnaireSkip, Vc as QuestionnaireSubmit, Ac as QuestionnaireTitle, $i as RadioGroup, na as RadioGroupItem, Qi as RadioIndicator, Wc as ResizableHandle, Uc as ResizablePanel, Hc as ResizablePanelGroup, Sa as SCROLL_SHADOWS_STYLE_ID, wa as ScrollArea, Ta as ScrollBar, Gc as Select, Xc as SelectContent, Kc as SelectGroup, Zc as SelectGroupLabel, Qc as SelectItem, $c as SelectSeparator, Yc as SelectTrigger, Jc as SelectTriggerIcon, qc as SelectValue, $e as Separator, nl as Skeleton, rl as SkeletonText, il as Slider, Re as Spinner, gl as Switch, yl as Table, xl as TableBody, Dl as TableCaption, Tl as TableCell, El as TableEmpty, Sl as TableFooter, wl as TableHead, bl as TableHeader, Cl as TableRow, Ol as Tabs, Nl as TabsContent, jl as TabsList, Ml as TabsTrigger, Fl as Text, Ve as Textarea, Jl as ThemeProvider, Ir as ThreadItem, ei as ThreadItemAction, $r as ThreadItemActions, Gr as ThreadItemAttachment, qr as ThreadItemAttachmentContent, Jr as ThreadItemAttachmentImage, Kr as ThreadItemAttachmentTrigger, Br as ThreadItemAuthor, Hr as ThreadItemBody, Rr as ThreadItemContent, Fr as ThreadItemGroup, Lr as ThreadItemGutter, zr as ThreadItemHeader, Wr as ThreadItemLink, Ur as ThreadItemMention, Xr as ThreadItemReaction, Zr as ThreadItemReactionEmoji, Yr as ThreadItemReactions, ti as ThreadItemReplies, ni as ThreadItemRepliesLabel, ri as ThreadItemRepliesMeta, Vr as ThreadItemTimestamp, cl as ToastCard, ul as ToastProvider, Ll as Toggle, zl as ToggleGroup, Bl as ToggleGroupItem, Mr as Tooltip, Pr as TooltipContent, jr as TooltipProvider, Nr as TooltipTrigger, hl as anchoredToast, ol as anchoredToastManager, St as badgeVariants, Tt as bubbleVariants, ii as buttonGroupVariants, ze as buttonVariants, q as cn, La as dotVariants, Ds as getPaginationRange, No as headingVariants, Vt as markerVariants, Ms as progressIndicatorVariants, Up as quickRanges, Ca as scrollShadowsCss, Pl as textVariants, ml as toast, al as toastManager, Il as toggleVariants, _t as useAutocompleteAnchor, Fp as useCalendar, Jn as useChatMessageScroller, Yn as useChatMessageScrollerScrollable, Xn as useChatMessageScrollerVisibility, Ki as useComboboxAnchor, de as useDirection, uo as useDropdownMenuSelectAll, Yl as useTheme };
